// Generated by scripts/generate-runtime-validators.mjs. Do not edit.
import ucs2lengthRuntime from "ajv/dist/runtime/ucs2length.js";
import equalRuntime from "ajv/dist/runtime/equal.js";
import formatsRuntime from "ajv-formats/dist/formats.js";

"use strict";
export const client = validate20;
const schema31 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/explorer-client-request.v1.schema.json","type":"object","additionalProperties":false,"required":["contractVersion","profileId","requestId","operation","input"],"properties":{"contractVersion":{"const":"explorer.v1"},"profileId":{"enum":["datahike-s3","datahike-dynamodb","datomic-dynamodb","datalevin-memory","jank-memory","datascript-browser-memory"]},"requestId":{"type":"string","minLength":1,"maxLength":128},"operation":{"enum":["health","bootstrap","list-subjects","get-object","list-relationships","reverse-relationships","check-permission","lookup-resources","lookup-subjects","count-resources","get-schema","get-cache-info","count-objects"]},"input":{"type":"object","maxProperties":32}}};
const func1 = ucs2lengthRuntime.default;

function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/explorer-client-request.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate20.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.contractVersion === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contractVersion"},message:"must have required property '"+"contractVersion"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.profileId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profileId"},message:"must have required property '"+"profileId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operation === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operation"},message:"must have required property '"+"operation"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.input === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "input"},message:"must have required property '"+"input"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "contractVersion") || (key0 === "profileId")) || (key0 === "requestId")) || (key0 === "operation")) || (key0 === "input"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.contractVersion !== undefined){
if("explorer.v1" !== data.contractVersion){
const err6 = {instancePath:instancePath+"/contractVersion",schemaPath:"#/properties/contractVersion/const",keyword:"const",params:{allowedValue: "explorer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.profileId !== undefined){
let data1 = data.profileId;
if(!((((((data1 === "datahike-s3") || (data1 === "datahike-dynamodb")) || (data1 === "datomic-dynamodb")) || (data1 === "datalevin-memory")) || (data1 === "jank-memory")) || (data1 === "datascript-browser-memory"))){
const err7 = {instancePath:instancePath+"/profileId",schemaPath:"#/properties/profileId/enum",keyword:"enum",params:{allowedValues: schema31.properties.profileId.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.requestId !== undefined){
let data2 = data.requestId;
if(typeof data2 === "string"){
if(func1(data2) > 128){
const err8 = {instancePath:instancePath+"/requestId",schemaPath:"#/properties/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func1(data2) < 1){
const err9 = {instancePath:instancePath+"/requestId",schemaPath:"#/properties/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/requestId",schemaPath:"#/properties/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.operation !== undefined){
let data3 = data.operation;
if(!(((((((((((((data3 === "health") || (data3 === "bootstrap")) || (data3 === "list-subjects")) || (data3 === "get-object")) || (data3 === "list-relationships")) || (data3 === "reverse-relationships")) || (data3 === "check-permission")) || (data3 === "lookup-resources")) || (data3 === "lookup-subjects")) || (data3 === "count-resources")) || (data3 === "get-schema")) || (data3 === "get-cache-info")) || (data3 === "count-objects"))){
const err11 = {instancePath:instancePath+"/operation",schemaPath:"#/properties/operation/enum",keyword:"enum",params:{allowedValues: schema31.properties.operation.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.input !== undefined){
let data4 = data.input;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(Object.keys(data4).length > 32){
const err12 = {instancePath:instancePath+"/input",schemaPath:"#/properties/input/maxProperties",keyword:"maxProperties",params:{limit: 32},message:"must NOT have more than 32 properties"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/input",schemaPath:"#/properties/input/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate20.errors = vErrors;
return errors === 0;
}
validate20.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const server = validate21;
const schema32 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/explorer-response.v1.schema.json","oneOf":[{"$ref":"explorer.v1.schema.json#/$defs/success"},{"$ref":"explorer.v1.schema.json#/$defs/failure"}]};
const schema34 = {"type":"object","additionalProperties":false,"required":["meta","data"],"properties":{"meta":{"$ref":"#/$defs/responseMeta"},"data":{"anyOf":[{"$ref":"#/$defs/health"},{"$ref":"#/$defs/bootstrap"},{"$ref":"#/$defs/objectPage"},{"$ref":"#/$defs/objectResult"},{"$ref":"#/$defs/relationshipPage"},{"$ref":"#/$defs/permissionDecision"},{"$ref":"#/$defs/count"},{"$ref":"#/$defs/schema"},{"$ref":"#/$defs/cacheInfo"}]}}};
const schema35 = {"type":"object","additionalProperties":false,"required":["revision","requestId"],"properties":{"revision":{"type":"string","minLength":1,"maxLength":256},"requestId":{"type":"string","minLength":1,"maxLength":128},"elapsedMs":{"type":"number","minimum":0},"cacheStatus":{"enum":["hit","miss","disabled"]}}};
const schema64 = {"type":"object","additionalProperties":false,"required":["allowed"],"properties":{"allowed":{"type":"boolean"}}};
const schema65 = {"type":"object","additionalProperties":false,"required":["kind","value","exact","ceiling"],"properties":{"kind":{"enum":["subjects","objects","relationships"]},"value":{"type":"integer","minimum":0},"exact":{"type":"boolean"},"ceiling":{"type":["integer","null"],"minimum":1}}};
const schema75 = {"type":"object","additionalProperties":false,"required":["behavior","hit","scope","entries","limitations"],"properties":{"behavior":{"enum":["none","request-local","environment-local","browser-page-local","shared-read-through"]},"hit":{"type":["boolean","null"]},"scope":{"type":"string","minLength":1,"maxLength":128},"entries":{"type":["integer","null"],"minimum":0},"limitations":{"type":"array","maxItems":16,"uniqueItems":true,"items":{"type":"string","maxLength":256}}}};
const schema36 = {"type":"object","additionalProperties":false,"required":["status","ready","identity","basis"],"properties":{"status":{"enum":["ready","starting","degraded","unavailable"]},"ready":{"type":"boolean"},"identity":{"$ref":"#/$defs/identity"},"basis":{"anyOf":[{"$ref":"#/$defs/basis"},{"type":"null"}]}}};
const schema42 = {"type":"object","additionalProperties":false,"required":["behavior","id","capturedAt","fixedForEnvironment"],"properties":{"behavior":{"enum":["fixed-environment","request-snapshot","page-lifecycle","rebuild-lifecycle"]},"id":{"type":"string","minLength":1,"maxLength":256},"capturedAt":{"type":"string","format":"date-time"},"fixedForEnvironment":{"type":"boolean"}}};
const schema37 = {"type":"object","additionalProperties":false,"required":["profileId","demoSha","eaclSha","artifactSha256","deploymentId","dataManifestSha256"],"properties":{"profileId":{"type":"string","pattern":"^[a-z0-9]+(?:-[a-z0-9]+)*$"},"demoSha":{"$ref":"#/$defs/sha1"},"eaclSha":{"$ref":"#/$defs/sha1"},"artifactSha256":{"$ref":"#/$defs/sha256"},"deploymentId":{"type":"string","minLength":1,"maxLength":256},"dataManifestSha256":{"$ref":"#/$defs/sha256"}}};
const schema38 = {"type":"string","pattern":"^[0-9a-f]{40}$"};
const schema40 = {"type":"string","pattern":"^[0-9a-f]{64}$"};
const pattern4 = new RegExp("^[a-z0-9]+(?:-[a-z0-9]+)*$", "u");
const pattern5 = new RegExp("^[0-9a-f]{40}$", "u");
const pattern7 = new RegExp("^[0-9a-f]{64}$", "u");

function validate25(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate25.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.profileId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profileId"},message:"must have required property '"+"profileId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.demoSha === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "demoSha"},message:"must have required property '"+"demoSha"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.eaclSha === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "eaclSha"},message:"must have required property '"+"eaclSha"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.artifactSha256 === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifactSha256"},message:"must have required property '"+"artifactSha256"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.deploymentId === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "deploymentId"},message:"must have required property '"+"deploymentId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.dataManifestSha256 === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dataManifestSha256"},message:"must have required property '"+"dataManifestSha256"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "profileId") || (key0 === "demoSha")) || (key0 === "eaclSha")) || (key0 === "artifactSha256")) || (key0 === "deploymentId")) || (key0 === "dataManifestSha256"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.profileId !== undefined){
let data0 = data.profileId;
if(typeof data0 === "string"){
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/profileId",schemaPath:"#/properties/profileId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/profileId",schemaPath:"#/properties/profileId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.demoSha !== undefined){
let data1 = data.demoSha;
if(typeof data1 === "string"){
if(!pattern5.test(data1)){
const err9 = {instancePath:instancePath+"/demoSha",schemaPath:"#/$defs/sha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/demoSha",schemaPath:"#/$defs/sha1/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.eaclSha !== undefined){
let data2 = data.eaclSha;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err11 = {instancePath:instancePath+"/eaclSha",schemaPath:"#/$defs/sha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/eaclSha",schemaPath:"#/$defs/sha1/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.artifactSha256 !== undefined){
let data3 = data.artifactSha256;
if(typeof data3 === "string"){
if(!pattern7.test(data3)){
const err13 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.deploymentId !== undefined){
let data4 = data.deploymentId;
if(typeof data4 === "string"){
if(func1(data4) > 256){
const err15 = {instancePath:instancePath+"/deploymentId",schemaPath:"#/properties/deploymentId/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(func1(data4) < 1){
const err16 = {instancePath:instancePath+"/deploymentId",schemaPath:"#/properties/deploymentId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/deploymentId",schemaPath:"#/properties/deploymentId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.dataManifestSha256 !== undefined){
let data5 = data.dataManifestSha256;
if(typeof data5 === "string"){
if(!pattern7.test(data5)){
const err18 = {instancePath:instancePath+"/dataManifestSha256",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/dataManifestSha256",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
validate25.errors = vErrors;
return errors === 0;
}
validate25.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const formats0 = formatsRuntime.fullFormats["date-time"];

function validate24(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate24.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.status === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.ready === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ready"},message:"must have required property '"+"ready"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.identity === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "identity"},message:"must have required property '"+"identity"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.basis === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "basis"},message:"must have required property '"+"basis"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "status") || (key0 === "ready")) || (key0 === "identity")) || (key0 === "basis"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.status !== undefined){
let data0 = data.status;
if(!((((data0 === "ready") || (data0 === "starting")) || (data0 === "degraded")) || (data0 === "unavailable"))){
const err5 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema36.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.ready !== undefined){
if(typeof data.ready !== "boolean"){
const err6 = {instancePath:instancePath+"/ready",schemaPath:"#/properties/ready/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.identity !== undefined){
if(!(validate25(data.identity, {instancePath:instancePath+"/identity",parentData:data,parentDataProperty:"identity",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
errors = vErrors.length;
}
}
if(data.basis !== undefined){
let data3 = data.basis;
const _errs7 = errors;
let valid1 = false;
const _errs8 = errors;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.behavior === undefined){
const err7 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "behavior"},message:"must have required property '"+"behavior"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data3.id === undefined){
const err8 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data3.capturedAt === undefined){
const err9 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "capturedAt"},message:"must have required property '"+"capturedAt"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data3.fixedForEnvironment === undefined){
const err10 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "fixedForEnvironment"},message:"must have required property '"+"fixedForEnvironment"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
for(const key1 in data3){
if(!((((key1 === "behavior") || (key1 === "id")) || (key1 === "capturedAt")) || (key1 === "fixedForEnvironment"))){
const err11 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data3.behavior !== undefined){
let data4 = data3.behavior;
if(!((((data4 === "fixed-environment") || (data4 === "request-snapshot")) || (data4 === "page-lifecycle")) || (data4 === "rebuild-lifecycle"))){
const err12 = {instancePath:instancePath+"/basis/behavior",schemaPath:"#/$defs/basis/properties/behavior/enum",keyword:"enum",params:{allowedValues: schema42.properties.behavior.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data3.id !== undefined){
let data5 = data3.id;
if(typeof data5 === "string"){
if(func1(data5) > 256){
const err13 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func1(data5) < 1){
const err14 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data3.capturedAt !== undefined){
let data6 = data3.capturedAt;
if(typeof data6 === "string"){
if(!(formats0.validate(data6))){
const err16 = {instancePath:instancePath+"/basis/capturedAt",schemaPath:"#/$defs/basis/properties/capturedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/basis/capturedAt",schemaPath:"#/$defs/basis/properties/capturedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data3.fixedForEnvironment !== undefined){
if(typeof data3.fixedForEnvironment !== "boolean"){
const err18 = {instancePath:instancePath+"/basis/fixedForEnvironment",schemaPath:"#/$defs/basis/properties/fixedForEnvironment/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid0 = _errs8 === errors;
valid1 = valid1 || _valid0;
const _errs19 = errors;
if(data3 !== null){
const err20 = {instancePath:instancePath+"/basis",schemaPath:"#/properties/basis/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
var _valid0 = _errs19 === errors;
valid1 = valid1 || _valid0;
if(!valid1){
const err21 = {instancePath:instancePath+"/basis",schemaPath:"#/properties/basis/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
else {
errors = _errs7;
if(vErrors !== null){
if(_errs7){
vErrors.length = _errs7;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err22 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
validate24.errors = vErrors;
return errors === 0;
}
validate24.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema43 = {"type":"object","additionalProperties":false,"required":["contract","identity","profile","runtime","capabilities","limits","dataset","basis"],"properties":{"contract":{"type":"object","additionalProperties":false,"required":["name","routeMajor","revision","minimumClientRevision"],"properties":{"name":{"const":"explorer.v1"},"routeMajor":{"const":1},"revision":{"type":"integer","minimum":0},"minimumClientRevision":{"type":"integer","minimum":0}}},"identity":{"$ref":"#/$defs/identity"},"profile":{"type":"object","additionalProperties":false,"required":["backend","storage"],"properties":{"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"storage":{"enum":["s3","dynamodb","memory","browser-memory"]}}},"runtime":{"type":"object","additionalProperties":false,"required":["execution","name","architecture","snapStart"],"properties":{"execution":{"enum":["lambda","ec2","browser"]},"name":{"type":"string","minLength":1,"maxLength":64},"architecture":{"enum":["arm64","x86_64","wasm32","javascript"]},"snapStart":{"enum":["enabled","disabled","not-applicable"]}}},"capabilities":{"type":"object","additionalProperties":false,"required":["operations","consistencyModes","snapshotBehavior","cacheBehavior","mutationLocality","limitations"],"properties":{"operations":{"type":"array","minItems":1,"maxItems":13,"uniqueItems":true,"items":{"enum":["health","bootstrap","list-subjects","get-object","list-relationships","reverse-relationships","check-permission","lookup-resources","lookup-subjects","count-resources","get-schema","get-cache-info","count-objects"]}},"consistencyModes":{"type":"array","minItems":1,"maxItems":6,"uniqueItems":true,"items":{"enum":["minimize","authoritative","at-least","exact","historical-date"]}},"snapshotBehavior":{"enum":["fixed-environment","request-snapshot","page-lifecycle","rebuild-lifecycle"]},"cacheBehavior":{"enum":["none","request-local","environment-local","browser-page-local","shared-read-through"]},"mutationLocality":{"enum":["none","private-seed-workflow","initialization-before-ready","browser-initialization"]},"limitations":{"type":"array","maxItems":16,"uniqueItems":true,"items":{"enum":["read-only","fixed-current-snapshot","no-synchronization","no-history-api","ephemeral","browser-local","no-durability","datomic-like-not-datomic-pro","no-datalog-api","no-distribution","not-production-database","unequal-dataset-scale","no-snapstart","eventual-storage-read","lifecycle-rebuild","unsupported-consistency"]}}}},"limits":{"type":"array","minItems":1,"maxItems":32,"items":{"type":"object","additionalProperties":false,"required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"integer","minimum":0}}}},"dataset":{"type":"object","additionalProperties":false,"required":["fixtureId","logicalResourceCount","serverCount","manifestSha256"],"properties":{"fixtureId":{"type":"string"},"logicalResourceCount":{"type":"integer","minimum":1},"serverCount":{"type":"integer","minimum":1},"manifestSha256":{"$ref":"#/$defs/sha256"}}},"basis":{"$ref":"#/$defs/basis"}}};
const func0 = equalRuntime.default;

function validate28(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate28.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.contract === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contract"},message:"must have required property '"+"contract"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.identity === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "identity"},message:"must have required property '"+"identity"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.profile === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.runtime === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runtime"},message:"must have required property '"+"runtime"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.capabilities === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.limits === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "limits"},message:"must have required property '"+"limits"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.dataset === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dataset"},message:"must have required property '"+"dataset"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.basis === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "basis"},message:"must have required property '"+"basis"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "contract") || (key0 === "identity")) || (key0 === "profile")) || (key0 === "runtime")) || (key0 === "capabilities")) || (key0 === "limits")) || (key0 === "dataset")) || (key0 === "basis"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.contract !== undefined){
let data0 = data.contract;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.name === undefined){
const err9 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data0.routeMajor === undefined){
const err10 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/required",keyword:"required",params:{missingProperty: "routeMajor"},message:"must have required property '"+"routeMajor"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data0.revision === undefined){
const err11 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data0.minimumClientRevision === undefined){
const err12 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/required",keyword:"required",params:{missingProperty: "minimumClientRevision"},message:"must have required property '"+"minimumClientRevision"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data0){
if(!((((key1 === "name") || (key1 === "routeMajor")) || (key1 === "revision")) || (key1 === "minimumClientRevision"))){
const err13 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data0.name !== undefined){
if("explorer.v1" !== data0.name){
const err14 = {instancePath:instancePath+"/contract/name",schemaPath:"#/properties/contract/properties/name/const",keyword:"const",params:{allowedValue: "explorer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data0.routeMajor !== undefined){
if(1 !== data0.routeMajor){
const err15 = {instancePath:instancePath+"/contract/routeMajor",schemaPath:"#/properties/contract/properties/routeMajor/const",keyword:"const",params:{allowedValue: 1},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data0.revision !== undefined){
let data3 = data0.revision;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err16 = {instancePath:instancePath+"/contract/revision",schemaPath:"#/properties/contract/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 < 0 || isNaN(data3)){
const err17 = {instancePath:instancePath+"/contract/revision",schemaPath:"#/properties/contract/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
if(data0.minimumClientRevision !== undefined){
let data4 = data0.minimumClientRevision;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err18 = {instancePath:instancePath+"/contract/minimumClientRevision",schemaPath:"#/properties/contract/properties/minimumClientRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err19 = {instancePath:instancePath+"/contract/minimumClientRevision",schemaPath:"#/properties/contract/properties/minimumClientRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
}
else {
const err20 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.identity !== undefined){
if(!(validate25(data.identity, {instancePath:instancePath+"/identity",parentData:data,parentDataProperty:"identity",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
errors = vErrors.length;
}
}
if(data.profile !== undefined){
let data6 = data.profile;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.backend === undefined){
const err21 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data6.storage === undefined){
const err22 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/required",keyword:"required",params:{missingProperty: "storage"},message:"must have required property '"+"storage"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
for(const key2 in data6){
if(!((key2 === "backend") || (key2 === "storage"))){
const err23 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data6.backend !== undefined){
let data7 = data6.backend;
if(!(((((data7 === "datahike") || (data7 === "datomic")) || (data7 === "datalevin")) || (data7 === "jank")) || (data7 === "datascript"))){
const err24 = {instancePath:instancePath+"/profile/backend",schemaPath:"#/properties/profile/properties/backend/enum",keyword:"enum",params:{allowedValues: schema43.properties.profile.properties.backend.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data6.storage !== undefined){
let data8 = data6.storage;
if(!((((data8 === "s3") || (data8 === "dynamodb")) || (data8 === "memory")) || (data8 === "browser-memory"))){
const err25 = {instancePath:instancePath+"/profile/storage",schemaPath:"#/properties/profile/properties/storage/enum",keyword:"enum",params:{allowedValues: schema43.properties.profile.properties.storage.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
else {
const err26 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.runtime !== undefined){
let data9 = data.runtime;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(data9.execution === undefined){
const err27 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/required",keyword:"required",params:{missingProperty: "execution"},message:"must have required property '"+"execution"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data9.name === undefined){
const err28 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data9.architecture === undefined){
const err29 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/required",keyword:"required",params:{missingProperty: "architecture"},message:"must have required property '"+"architecture"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data9.snapStart === undefined){
const err30 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/required",keyword:"required",params:{missingProperty: "snapStart"},message:"must have required property '"+"snapStart"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
for(const key3 in data9){
if(!((((key3 === "execution") || (key3 === "name")) || (key3 === "architecture")) || (key3 === "snapStart"))){
const err31 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data9.execution !== undefined){
let data10 = data9.execution;
if(!(((data10 === "lambda") || (data10 === "ec2")) || (data10 === "browser"))){
const err32 = {instancePath:instancePath+"/runtime/execution",schemaPath:"#/properties/runtime/properties/execution/enum",keyword:"enum",params:{allowedValues: schema43.properties.runtime.properties.execution.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data9.name !== undefined){
let data11 = data9.name;
if(typeof data11 === "string"){
if(func1(data11) > 64){
const err33 = {instancePath:instancePath+"/runtime/name",schemaPath:"#/properties/runtime/properties/name/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(func1(data11) < 1){
const err34 = {instancePath:instancePath+"/runtime/name",schemaPath:"#/properties/runtime/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/runtime/name",schemaPath:"#/properties/runtime/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data9.architecture !== undefined){
let data12 = data9.architecture;
if(!((((data12 === "arm64") || (data12 === "x86_64")) || (data12 === "wasm32")) || (data12 === "javascript"))){
const err36 = {instancePath:instancePath+"/runtime/architecture",schemaPath:"#/properties/runtime/properties/architecture/enum",keyword:"enum",params:{allowedValues: schema43.properties.runtime.properties.architecture.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data9.snapStart !== undefined){
let data13 = data9.snapStart;
if(!(((data13 === "enabled") || (data13 === "disabled")) || (data13 === "not-applicable"))){
const err37 = {instancePath:instancePath+"/runtime/snapStart",schemaPath:"#/properties/runtime/properties/snapStart/enum",keyword:"enum",params:{allowedValues: schema43.properties.runtime.properties.snapStart.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
else {
const err38 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.capabilities !== undefined){
let data14 = data.capabilities;
if(data14 && typeof data14 == "object" && !Array.isArray(data14)){
if(data14.operations === undefined){
const err39 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "operations"},message:"must have required property '"+"operations"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data14.consistencyModes === undefined){
const err40 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "consistencyModes"},message:"must have required property '"+"consistencyModes"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data14.snapshotBehavior === undefined){
const err41 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "snapshotBehavior"},message:"must have required property '"+"snapshotBehavior"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data14.cacheBehavior === undefined){
const err42 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "cacheBehavior"},message:"must have required property '"+"cacheBehavior"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data14.mutationLocality === undefined){
const err43 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "mutationLocality"},message:"must have required property '"+"mutationLocality"+"'"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if(data14.limitations === undefined){
const err44 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "limitations"},message:"must have required property '"+"limitations"+"'"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
for(const key4 in data14){
if(!((((((key4 === "operations") || (key4 === "consistencyModes")) || (key4 === "snapshotBehavior")) || (key4 === "cacheBehavior")) || (key4 === "mutationLocality")) || (key4 === "limitations"))){
const err45 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key4},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data14.operations !== undefined){
let data15 = data14.operations;
if(Array.isArray(data15)){
if(data15.length > 13){
const err46 = {instancePath:instancePath+"/capabilities/operations",schemaPath:"#/properties/capabilities/properties/operations/maxItems",keyword:"maxItems",params:{limit: 13},message:"must NOT have more than 13 items"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
if(data15.length < 1){
const err47 = {instancePath:instancePath+"/capabilities/operations",schemaPath:"#/properties/capabilities/properties/operations/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
const len0 = data15.length;
for(let i0=0; i0<len0; i0++){
let data16 = data15[i0];
if(!(((((((((((((data16 === "health") || (data16 === "bootstrap")) || (data16 === "list-subjects")) || (data16 === "get-object")) || (data16 === "list-relationships")) || (data16 === "reverse-relationships")) || (data16 === "check-permission")) || (data16 === "lookup-resources")) || (data16 === "lookup-subjects")) || (data16 === "count-resources")) || (data16 === "get-schema")) || (data16 === "get-cache-info")) || (data16 === "count-objects"))){
const err48 = {instancePath:instancePath+"/capabilities/operations/" + i0,schemaPath:"#/properties/capabilities/properties/operations/items/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.operations.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
let i1 = data15.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data15[i1], data15[j0])){
const err49 = {instancePath:instancePath+"/capabilities/operations",schemaPath:"#/properties/capabilities/properties/operations/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err50 = {instancePath:instancePath+"/capabilities/operations",schemaPath:"#/properties/capabilities/properties/operations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data14.consistencyModes !== undefined){
let data17 = data14.consistencyModes;
if(Array.isArray(data17)){
if(data17.length > 6){
const err51 = {instancePath:instancePath+"/capabilities/consistencyModes",schemaPath:"#/properties/capabilities/properties/consistencyModes/maxItems",keyword:"maxItems",params:{limit: 6},message:"must NOT have more than 6 items"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
if(data17.length < 1){
const err52 = {instancePath:instancePath+"/capabilities/consistencyModes",schemaPath:"#/properties/capabilities/properties/consistencyModes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
const len1 = data17.length;
for(let i2=0; i2<len1; i2++){
let data18 = data17[i2];
if(!(((((data18 === "minimize") || (data18 === "authoritative")) || (data18 === "at-least")) || (data18 === "exact")) || (data18 === "historical-date"))){
const err53 = {instancePath:instancePath+"/capabilities/consistencyModes/" + i2,schemaPath:"#/properties/capabilities/properties/consistencyModes/items/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.consistencyModes.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
let i3 = data17.length;
let j1;
if(i3 > 1){
outer1:
for(;i3--;){
for(j1 = i3; j1--;){
if(func0(data17[i3], data17[j1])){
const err54 = {instancePath:instancePath+"/capabilities/consistencyModes",schemaPath:"#/properties/capabilities/properties/consistencyModes/uniqueItems",keyword:"uniqueItems",params:{i: i3, j: j1},message:"must NOT have duplicate items (items ## "+j1+" and "+i3+" are identical)"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
break outer1;
}
}
}
}
}
else {
const err55 = {instancePath:instancePath+"/capabilities/consistencyModes",schemaPath:"#/properties/capabilities/properties/consistencyModes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
if(data14.snapshotBehavior !== undefined){
let data19 = data14.snapshotBehavior;
if(!((((data19 === "fixed-environment") || (data19 === "request-snapshot")) || (data19 === "page-lifecycle")) || (data19 === "rebuild-lifecycle"))){
const err56 = {instancePath:instancePath+"/capabilities/snapshotBehavior",schemaPath:"#/properties/capabilities/properties/snapshotBehavior/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.snapshotBehavior.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
if(data14.cacheBehavior !== undefined){
let data20 = data14.cacheBehavior;
if(!(((((data20 === "none") || (data20 === "request-local")) || (data20 === "environment-local")) || (data20 === "browser-page-local")) || (data20 === "shared-read-through"))){
const err57 = {instancePath:instancePath+"/capabilities/cacheBehavior",schemaPath:"#/properties/capabilities/properties/cacheBehavior/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.cacheBehavior.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
if(data14.mutationLocality !== undefined){
let data21 = data14.mutationLocality;
if(!((((data21 === "none") || (data21 === "private-seed-workflow")) || (data21 === "initialization-before-ready")) || (data21 === "browser-initialization"))){
const err58 = {instancePath:instancePath+"/capabilities/mutationLocality",schemaPath:"#/properties/capabilities/properties/mutationLocality/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.mutationLocality.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
if(data14.limitations !== undefined){
let data22 = data14.limitations;
if(Array.isArray(data22)){
if(data22.length > 16){
const err59 = {instancePath:instancePath+"/capabilities/limitations",schemaPath:"#/properties/capabilities/properties/limitations/maxItems",keyword:"maxItems",params:{limit: 16},message:"must NOT have more than 16 items"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
const len2 = data22.length;
for(let i4=0; i4<len2; i4++){
let data23 = data22[i4];
if(!((((((((((((((((data23 === "read-only") || (data23 === "fixed-current-snapshot")) || (data23 === "no-synchronization")) || (data23 === "no-history-api")) || (data23 === "ephemeral")) || (data23 === "browser-local")) || (data23 === "no-durability")) || (data23 === "datomic-like-not-datomic-pro")) || (data23 === "no-datalog-api")) || (data23 === "no-distribution")) || (data23 === "not-production-database")) || (data23 === "unequal-dataset-scale")) || (data23 === "no-snapstart")) || (data23 === "eventual-storage-read")) || (data23 === "lifecycle-rebuild")) || (data23 === "unsupported-consistency"))){
const err60 = {instancePath:instancePath+"/capabilities/limitations/" + i4,schemaPath:"#/properties/capabilities/properties/limitations/items/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.limitations.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
let i5 = data22.length;
let j2;
if(i5 > 1){
outer2:
for(;i5--;){
for(j2 = i5; j2--;){
if(func0(data22[i5], data22[j2])){
const err61 = {instancePath:instancePath+"/capabilities/limitations",schemaPath:"#/properties/capabilities/properties/limitations/uniqueItems",keyword:"uniqueItems",params:{i: i5, j: j2},message:"must NOT have duplicate items (items ## "+j2+" and "+i5+" are identical)"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
break outer2;
}
}
}
}
}
else {
const err62 = {instancePath:instancePath+"/capabilities/limitations",schemaPath:"#/properties/capabilities/properties/limitations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
}
}
else {
const err63 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
if(data.limits !== undefined){
let data24 = data.limits;
if(Array.isArray(data24)){
if(data24.length > 32){
const err64 = {instancePath:instancePath+"/limits",schemaPath:"#/properties/limits/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
if(data24.length < 1){
const err65 = {instancePath:instancePath+"/limits",schemaPath:"#/properties/limits/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
const len3 = data24.length;
for(let i6=0; i6<len3; i6++){
let data25 = data24[i6];
if(data25 && typeof data25 == "object" && !Array.isArray(data25)){
if(data25.name === undefined){
const err66 = {instancePath:instancePath+"/limits/" + i6,schemaPath:"#/properties/limits/items/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
if(data25.value === undefined){
const err67 = {instancePath:instancePath+"/limits/" + i6,schemaPath:"#/properties/limits/items/required",keyword:"required",params:{missingProperty: "value"},message:"must have required property '"+"value"+"'"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
for(const key5 in data25){
if(!((key5 === "name") || (key5 === "value"))){
const err68 = {instancePath:instancePath+"/limits/" + i6,schemaPath:"#/properties/limits/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key5},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
}
if(data25.name !== undefined){
if(typeof data25.name !== "string"){
const err69 = {instancePath:instancePath+"/limits/" + i6+"/name",schemaPath:"#/properties/limits/items/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
if(data25.value !== undefined){
let data27 = data25.value;
if(!(((typeof data27 == "number") && (!(data27 % 1) && !isNaN(data27))) && (isFinite(data27)))){
const err70 = {instancePath:instancePath+"/limits/" + i6+"/value",schemaPath:"#/properties/limits/items/properties/value/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
if((typeof data27 == "number") && (isFinite(data27))){
if(data27 < 0 || isNaN(data27)){
const err71 = {instancePath:instancePath+"/limits/" + i6+"/value",schemaPath:"#/properties/limits/items/properties/value/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
}
}
}
else {
const err72 = {instancePath:instancePath+"/limits/" + i6,schemaPath:"#/properties/limits/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
}
else {
const err73 = {instancePath:instancePath+"/limits",schemaPath:"#/properties/limits/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
if(data.dataset !== undefined){
let data28 = data.dataset;
if(data28 && typeof data28 == "object" && !Array.isArray(data28)){
if(data28.fixtureId === undefined){
const err74 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/required",keyword:"required",params:{missingProperty: "fixtureId"},message:"must have required property '"+"fixtureId"+"'"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
if(data28.logicalResourceCount === undefined){
const err75 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/required",keyword:"required",params:{missingProperty: "logicalResourceCount"},message:"must have required property '"+"logicalResourceCount"+"'"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
if(data28.serverCount === undefined){
const err76 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/required",keyword:"required",params:{missingProperty: "serverCount"},message:"must have required property '"+"serverCount"+"'"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
if(data28.manifestSha256 === undefined){
const err77 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/required",keyword:"required",params:{missingProperty: "manifestSha256"},message:"must have required property '"+"manifestSha256"+"'"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
for(const key6 in data28){
if(!((((key6 === "fixtureId") || (key6 === "logicalResourceCount")) || (key6 === "serverCount")) || (key6 === "manifestSha256"))){
const err78 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key6},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
}
if(data28.fixtureId !== undefined){
if(typeof data28.fixtureId !== "string"){
const err79 = {instancePath:instancePath+"/dataset/fixtureId",schemaPath:"#/properties/dataset/properties/fixtureId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
}
if(data28.logicalResourceCount !== undefined){
let data30 = data28.logicalResourceCount;
if(!(((typeof data30 == "number") && (!(data30 % 1) && !isNaN(data30))) && (isFinite(data30)))){
const err80 = {instancePath:instancePath+"/dataset/logicalResourceCount",schemaPath:"#/properties/dataset/properties/logicalResourceCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
if((typeof data30 == "number") && (isFinite(data30))){
if(data30 < 1 || isNaN(data30)){
const err81 = {instancePath:instancePath+"/dataset/logicalResourceCount",schemaPath:"#/properties/dataset/properties/logicalResourceCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
}
}
if(data28.serverCount !== undefined){
let data31 = data28.serverCount;
if(!(((typeof data31 == "number") && (!(data31 % 1) && !isNaN(data31))) && (isFinite(data31)))){
const err82 = {instancePath:instancePath+"/dataset/serverCount",schemaPath:"#/properties/dataset/properties/serverCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err82];
}
else {
vErrors.push(err82);
}
errors++;
}
if((typeof data31 == "number") && (isFinite(data31))){
if(data31 < 1 || isNaN(data31)){
const err83 = {instancePath:instancePath+"/dataset/serverCount",schemaPath:"#/properties/dataset/properties/serverCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err83];
}
else {
vErrors.push(err83);
}
errors++;
}
}
}
if(data28.manifestSha256 !== undefined){
let data32 = data28.manifestSha256;
if(typeof data32 === "string"){
if(!pattern7.test(data32)){
const err84 = {instancePath:instancePath+"/dataset/manifestSha256",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err84];
}
else {
vErrors.push(err84);
}
errors++;
}
}
else {
const err85 = {instancePath:instancePath+"/dataset/manifestSha256",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err85];
}
else {
vErrors.push(err85);
}
errors++;
}
}
}
else {
const err86 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err86];
}
else {
vErrors.push(err86);
}
errors++;
}
}
if(data.basis !== undefined){
let data33 = data.basis;
if(data33 && typeof data33 == "object" && !Array.isArray(data33)){
if(data33.behavior === undefined){
const err87 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "behavior"},message:"must have required property '"+"behavior"+"'"};
if(vErrors === null){
vErrors = [err87];
}
else {
vErrors.push(err87);
}
errors++;
}
if(data33.id === undefined){
const err88 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err88];
}
else {
vErrors.push(err88);
}
errors++;
}
if(data33.capturedAt === undefined){
const err89 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "capturedAt"},message:"must have required property '"+"capturedAt"+"'"};
if(vErrors === null){
vErrors = [err89];
}
else {
vErrors.push(err89);
}
errors++;
}
if(data33.fixedForEnvironment === undefined){
const err90 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "fixedForEnvironment"},message:"must have required property '"+"fixedForEnvironment"+"'"};
if(vErrors === null){
vErrors = [err90];
}
else {
vErrors.push(err90);
}
errors++;
}
for(const key7 in data33){
if(!((((key7 === "behavior") || (key7 === "id")) || (key7 === "capturedAt")) || (key7 === "fixedForEnvironment"))){
const err91 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key7},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err91];
}
else {
vErrors.push(err91);
}
errors++;
}
}
if(data33.behavior !== undefined){
let data34 = data33.behavior;
if(!((((data34 === "fixed-environment") || (data34 === "request-snapshot")) || (data34 === "page-lifecycle")) || (data34 === "rebuild-lifecycle"))){
const err92 = {instancePath:instancePath+"/basis/behavior",schemaPath:"#/$defs/basis/properties/behavior/enum",keyword:"enum",params:{allowedValues: schema42.properties.behavior.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err92];
}
else {
vErrors.push(err92);
}
errors++;
}
}
if(data33.id !== undefined){
let data35 = data33.id;
if(typeof data35 === "string"){
if(func1(data35) > 256){
const err93 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err93];
}
else {
vErrors.push(err93);
}
errors++;
}
if(func1(data35) < 1){
const err94 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err94];
}
else {
vErrors.push(err94);
}
errors++;
}
}
else {
const err95 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err95];
}
else {
vErrors.push(err95);
}
errors++;
}
}
if(data33.capturedAt !== undefined){
let data36 = data33.capturedAt;
if(typeof data36 === "string"){
if(!(formats0.validate(data36))){
const err96 = {instancePath:instancePath+"/basis/capturedAt",schemaPath:"#/$defs/basis/properties/capturedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err96];
}
else {
vErrors.push(err96);
}
errors++;
}
}
else {
const err97 = {instancePath:instancePath+"/basis/capturedAt",schemaPath:"#/$defs/basis/properties/capturedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err97];
}
else {
vErrors.push(err97);
}
errors++;
}
}
if(data33.fixedForEnvironment !== undefined){
if(typeof data33.fixedForEnvironment !== "boolean"){
const err98 = {instancePath:instancePath+"/basis/fixedForEnvironment",schemaPath:"#/$defs/basis/properties/fixedForEnvironment/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err98];
}
else {
vErrors.push(err98);
}
errors++;
}
}
}
else {
const err99 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err99];
}
else {
vErrors.push(err99);
}
errors++;
}
}
}
else {
const err100 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err100];
}
else {
vErrors.push(err100);
}
errors++;
}
validate28.errors = vErrors;
return errors === 0;
}
validate28.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema46 = {"type":"object","additionalProperties":false,"required":["items","pageInfo"],"properties":{"items":{"type":"array","maxItems":1000,"items":{"$ref":"#/$defs/object"}},"pageInfo":{"$ref":"#/$defs/pageInfo"}}};
const schema53 = {"type":"object","additionalProperties":false,"required":["hasNextPage","endCursor","pageSize"],"properties":{"hasNextPage":{"type":"boolean"},"endCursor":{"type":["string","null"],"maxLength":4096},"pageSize":{"type":"integer","minimum":0,"maximum":1000}},"allOf":[{"if":{"properties":{"hasNextPage":{"const":true}}},"then":{"properties":{"endCursor":{"type":"string","minLength":1}}}},{"if":{"properties":{"hasNextPage":{"const":false}}},"then":{"properties":{"endCursor":{"type":"null"}}}}]};
const schema47 = {"type":"object","additionalProperties":false,"required":["type","id","displayName","attributes"],"properties":{"type":{"$ref":"#/$defs/identifier"},"id":{"$ref":"#/$defs/identifier"},"displayName":{"type":["string","null"],"maxLength":256},"attributes":{"type":"array","maxItems":64,"items":{"$ref":"#/$defs/attribute"}}}};
const schema48 = {"type":"string","minLength":1,"maxLength":256,"pattern":"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"};
const pattern10 = new RegExp("^[A-Za-z0-9][A-Za-z0-9._:@/-]*$", "u");
const schema50 = {"type":"object","additionalProperties":false,"required":["name","value"],"properties":{"name":{"$ref":"#/$defs/identifier"},"value":{"$ref":"#/$defs/scalar"}}};
const schema52 = {"type":["string","number","integer","boolean","null"]};

function validate33(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate33.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.value === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "value"},message:"must have required property '"+"value"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "name") || (key0 === "value"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.name !== undefined){
let data0 = data.name;
if(typeof data0 === "string"){
if(func1(data0) > 256){
const err3 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func1(data0) < 1){
const err4 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern10.test(data0)){
const err5 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.value !== undefined){
let data1 = data.value;
if((((typeof data1 !== "string") && (!((typeof data1 == "number") && (isFinite(data1))))) && (typeof data1 !== "boolean")) && (data1 !== null)){
const err7 = {instancePath:instancePath+"/value",schemaPath:"#/$defs/scalar/type",keyword:"type",params:{type: schema52.type},message:"must be string,number,integer,boolean,null"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate33.errors = vErrors;
return errors === 0;
}
validate33.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate32(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate32.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.type === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.id === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.displayName === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "displayName"},message:"must have required property '"+"displayName"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.attributes === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "attributes"},message:"must have required property '"+"attributes"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "type") || (key0 === "id")) || (key0 === "displayName")) || (key0 === "attributes"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.type !== undefined){
let data0 = data.type;
if(typeof data0 === "string"){
if(func1(data0) > 256){
const err5 = {instancePath:instancePath+"/type",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/type",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern10.test(data0)){
const err7 = {instancePath:instancePath+"/type",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/type",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.id !== undefined){
let data1 = data.id;
if(typeof data1 === "string"){
if(func1(data1) > 256){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data1) < 1){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern10.test(data1)){
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.displayName !== undefined){
let data2 = data.displayName;
if((typeof data2 !== "string") && (data2 !== null)){
const err13 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/type",keyword:"type",params:{type: schema47.properties.displayName.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(typeof data2 === "string"){
if(func1(data2) > 256){
const err14 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.attributes !== undefined){
let data3 = data.attributes;
if(Array.isArray(data3)){
if(data3.length > 64){
const err15 = {instancePath:instancePath+"/attributes",schemaPath:"#/properties/attributes/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
const len0 = data3.length;
for(let i0=0; i0<len0; i0++){
if(!(validate33(data3[i0], {instancePath:instancePath+"/attributes/" + i0,parentData:data3,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate33.errors : vErrors.concat(validate33.errors);
errors = vErrors.length;
}
}
}
else {
const err16 = {instancePath:instancePath+"/attributes",schemaPath:"#/properties/attributes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate32.errors = vErrors;
return errors === 0;
}
validate32.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate31(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate31.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.pageInfo === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pageInfo"},message:"must have required property '"+"pageInfo"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "pageInfo"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 1000){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 1000},message:"must NOT have more than 1000 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate32(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.pageInfo !== undefined){
let data2 = data.pageInfo;
const _errs9 = errors;
let valid5 = true;
const _errs10 = errors;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.hasNextPage !== undefined){
if(true !== data2.hasNextPage){
const err5 = {};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
var _valid0 = _errs10 === errors;
errors = _errs9;
if(vErrors !== null){
if(_errs9){
vErrors.length = _errs9;
}
else {
vErrors = null;
}
}
if(_valid0){
const _errs12 = errors;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.endCursor !== undefined){
let data4 = data2.endCursor;
if(typeof data4 === "string"){
if(func1(data4) < 1){
const err6 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/allOf/0/then/properties/endCursor/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/allOf/0/then/properties/endCursor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
var _valid0 = _errs12 === errors;
valid5 = _valid0;
if(valid5){
var props0 = {};
props0.endCursor = true;
props0.hasNextPage = true;
}
}
if(!valid5){
const err8 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/allOf/0/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
const _errs16 = errors;
let valid8 = true;
const _errs17 = errors;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.hasNextPage !== undefined){
if(false !== data2.hasNextPage){
const err9 = {};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
var _valid1 = _errs17 === errors;
errors = _errs16;
if(vErrors !== null){
if(_errs16){
vErrors.length = _errs16;
}
else {
vErrors = null;
}
}
if(_valid1){
const _errs19 = errors;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.endCursor !== undefined){
if(data2.endCursor !== null){
const err10 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/allOf/1/then/properties/endCursor/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
var _valid1 = _errs19 === errors;
valid8 = _valid1;
if(valid8){
var props1 = {};
props1.endCursor = true;
props1.hasNextPage = true;
}
}
if(!valid8){
const err11 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/allOf/1/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(props0 !== true && props1 !== undefined){
if(props1 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props1);
}
}
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.hasNextPage === undefined){
const err12 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/required",keyword:"required",params:{missingProperty: "hasNextPage"},message:"must have required property '"+"hasNextPage"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data2.endCursor === undefined){
const err13 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/required",keyword:"required",params:{missingProperty: "endCursor"},message:"must have required property '"+"endCursor"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2.pageSize === undefined){
const err14 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/required",keyword:"required",params:{missingProperty: "pageSize"},message:"must have required property '"+"pageSize"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
for(const key1 in data2){
if(!(((key1 === "hasNextPage") || (key1 === "endCursor")) || (key1 === "pageSize"))){
const err15 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data2.hasNextPage !== undefined){
if(typeof data2.hasNextPage !== "boolean"){
const err16 = {instancePath:instancePath+"/pageInfo/hasNextPage",schemaPath:"#/$defs/pageInfo/properties/hasNextPage/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.endCursor !== undefined){
let data8 = data2.endCursor;
if((typeof data8 !== "string") && (data8 !== null)){
const err17 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/properties/endCursor/type",keyword:"type",params:{type: schema53.properties.endCursor.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(typeof data8 === "string"){
if(func1(data8) > 4096){
const err18 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/properties/endCursor/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data2.pageSize !== undefined){
let data9 = data2.pageSize;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err19 = {instancePath:instancePath+"/pageInfo/pageSize",schemaPath:"#/$defs/pageInfo/properties/pageSize/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 1000 || isNaN(data9)){
const err20 = {instancePath:instancePath+"/pageInfo/pageSize",schemaPath:"#/$defs/pageInfo/properties/pageSize/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000},message:"must be <= 1000"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data9 < 0 || isNaN(data9)){
const err21 = {instancePath:instancePath+"/pageInfo/pageSize",schemaPath:"#/$defs/pageInfo/properties/pageSize/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
}
else {
const err22 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate31.errors = vErrors;
return errors === 0;
}
validate31.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema54 = {"type":"object","additionalProperties":false,"required":["object"],"properties":{"object":{"$ref":"#/$defs/object"}}};

function validate37(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate37.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.object === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "object"},message:"must have required property '"+"object"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "object")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.object !== undefined){
if(!(validate32(data.object, {instancePath:instancePath+"/object",parentData:data,parentDataProperty:"object",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
errors = vErrors.length;
}
}
}
else {
const err2 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
validate37.errors = vErrors;
return errors === 0;
}
validate37.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema55 = {"type":"object","additionalProperties":false,"required":["items","pageInfo"],"properties":{"items":{"type":"array","maxItems":1000,"items":{"$ref":"#/$defs/relationship"}},"pageInfo":{"$ref":"#/$defs/pageInfo"}}};
const schema56 = {"type":"object","additionalProperties":false,"required":["resourceType","resourceId","relation","subjectType","subjectId","subjectRelation"],"properties":{"resourceType":{"$ref":"#/$defs/identifier"},"resourceId":{"$ref":"#/$defs/identifier"},"relation":{"$ref":"#/$defs/identifier"},"subjectType":{"$ref":"#/$defs/identifier"},"subjectId":{"$ref":"#/$defs/identifier"},"subjectRelation":{"anyOf":[{"$ref":"#/$defs/identifier"},{"type":"null"}]}}};

function validate41(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate41.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resourceType === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "resourceType"},message:"must have required property '"+"resourceType"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.resourceId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "resourceId"},message:"must have required property '"+"resourceId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.relation === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "relation"},message:"must have required property '"+"relation"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.subjectType === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "subjectType"},message:"must have required property '"+"subjectType"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.subjectId === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "subjectId"},message:"must have required property '"+"subjectId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.subjectRelation === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "subjectRelation"},message:"must have required property '"+"subjectRelation"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "resourceType") || (key0 === "resourceId")) || (key0 === "relation")) || (key0 === "subjectType")) || (key0 === "subjectId")) || (key0 === "subjectRelation"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.resourceType !== undefined){
let data0 = data.resourceType;
if(typeof data0 === "string"){
if(func1(data0) > 256){
const err7 = {instancePath:instancePath+"/resourceType",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func1(data0) < 1){
const err8 = {instancePath:instancePath+"/resourceType",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!pattern10.test(data0)){
const err9 = {instancePath:instancePath+"/resourceType",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/resourceType",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.resourceId !== undefined){
let data1 = data.resourceId;
if(typeof data1 === "string"){
if(func1(data1) > 256){
const err11 = {instancePath:instancePath+"/resourceId",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func1(data1) < 1){
const err12 = {instancePath:instancePath+"/resourceId",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!pattern10.test(data1)){
const err13 = {instancePath:instancePath+"/resourceId",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/resourceId",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.relation !== undefined){
let data2 = data.relation;
if(typeof data2 === "string"){
if(func1(data2) > 256){
const err15 = {instancePath:instancePath+"/relation",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(func1(data2) < 1){
const err16 = {instancePath:instancePath+"/relation",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(!pattern10.test(data2)){
const err17 = {instancePath:instancePath+"/relation",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/relation",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.subjectType !== undefined){
let data3 = data.subjectType;
if(typeof data3 === "string"){
if(func1(data3) > 256){
const err19 = {instancePath:instancePath+"/subjectType",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(func1(data3) < 1){
const err20 = {instancePath:instancePath+"/subjectType",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(!pattern10.test(data3)){
const err21 = {instancePath:instancePath+"/subjectType",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/subjectType",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.subjectId !== undefined){
let data4 = data.subjectId;
if(typeof data4 === "string"){
if(func1(data4) > 256){
const err23 = {instancePath:instancePath+"/subjectId",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(func1(data4) < 1){
const err24 = {instancePath:instancePath+"/subjectId",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(!pattern10.test(data4)){
const err25 = {instancePath:instancePath+"/subjectId",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
else {
const err26 = {instancePath:instancePath+"/subjectId",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.subjectRelation !== undefined){
let data5 = data.subjectRelation;
const _errs18 = errors;
let valid6 = false;
const _errs19 = errors;
if(typeof data5 === "string"){
if(func1(data5) > 256){
const err27 = {instancePath:instancePath+"/subjectRelation",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(func1(data5) < 1){
const err28 = {instancePath:instancePath+"/subjectRelation",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(!pattern10.test(data5)){
const err29 = {instancePath:instancePath+"/subjectRelation",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/subjectRelation",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid0 = _errs19 === errors;
valid6 = valid6 || _valid0;
const _errs22 = errors;
if(data5 !== null){
const err31 = {instancePath:instancePath+"/subjectRelation",schemaPath:"#/properties/subjectRelation/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
var _valid0 = _errs22 === errors;
valid6 = valid6 || _valid0;
if(!valid6){
const err32 = {instancePath:instancePath+"/subjectRelation",schemaPath:"#/properties/subjectRelation/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs18;
if(vErrors !== null){
if(_errs18){
vErrors.length = _errs18;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err33 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
validate41.errors = vErrors;
return errors === 0;
}
validate41.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate40(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate40.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.pageInfo === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "pageInfo"},message:"must have required property '"+"pageInfo"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "pageInfo"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 1000){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 1000},message:"must NOT have more than 1000 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate41(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate41.errors : vErrors.concat(validate41.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.pageInfo !== undefined){
let data2 = data.pageInfo;
const _errs9 = errors;
let valid5 = true;
const _errs10 = errors;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.hasNextPage !== undefined){
if(true !== data2.hasNextPage){
const err5 = {};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
var _valid0 = _errs10 === errors;
errors = _errs9;
if(vErrors !== null){
if(_errs9){
vErrors.length = _errs9;
}
else {
vErrors = null;
}
}
if(_valid0){
const _errs12 = errors;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.endCursor !== undefined){
let data4 = data2.endCursor;
if(typeof data4 === "string"){
if(func1(data4) < 1){
const err6 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/allOf/0/then/properties/endCursor/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/allOf/0/then/properties/endCursor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
var _valid0 = _errs12 === errors;
valid5 = _valid0;
if(valid5){
var props0 = {};
props0.endCursor = true;
props0.hasNextPage = true;
}
}
if(!valid5){
const err8 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/allOf/0/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
const _errs16 = errors;
let valid8 = true;
const _errs17 = errors;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.hasNextPage !== undefined){
if(false !== data2.hasNextPage){
const err9 = {};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
var _valid1 = _errs17 === errors;
errors = _errs16;
if(vErrors !== null){
if(_errs16){
vErrors.length = _errs16;
}
else {
vErrors = null;
}
}
if(_valid1){
const _errs19 = errors;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.endCursor !== undefined){
if(data2.endCursor !== null){
const err10 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/allOf/1/then/properties/endCursor/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
var _valid1 = _errs19 === errors;
valid8 = _valid1;
if(valid8){
var props1 = {};
props1.endCursor = true;
props1.hasNextPage = true;
}
}
if(!valid8){
const err11 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/allOf/1/if",keyword:"if",params:{failingKeyword: "then"},message:"must match \"then\" schema"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(props0 !== true && props1 !== undefined){
if(props1 === true){
props0 = true;
}
else {
props0 = props0 || {};
Object.assign(props0, props1);
}
}
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.hasNextPage === undefined){
const err12 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/required",keyword:"required",params:{missingProperty: "hasNextPage"},message:"must have required property '"+"hasNextPage"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data2.endCursor === undefined){
const err13 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/required",keyword:"required",params:{missingProperty: "endCursor"},message:"must have required property '"+"endCursor"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2.pageSize === undefined){
const err14 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/required",keyword:"required",params:{missingProperty: "pageSize"},message:"must have required property '"+"pageSize"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
for(const key1 in data2){
if(!(((key1 === "hasNextPage") || (key1 === "endCursor")) || (key1 === "pageSize"))){
const err15 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data2.hasNextPage !== undefined){
if(typeof data2.hasNextPage !== "boolean"){
const err16 = {instancePath:instancePath+"/pageInfo/hasNextPage",schemaPath:"#/$defs/pageInfo/properties/hasNextPage/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data2.endCursor !== undefined){
let data8 = data2.endCursor;
if((typeof data8 !== "string") && (data8 !== null)){
const err17 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/properties/endCursor/type",keyword:"type",params:{type: schema53.properties.endCursor.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(typeof data8 === "string"){
if(func1(data8) > 4096){
const err18 = {instancePath:instancePath+"/pageInfo/endCursor",schemaPath:"#/$defs/pageInfo/properties/endCursor/maxLength",keyword:"maxLength",params:{limit: 4096},message:"must NOT have more than 4096 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data2.pageSize !== undefined){
let data9 = data2.pageSize;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err19 = {instancePath:instancePath+"/pageInfo/pageSize",schemaPath:"#/$defs/pageInfo/properties/pageSize/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 1000 || isNaN(data9)){
const err20 = {instancePath:instancePath+"/pageInfo/pageSize",schemaPath:"#/$defs/pageInfo/properties/pageSize/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1000},message:"must be <= 1000"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data9 < 0 || isNaN(data9)){
const err21 = {instancePath:instancePath+"/pageInfo/pageSize",schemaPath:"#/$defs/pageInfo/properties/pageSize/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
}
else {
const err22 = {instancePath:instancePath+"/pageInfo",schemaPath:"#/$defs/pageInfo/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate40.errors = vErrors;
return errors === 0;
}
validate40.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema66 = {"type":"object","additionalProperties":false,"required":["sha256","types"],"properties":{"sha256":{"$ref":"#/$defs/sha256"},"types":{"type":"array","minItems":1,"maxItems":128,"items":{"$ref":"#/$defs/schemaType"}}}};
const schema68 = {"type":"object","additionalProperties":false,"required":["name","relations","permissions"],"properties":{"name":{"$ref":"#/$defs/identifier"},"relations":{"type":"array","maxItems":64,"items":{"$ref":"#/$defs/schemaRelation"}},"permissions":{"type":"array","maxItems":64,"items":{"$ref":"#/$defs/schemaPermission"}}}};
const schema70 = {"type":"object","additionalProperties":false,"required":["name","subjectTypes"],"properties":{"name":{"$ref":"#/$defs/identifier"},"subjectTypes":{"type":"array","minItems":1,"maxItems":32,"uniqueItems":true,"items":{"$ref":"#/$defs/identifier"}}}};

function validate46(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate46.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.subjectTypes === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "subjectTypes"},message:"must have required property '"+"subjectTypes"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "name") || (key0 === "subjectTypes"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.name !== undefined){
let data0 = data.name;
if(typeof data0 === "string"){
if(func1(data0) > 256){
const err3 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func1(data0) < 1){
const err4 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern10.test(data0)){
const err5 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.subjectTypes !== undefined){
let data1 = data.subjectTypes;
if(Array.isArray(data1)){
if(data1.length > 32){
const err7 = {instancePath:instancePath+"/subjectTypes",schemaPath:"#/properties/subjectTypes/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data1.length < 1){
const err8 = {instancePath:instancePath+"/subjectTypes",schemaPath:"#/properties/subjectTypes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(typeof data2 === "string"){
if(func1(data2) > 256){
const err9 = {instancePath:instancePath+"/subjectTypes/" + i0,schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data2) < 1){
const err10 = {instancePath:instancePath+"/subjectTypes/" + i0,schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern10.test(data2)){
const err11 = {instancePath:instancePath+"/subjectTypes/" + i0,schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/subjectTypes/" + i0,schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
let i1 = data1.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data1[i1], data1[j0])){
const err13 = {instancePath:instancePath+"/subjectTypes",schemaPath:"#/properties/subjectTypes/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err14 = {instancePath:instancePath+"/subjectTypes",schemaPath:"#/properties/subjectTypes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate46.errors = vErrors;
return errors === 0;
}
validate46.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema73 = {"type":"object","additionalProperties":false,"required":["name","expression"],"properties":{"name":{"$ref":"#/$defs/identifier"},"expression":{"type":"string","minLength":1,"maxLength":1024}}};

function validate48(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate48.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.expression === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expression"},message:"must have required property '"+"expression"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "name") || (key0 === "expression"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.name !== undefined){
let data0 = data.name;
if(typeof data0 === "string"){
if(func1(data0) > 256){
const err3 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func1(data0) < 1){
const err4 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern10.test(data0)){
const err5 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.expression !== undefined){
let data1 = data.expression;
if(typeof data1 === "string"){
if(func1(data1) > 1024){
const err7 = {instancePath:instancePath+"/expression",schemaPath:"#/properties/expression/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func1(data1) < 1){
const err8 = {instancePath:instancePath+"/expression",schemaPath:"#/properties/expression/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/expression",schemaPath:"#/properties/expression/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate48.errors = vErrors;
return errors === 0;
}
validate48.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate45(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate45.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.relations === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "relations"},message:"must have required property '"+"relations"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.permissions === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "permissions"},message:"must have required property '"+"permissions"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "name") || (key0 === "relations")) || (key0 === "permissions"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.name !== undefined){
let data0 = data.name;
if(typeof data0 === "string"){
if(func1(data0) > 256){
const err4 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(func1(data0) < 1){
const err5 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!pattern10.test(data0)){
const err6 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"},message:"must match pattern \""+"^[A-Za-z0-9][A-Za-z0-9._:@/-]*$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/identifier/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.relations !== undefined){
let data1 = data.relations;
if(Array.isArray(data1)){
if(data1.length > 64){
const err8 = {instancePath:instancePath+"/relations",schemaPath:"#/properties/relations/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
if(!(validate46(data1[i0], {instancePath:instancePath+"/relations/" + i0,parentData:data1,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate46.errors : vErrors.concat(validate46.errors);
errors = vErrors.length;
}
}
}
else {
const err9 = {instancePath:instancePath+"/relations",schemaPath:"#/properties/relations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.permissions !== undefined){
let data3 = data.permissions;
if(Array.isArray(data3)){
if(data3.length > 64){
const err10 = {instancePath:instancePath+"/permissions",schemaPath:"#/properties/permissions/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
const len1 = data3.length;
for(let i1=0; i1<len1; i1++){
if(!(validate48(data3[i1], {instancePath:instancePath+"/permissions/" + i1,parentData:data3,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate48.errors : vErrors.concat(validate48.errors);
errors = vErrors.length;
}
}
}
else {
const err11 = {instancePath:instancePath+"/permissions",schemaPath:"#/properties/permissions/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate45.errors = vErrors;
return errors === 0;
}
validate45.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate44(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate44.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.sha256 === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.types === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "types"},message:"must have required property '"+"types"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "sha256") || (key0 === "types"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.sha256 !== undefined){
let data0 = data.sha256;
if(typeof data0 === "string"){
if(!pattern7.test(data0)){
const err3 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.types !== undefined){
let data1 = data.types;
if(Array.isArray(data1)){
if(data1.length > 128){
const err5 = {instancePath:instancePath+"/types",schemaPath:"#/properties/types/maxItems",keyword:"maxItems",params:{limit: 128},message:"must NOT have more than 128 items"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data1.length < 1){
const err6 = {instancePath:instancePath+"/types",schemaPath:"#/properties/types/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
if(!(validate45(data1[i0], {instancePath:instancePath+"/types/" + i0,parentData:data1,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate45.errors : vErrors.concat(validate45.errors);
errors = vErrors.length;
}
}
}
else {
const err7 = {instancePath:instancePath+"/types",schemaPath:"#/properties/types/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate44.errors = vErrors;
return errors === 0;
}
validate44.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate23(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate23.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.meta === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "meta"},message:"must have required property '"+"meta"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.data === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "data"},message:"must have required property '"+"data"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "meta") || (key0 === "data"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.meta !== undefined){
let data0 = data.meta;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.revision === undefined){
const err3 = {instancePath:instancePath+"/meta",schemaPath:"#/$defs/responseMeta/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data0.requestId === undefined){
const err4 = {instancePath:instancePath+"/meta",schemaPath:"#/$defs/responseMeta/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key1 in data0){
if(!((((key1 === "revision") || (key1 === "requestId")) || (key1 === "elapsedMs")) || (key1 === "cacheStatus"))){
const err5 = {instancePath:instancePath+"/meta",schemaPath:"#/$defs/responseMeta/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data0.revision !== undefined){
let data1 = data0.revision;
if(typeof data1 === "string"){
if(func1(data1) > 256){
const err6 = {instancePath:instancePath+"/meta/revision",schemaPath:"#/$defs/responseMeta/properties/revision/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func1(data1) < 1){
const err7 = {instancePath:instancePath+"/meta/revision",schemaPath:"#/$defs/responseMeta/properties/revision/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/meta/revision",schemaPath:"#/$defs/responseMeta/properties/revision/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data0.requestId !== undefined){
let data2 = data0.requestId;
if(typeof data2 === "string"){
if(func1(data2) > 128){
const err9 = {instancePath:instancePath+"/meta/requestId",schemaPath:"#/$defs/responseMeta/properties/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data2) < 1){
const err10 = {instancePath:instancePath+"/meta/requestId",schemaPath:"#/$defs/responseMeta/properties/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/meta/requestId",schemaPath:"#/$defs/responseMeta/properties/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data0.elapsedMs !== undefined){
let data3 = data0.elapsedMs;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 < 0 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/meta/elapsedMs",schemaPath:"#/$defs/responseMeta/properties/elapsedMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/meta/elapsedMs",schemaPath:"#/$defs/responseMeta/properties/elapsedMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data0.cacheStatus !== undefined){
let data4 = data0.cacheStatus;
if(!(((data4 === "hit") || (data4 === "miss")) || (data4 === "disabled"))){
const err14 = {instancePath:instancePath+"/meta/cacheStatus",schemaPath:"#/$defs/responseMeta/properties/cacheStatus/enum",keyword:"enum",params:{allowedValues: schema35.properties.cacheStatus.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath:instancePath+"/meta",schemaPath:"#/$defs/responseMeta/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.data !== undefined){
let data5 = data.data;
const _errs14 = errors;
let valid3 = false;
const _errs15 = errors;
if(!(validate24(data5, {instancePath:instancePath+"/data",parentData:data,parentDataProperty:"data",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
var _valid0 = _errs15 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
var props0 = true;
}
const _errs16 = errors;
if(!(validate28(data5, {instancePath:instancePath+"/data",parentData:data,parentDataProperty:"data",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
errors = vErrors.length;
}
var _valid0 = _errs16 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
const _errs17 = errors;
if(!(validate31(data5, {instancePath:instancePath+"/data",parentData:data,parentDataProperty:"data",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate31.errors : vErrors.concat(validate31.errors);
errors = vErrors.length;
}
var _valid0 = _errs17 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
const _errs18 = errors;
if(!(validate37(data5, {instancePath:instancePath+"/data",parentData:data,parentDataProperty:"data",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate37.errors : vErrors.concat(validate37.errors);
errors = vErrors.length;
}
var _valid0 = _errs18 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
const _errs19 = errors;
if(!(validate40(data5, {instancePath:instancePath+"/data",parentData:data,parentDataProperty:"data",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate40.errors : vErrors.concat(validate40.errors);
errors = vErrors.length;
}
var _valid0 = _errs19 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
const _errs20 = errors;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.allowed === undefined){
const err16 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/permissionDecision/required",keyword:"required",params:{missingProperty: "allowed"},message:"must have required property '"+"allowed"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
for(const key2 in data5){
if(!(key2 === "allowed")){
const err17 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/permissionDecision/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data5.allowed !== undefined){
if(typeof data5.allowed !== "boolean"){
const err18 = {instancePath:instancePath+"/data/allowed",schemaPath:"#/$defs/permissionDecision/properties/allowed/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/permissionDecision/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid0 = _errs20 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
const _errs26 = errors;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.kind === undefined){
const err20 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/count/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data5.value === undefined){
const err21 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/count/required",keyword:"required",params:{missingProperty: "value"},message:"must have required property '"+"value"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data5.exact === undefined){
const err22 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/count/required",keyword:"required",params:{missingProperty: "exact"},message:"must have required property '"+"exact"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5.ceiling === undefined){
const err23 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/count/required",keyword:"required",params:{missingProperty: "ceiling"},message:"must have required property '"+"ceiling"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key3 in data5){
if(!((((key3 === "kind") || (key3 === "value")) || (key3 === "exact")) || (key3 === "ceiling"))){
const err24 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/count/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data5.kind !== undefined){
let data7 = data5.kind;
if(!(((data7 === "subjects") || (data7 === "objects")) || (data7 === "relationships"))){
const err25 = {instancePath:instancePath+"/data/kind",schemaPath:"#/$defs/count/properties/kind/enum",keyword:"enum",params:{allowedValues: schema65.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data5.value !== undefined){
let data8 = data5.value;
if(!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))){
const err26 = {instancePath:instancePath+"/data/value",schemaPath:"#/$defs/count/properties/value/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 < 0 || isNaN(data8)){
const err27 = {instancePath:instancePath+"/data/value",schemaPath:"#/$defs/count/properties/value/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
if(data5.exact !== undefined){
if(typeof data5.exact !== "boolean"){
const err28 = {instancePath:instancePath+"/data/exact",schemaPath:"#/$defs/count/properties/exact/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data5.ceiling !== undefined){
let data10 = data5.ceiling;
if((!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))) && (data10 !== null)){
const err29 = {instancePath:instancePath+"/data/ceiling",schemaPath:"#/$defs/count/properties/ceiling/type",keyword:"type",params:{type: schema65.properties.ceiling.type},message:"must be integer,null"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 < 1 || isNaN(data10)){
const err30 = {instancePath:instancePath+"/data/ceiling",schemaPath:"#/$defs/count/properties/ceiling/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
}
else {
const err31 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/count/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
var _valid0 = _errs26 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
const _errs37 = errors;
if(!(validate44(data5, {instancePath:instancePath+"/data",parentData:data,parentDataProperty:"data",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate44.errors : vErrors.concat(validate44.errors);
errors = vErrors.length;
}
var _valid0 = _errs37 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
const _errs38 = errors;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.behavior === undefined){
const err32 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/cacheInfo/required",keyword:"required",params:{missingProperty: "behavior"},message:"must have required property '"+"behavior"+"'"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data5.hit === undefined){
const err33 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/cacheInfo/required",keyword:"required",params:{missingProperty: "hit"},message:"must have required property '"+"hit"+"'"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(data5.scope === undefined){
const err34 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/cacheInfo/required",keyword:"required",params:{missingProperty: "scope"},message:"must have required property '"+"scope"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data5.entries === undefined){
const err35 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/cacheInfo/required",keyword:"required",params:{missingProperty: "entries"},message:"must have required property '"+"entries"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data5.limitations === undefined){
const err36 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/cacheInfo/required",keyword:"required",params:{missingProperty: "limitations"},message:"must have required property '"+"limitations"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
for(const key4 in data5){
if(!(((((key4 === "behavior") || (key4 === "hit")) || (key4 === "scope")) || (key4 === "entries")) || (key4 === "limitations"))){
const err37 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/cacheInfo/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key4},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data5.behavior !== undefined){
let data11 = data5.behavior;
if(!(((((data11 === "none") || (data11 === "request-local")) || (data11 === "environment-local")) || (data11 === "browser-page-local")) || (data11 === "shared-read-through"))){
const err38 = {instancePath:instancePath+"/data/behavior",schemaPath:"#/$defs/cacheInfo/properties/behavior/enum",keyword:"enum",params:{allowedValues: schema75.properties.behavior.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data5.hit !== undefined){
let data12 = data5.hit;
if((typeof data12 !== "boolean") && (data12 !== null)){
const err39 = {instancePath:instancePath+"/data/hit",schemaPath:"#/$defs/cacheInfo/properties/hit/type",keyword:"type",params:{type: schema75.properties.hit.type},message:"must be boolean,null"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data5.scope !== undefined){
let data13 = data5.scope;
if(typeof data13 === "string"){
if(func1(data13) > 128){
const err40 = {instancePath:instancePath+"/data/scope",schemaPath:"#/$defs/cacheInfo/properties/scope/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(func1(data13) < 1){
const err41 = {instancePath:instancePath+"/data/scope",schemaPath:"#/$defs/cacheInfo/properties/scope/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
else {
const err42 = {instancePath:instancePath+"/data/scope",schemaPath:"#/$defs/cacheInfo/properties/scope/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data5.entries !== undefined){
let data14 = data5.entries;
if((!(((typeof data14 == "number") && (!(data14 % 1) && !isNaN(data14))) && (isFinite(data14)))) && (data14 !== null)){
const err43 = {instancePath:instancePath+"/data/entries",schemaPath:"#/$defs/cacheInfo/properties/entries/type",keyword:"type",params:{type: schema75.properties.entries.type},message:"must be integer,null"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if((typeof data14 == "number") && (isFinite(data14))){
if(data14 < 0 || isNaN(data14)){
const err44 = {instancePath:instancePath+"/data/entries",schemaPath:"#/$defs/cacheInfo/properties/entries/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
}
if(data5.limitations !== undefined){
let data15 = data5.limitations;
if(Array.isArray(data15)){
if(data15.length > 16){
const err45 = {instancePath:instancePath+"/data/limitations",schemaPath:"#/$defs/cacheInfo/properties/limitations/maxItems",keyword:"maxItems",params:{limit: 16},message:"must NOT have more than 16 items"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
const len0 = data15.length;
for(let i0=0; i0<len0; i0++){
let data16 = data15[i0];
if(typeof data16 === "string"){
if(func1(data16) > 256){
const err46 = {instancePath:instancePath+"/data/limitations/" + i0,schemaPath:"#/$defs/cacheInfo/properties/limitations/items/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {instancePath:instancePath+"/data/limitations/" + i0,schemaPath:"#/$defs/cacheInfo/properties/limitations/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
let i1 = data15.length;
let j0;
if(i1 > 1){
const indices0 = {};
for(;i1--;){
let item0 = data15[i1];
if(typeof item0 !== "string"){
continue;
}
if(typeof indices0[item0] == "number"){
j0 = indices0[item0];
const err48 = {instancePath:instancePath+"/data/limitations",schemaPath:"#/$defs/cacheInfo/properties/limitations/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
break;
}
indices0[item0] = i1;
}
}
}
else {
const err49 = {instancePath:instancePath+"/data/limitations",schemaPath:"#/$defs/cacheInfo/properties/limitations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
}
else {
const err50 = {instancePath:instancePath+"/data",schemaPath:"#/$defs/cacheInfo/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
var _valid0 = _errs38 === errors;
valid3 = valid3 || _valid0;
if(_valid0){
if(props0 !== true){
props0 = true;
}
}
if(!valid3){
const err51 = {instancePath:instancePath+"/data",schemaPath:"#/properties/data/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
else {
errors = _errs14;
if(vErrors !== null){
if(_errs14){
vErrors.length = _errs14;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err52 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
validate23.errors = vErrors;
return errors === 0;
}
validate23.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema76 = {"type":"object","additionalProperties":false,"required":["error","meta"],"properties":{"meta":{"$ref":"#/$defs/responseMeta"},"error":{"type":"object","additionalProperties":false,"required":["code","message"],"properties":{"code":{"$ref":"error-codes.v1.schema.json#/$defs/code"},"message":{"type":"string","minLength":1,"maxLength":512}}}}};
const schema80 = {"enum":["validation-error","request-too-large","method-not-allowed","route-not-found","unsupported-media-type","cursor-invalid","cursor-expired","cursor-scope-mismatch","unsupported-consistency","freshness-unavailable","cancelled","deadline-exceeded","overloaded","throttled","dependency-unavailable","storage-missing","storage-corrupt","identity-mismatch","response-too-large","internal-error"]};

function validate53(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate53.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.error === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "error"},message:"must have required property '"+"error"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.meta === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "meta"},message:"must have required property '"+"meta"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "meta") || (key0 === "error"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.meta !== undefined){
let data0 = data.meta;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.revision === undefined){
const err3 = {instancePath:instancePath+"/meta",schemaPath:"#/$defs/responseMeta/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data0.requestId === undefined){
const err4 = {instancePath:instancePath+"/meta",schemaPath:"#/$defs/responseMeta/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key1 in data0){
if(!((((key1 === "revision") || (key1 === "requestId")) || (key1 === "elapsedMs")) || (key1 === "cacheStatus"))){
const err5 = {instancePath:instancePath+"/meta",schemaPath:"#/$defs/responseMeta/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data0.revision !== undefined){
let data1 = data0.revision;
if(typeof data1 === "string"){
if(func1(data1) > 256){
const err6 = {instancePath:instancePath+"/meta/revision",schemaPath:"#/$defs/responseMeta/properties/revision/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func1(data1) < 1){
const err7 = {instancePath:instancePath+"/meta/revision",schemaPath:"#/$defs/responseMeta/properties/revision/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/meta/revision",schemaPath:"#/$defs/responseMeta/properties/revision/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data0.requestId !== undefined){
let data2 = data0.requestId;
if(typeof data2 === "string"){
if(func1(data2) > 128){
const err9 = {instancePath:instancePath+"/meta/requestId",schemaPath:"#/$defs/responseMeta/properties/requestId/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data2) < 1){
const err10 = {instancePath:instancePath+"/meta/requestId",schemaPath:"#/$defs/responseMeta/properties/requestId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/meta/requestId",schemaPath:"#/$defs/responseMeta/properties/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data0.elapsedMs !== undefined){
let data3 = data0.elapsedMs;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 < 0 || isNaN(data3)){
const err12 = {instancePath:instancePath+"/meta/elapsedMs",schemaPath:"#/$defs/responseMeta/properties/elapsedMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/meta/elapsedMs",schemaPath:"#/$defs/responseMeta/properties/elapsedMs/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data0.cacheStatus !== undefined){
let data4 = data0.cacheStatus;
if(!(((data4 === "hit") || (data4 === "miss")) || (data4 === "disabled"))){
const err14 = {instancePath:instancePath+"/meta/cacheStatus",schemaPath:"#/$defs/responseMeta/properties/cacheStatus/enum",keyword:"enum",params:{allowedValues: schema35.properties.cacheStatus.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath:instancePath+"/meta",schemaPath:"#/$defs/responseMeta/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.error !== undefined){
let data5 = data.error;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.code === undefined){
const err16 = {instancePath:instancePath+"/error",schemaPath:"#/properties/error/required",keyword:"required",params:{missingProperty: "code"},message:"must have required property '"+"code"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data5.message === undefined){
const err17 = {instancePath:instancePath+"/error",schemaPath:"#/properties/error/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
for(const key2 in data5){
if(!((key2 === "code") || (key2 === "message"))){
const err18 = {instancePath:instancePath+"/error",schemaPath:"#/properties/error/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data5.code !== undefined){
let data6 = data5.code;
if(!((((((((((((((((((((data6 === "validation-error") || (data6 === "request-too-large")) || (data6 === "method-not-allowed")) || (data6 === "route-not-found")) || (data6 === "unsupported-media-type")) || (data6 === "cursor-invalid")) || (data6 === "cursor-expired")) || (data6 === "cursor-scope-mismatch")) || (data6 === "unsupported-consistency")) || (data6 === "freshness-unavailable")) || (data6 === "cancelled")) || (data6 === "deadline-exceeded")) || (data6 === "overloaded")) || (data6 === "throttled")) || (data6 === "dependency-unavailable")) || (data6 === "storage-missing")) || (data6 === "storage-corrupt")) || (data6 === "identity-mismatch")) || (data6 === "response-too-large")) || (data6 === "internal-error"))){
const err19 = {instancePath:instancePath+"/error/code",schemaPath:"error-codes.v1.schema.json#/$defs/code/enum",keyword:"enum",params:{allowedValues: schema80.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data5.message !== undefined){
let data7 = data5.message;
if(typeof data7 === "string"){
if(func1(data7) > 512){
const err20 = {instancePath:instancePath+"/error/message",schemaPath:"#/properties/error/properties/message/maxLength",keyword:"maxLength",params:{limit: 512},message:"must NOT have more than 512 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(func1(data7) < 1){
const err21 = {instancePath:instancePath+"/error/message",schemaPath:"#/properties/error/properties/message/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/error/message",schemaPath:"#/properties/error/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath:instancePath+"/error",schemaPath:"#/properties/error/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
else {
const err24 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
validate53.errors = vErrors;
return errors === 0;
}
validate53.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/explorer-response.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate21.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate23(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate53(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate21.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate21.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const fixture = validate58;
const schema82 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/fixture-manifest-boundary.v1.schema.json","type":"object","additionalProperties":false,"required":["schema","fixtureId","algorithmVersion","seed","cutPoint","logicalResourceCount","schemaSha256","manifestSha256"],"properties":{"schema":{"const":"eacl-demo.fixture-manifest.v1"},"fixtureId":{"type":"string","pattern":"^[a-z0-9]+(?:[._-][a-z0-9]+)*$"},"algorithmVersion":{"type":"string","pattern":"^[a-z0-9]+(?:[._-][a-z0-9]+)*$"},"seed":{"type":"string","minLength":1,"maxLength":128},"cutPoint":{"enum":[10000,1000000]},"logicalResourceCount":{"enum":[10000,1000000]},"schemaSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"manifestSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"}}};
const pattern24 = new RegExp("^[a-z0-9]+(?:[._-][a-z0-9]+)*$", "u");

function validate58(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/fixture-manifest-boundary.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate58.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.fixtureId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fixtureId"},message:"must have required property '"+"fixtureId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.algorithmVersion === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "algorithmVersion"},message:"must have required property '"+"algorithmVersion"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.seed === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "seed"},message:"must have required property '"+"seed"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.cutPoint === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cutPoint"},message:"must have required property '"+"cutPoint"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.logicalResourceCount === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "logicalResourceCount"},message:"must have required property '"+"logicalResourceCount"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.schemaSha256 === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaSha256"},message:"must have required property '"+"schemaSha256"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.manifestSha256 === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "manifestSha256"},message:"must have required property '"+"manifestSha256"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "schema") || (key0 === "fixtureId")) || (key0 === "algorithmVersion")) || (key0 === "seed")) || (key0 === "cutPoint")) || (key0 === "logicalResourceCount")) || (key0 === "schemaSha256")) || (key0 === "manifestSha256"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.schema !== undefined){
if("eacl-demo.fixture-manifest.v1" !== data.schema){
const err9 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/const",keyword:"const",params:{allowedValue: "eacl-demo.fixture-manifest.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.fixtureId !== undefined){
let data1 = data.fixtureId;
if(typeof data1 === "string"){
if(!pattern24.test(data1)){
const err10 = {instancePath:instancePath+"/fixtureId",schemaPath:"#/properties/fixtureId/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:[._-][a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:[._-][a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/fixtureId",schemaPath:"#/properties/fixtureId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.algorithmVersion !== undefined){
let data2 = data.algorithmVersion;
if(typeof data2 === "string"){
if(!pattern24.test(data2)){
const err12 = {instancePath:instancePath+"/algorithmVersion",schemaPath:"#/properties/algorithmVersion/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:[._-][a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:[._-][a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/algorithmVersion",schemaPath:"#/properties/algorithmVersion/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.seed !== undefined){
let data3 = data.seed;
if(typeof data3 === "string"){
if(func1(data3) > 128){
const err14 = {instancePath:instancePath+"/seed",schemaPath:"#/properties/seed/maxLength",keyword:"maxLength",params:{limit: 128},message:"must NOT have more than 128 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func1(data3) < 1){
const err15 = {instancePath:instancePath+"/seed",schemaPath:"#/properties/seed/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/seed",schemaPath:"#/properties/seed/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.cutPoint !== undefined){
let data4 = data.cutPoint;
if(!((data4 === 10000) || (data4 === 1000000))){
const err17 = {instancePath:instancePath+"/cutPoint",schemaPath:"#/properties/cutPoint/enum",keyword:"enum",params:{allowedValues: schema82.properties.cutPoint.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.logicalResourceCount !== undefined){
let data5 = data.logicalResourceCount;
if(!((data5 === 10000) || (data5 === 1000000))){
const err18 = {instancePath:instancePath+"/logicalResourceCount",schemaPath:"#/properties/logicalResourceCount/enum",keyword:"enum",params:{allowedValues: schema82.properties.logicalResourceCount.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.schemaSha256 !== undefined){
let data6 = data.schemaSha256;
if(typeof data6 === "string"){
if(!pattern7.test(data6)){
const err19 = {instancePath:instancePath+"/schemaSha256",schemaPath:"#/properties/schemaSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/schemaSha256",schemaPath:"#/properties/schemaSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.manifestSha256 !== undefined){
let data7 = data.manifestSha256;
if(typeof data7 === "string"){
if(!pattern7.test(data7)){
const err21 = {instancePath:instancePath+"/manifestSha256",schemaPath:"#/properties/manifestSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/manifestSha256",schemaPath:"#/properties/manifestSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate58.errors = vErrors;
return errors === 0;
}
validate58.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const descriptor = validate59;
const schema83 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/explorer-descriptor.v1.schema.json","$ref":"explorer.v1.schema.json#/$defs/bootstrap"};

function validate60(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate60.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.contract === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contract"},message:"must have required property '"+"contract"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.identity === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "identity"},message:"must have required property '"+"identity"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.profile === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.runtime === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runtime"},message:"must have required property '"+"runtime"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.capabilities === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.limits === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "limits"},message:"must have required property '"+"limits"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.dataset === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dataset"},message:"must have required property '"+"dataset"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.basis === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "basis"},message:"must have required property '"+"basis"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "contract") || (key0 === "identity")) || (key0 === "profile")) || (key0 === "runtime")) || (key0 === "capabilities")) || (key0 === "limits")) || (key0 === "dataset")) || (key0 === "basis"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.contract !== undefined){
let data0 = data.contract;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.name === undefined){
const err9 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data0.routeMajor === undefined){
const err10 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/required",keyword:"required",params:{missingProperty: "routeMajor"},message:"must have required property '"+"routeMajor"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data0.revision === undefined){
const err11 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data0.minimumClientRevision === undefined){
const err12 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/required",keyword:"required",params:{missingProperty: "minimumClientRevision"},message:"must have required property '"+"minimumClientRevision"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data0){
if(!((((key1 === "name") || (key1 === "routeMajor")) || (key1 === "revision")) || (key1 === "minimumClientRevision"))){
const err13 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data0.name !== undefined){
if("explorer.v1" !== data0.name){
const err14 = {instancePath:instancePath+"/contract/name",schemaPath:"#/properties/contract/properties/name/const",keyword:"const",params:{allowedValue: "explorer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data0.routeMajor !== undefined){
if(1 !== data0.routeMajor){
const err15 = {instancePath:instancePath+"/contract/routeMajor",schemaPath:"#/properties/contract/properties/routeMajor/const",keyword:"const",params:{allowedValue: 1},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data0.revision !== undefined){
let data3 = data0.revision;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err16 = {instancePath:instancePath+"/contract/revision",schemaPath:"#/properties/contract/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 < 0 || isNaN(data3)){
const err17 = {instancePath:instancePath+"/contract/revision",schemaPath:"#/properties/contract/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
if(data0.minimumClientRevision !== undefined){
let data4 = data0.minimumClientRevision;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err18 = {instancePath:instancePath+"/contract/minimumClientRevision",schemaPath:"#/properties/contract/properties/minimumClientRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err19 = {instancePath:instancePath+"/contract/minimumClientRevision",schemaPath:"#/properties/contract/properties/minimumClientRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
}
else {
const err20 = {instancePath:instancePath+"/contract",schemaPath:"#/properties/contract/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.identity !== undefined){
if(!(validate25(data.identity, {instancePath:instancePath+"/identity",parentData:data,parentDataProperty:"identity",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
errors = vErrors.length;
}
}
if(data.profile !== undefined){
let data6 = data.profile;
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.backend === undefined){
const err21 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data6.storage === undefined){
const err22 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/required",keyword:"required",params:{missingProperty: "storage"},message:"must have required property '"+"storage"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
for(const key2 in data6){
if(!((key2 === "backend") || (key2 === "storage"))){
const err23 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data6.backend !== undefined){
let data7 = data6.backend;
if(!(((((data7 === "datahike") || (data7 === "datomic")) || (data7 === "datalevin")) || (data7 === "jank")) || (data7 === "datascript"))){
const err24 = {instancePath:instancePath+"/profile/backend",schemaPath:"#/properties/profile/properties/backend/enum",keyword:"enum",params:{allowedValues: schema43.properties.profile.properties.backend.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data6.storage !== undefined){
let data8 = data6.storage;
if(!((((data8 === "s3") || (data8 === "dynamodb")) || (data8 === "memory")) || (data8 === "browser-memory"))){
const err25 = {instancePath:instancePath+"/profile/storage",schemaPath:"#/properties/profile/properties/storage/enum",keyword:"enum",params:{allowedValues: schema43.properties.profile.properties.storage.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
else {
const err26 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.runtime !== undefined){
let data9 = data.runtime;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(data9.execution === undefined){
const err27 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/required",keyword:"required",params:{missingProperty: "execution"},message:"must have required property '"+"execution"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data9.name === undefined){
const err28 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(data9.architecture === undefined){
const err29 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/required",keyword:"required",params:{missingProperty: "architecture"},message:"must have required property '"+"architecture"+"'"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(data9.snapStart === undefined){
const err30 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/required",keyword:"required",params:{missingProperty: "snapStart"},message:"must have required property '"+"snapStart"+"'"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
for(const key3 in data9){
if(!((((key3 === "execution") || (key3 === "name")) || (key3 === "architecture")) || (key3 === "snapStart"))){
const err31 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data9.execution !== undefined){
let data10 = data9.execution;
if(!(((data10 === "lambda") || (data10 === "ec2")) || (data10 === "browser"))){
const err32 = {instancePath:instancePath+"/runtime/execution",schemaPath:"#/properties/runtime/properties/execution/enum",keyword:"enum",params:{allowedValues: schema43.properties.runtime.properties.execution.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data9.name !== undefined){
let data11 = data9.name;
if(typeof data11 === "string"){
if(func1(data11) > 64){
const err33 = {instancePath:instancePath+"/runtime/name",schemaPath:"#/properties/runtime/properties/name/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(func1(data11) < 1){
const err34 = {instancePath:instancePath+"/runtime/name",schemaPath:"#/properties/runtime/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/runtime/name",schemaPath:"#/properties/runtime/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data9.architecture !== undefined){
let data12 = data9.architecture;
if(!((((data12 === "arm64") || (data12 === "x86_64")) || (data12 === "wasm32")) || (data12 === "javascript"))){
const err36 = {instancePath:instancePath+"/runtime/architecture",schemaPath:"#/properties/runtime/properties/architecture/enum",keyword:"enum",params:{allowedValues: schema43.properties.runtime.properties.architecture.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data9.snapStart !== undefined){
let data13 = data9.snapStart;
if(!(((data13 === "enabled") || (data13 === "disabled")) || (data13 === "not-applicable"))){
const err37 = {instancePath:instancePath+"/runtime/snapStart",schemaPath:"#/properties/runtime/properties/snapStart/enum",keyword:"enum",params:{allowedValues: schema43.properties.runtime.properties.snapStart.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
else {
const err38 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.capabilities !== undefined){
let data14 = data.capabilities;
if(data14 && typeof data14 == "object" && !Array.isArray(data14)){
if(data14.operations === undefined){
const err39 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "operations"},message:"must have required property '"+"operations"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data14.consistencyModes === undefined){
const err40 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "consistencyModes"},message:"must have required property '"+"consistencyModes"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data14.snapshotBehavior === undefined){
const err41 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "snapshotBehavior"},message:"must have required property '"+"snapshotBehavior"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data14.cacheBehavior === undefined){
const err42 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "cacheBehavior"},message:"must have required property '"+"cacheBehavior"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data14.mutationLocality === undefined){
const err43 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "mutationLocality"},message:"must have required property '"+"mutationLocality"+"'"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if(data14.limitations === undefined){
const err44 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "limitations"},message:"must have required property '"+"limitations"+"'"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
for(const key4 in data14){
if(!((((((key4 === "operations") || (key4 === "consistencyModes")) || (key4 === "snapshotBehavior")) || (key4 === "cacheBehavior")) || (key4 === "mutationLocality")) || (key4 === "limitations"))){
const err45 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key4},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data14.operations !== undefined){
let data15 = data14.operations;
if(Array.isArray(data15)){
if(data15.length > 13){
const err46 = {instancePath:instancePath+"/capabilities/operations",schemaPath:"#/properties/capabilities/properties/operations/maxItems",keyword:"maxItems",params:{limit: 13},message:"must NOT have more than 13 items"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
if(data15.length < 1){
const err47 = {instancePath:instancePath+"/capabilities/operations",schemaPath:"#/properties/capabilities/properties/operations/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
const len0 = data15.length;
for(let i0=0; i0<len0; i0++){
let data16 = data15[i0];
if(!(((((((((((((data16 === "health") || (data16 === "bootstrap")) || (data16 === "list-subjects")) || (data16 === "get-object")) || (data16 === "list-relationships")) || (data16 === "reverse-relationships")) || (data16 === "check-permission")) || (data16 === "lookup-resources")) || (data16 === "lookup-subjects")) || (data16 === "count-resources")) || (data16 === "get-schema")) || (data16 === "get-cache-info")) || (data16 === "count-objects"))){
const err48 = {instancePath:instancePath+"/capabilities/operations/" + i0,schemaPath:"#/properties/capabilities/properties/operations/items/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.operations.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
let i1 = data15.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data15[i1], data15[j0])){
const err49 = {instancePath:instancePath+"/capabilities/operations",schemaPath:"#/properties/capabilities/properties/operations/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err50 = {instancePath:instancePath+"/capabilities/operations",schemaPath:"#/properties/capabilities/properties/operations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data14.consistencyModes !== undefined){
let data17 = data14.consistencyModes;
if(Array.isArray(data17)){
if(data17.length > 6){
const err51 = {instancePath:instancePath+"/capabilities/consistencyModes",schemaPath:"#/properties/capabilities/properties/consistencyModes/maxItems",keyword:"maxItems",params:{limit: 6},message:"must NOT have more than 6 items"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
if(data17.length < 1){
const err52 = {instancePath:instancePath+"/capabilities/consistencyModes",schemaPath:"#/properties/capabilities/properties/consistencyModes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
const len1 = data17.length;
for(let i2=0; i2<len1; i2++){
let data18 = data17[i2];
if(!(((((data18 === "minimize") || (data18 === "authoritative")) || (data18 === "at-least")) || (data18 === "exact")) || (data18 === "historical-date"))){
const err53 = {instancePath:instancePath+"/capabilities/consistencyModes/" + i2,schemaPath:"#/properties/capabilities/properties/consistencyModes/items/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.consistencyModes.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
let i3 = data17.length;
let j1;
if(i3 > 1){
outer1:
for(;i3--;){
for(j1 = i3; j1--;){
if(func0(data17[i3], data17[j1])){
const err54 = {instancePath:instancePath+"/capabilities/consistencyModes",schemaPath:"#/properties/capabilities/properties/consistencyModes/uniqueItems",keyword:"uniqueItems",params:{i: i3, j: j1},message:"must NOT have duplicate items (items ## "+j1+" and "+i3+" are identical)"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
break outer1;
}
}
}
}
}
else {
const err55 = {instancePath:instancePath+"/capabilities/consistencyModes",schemaPath:"#/properties/capabilities/properties/consistencyModes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
if(data14.snapshotBehavior !== undefined){
let data19 = data14.snapshotBehavior;
if(!((((data19 === "fixed-environment") || (data19 === "request-snapshot")) || (data19 === "page-lifecycle")) || (data19 === "rebuild-lifecycle"))){
const err56 = {instancePath:instancePath+"/capabilities/snapshotBehavior",schemaPath:"#/properties/capabilities/properties/snapshotBehavior/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.snapshotBehavior.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
if(data14.cacheBehavior !== undefined){
let data20 = data14.cacheBehavior;
if(!(((((data20 === "none") || (data20 === "request-local")) || (data20 === "environment-local")) || (data20 === "browser-page-local")) || (data20 === "shared-read-through"))){
const err57 = {instancePath:instancePath+"/capabilities/cacheBehavior",schemaPath:"#/properties/capabilities/properties/cacheBehavior/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.cacheBehavior.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
if(data14.mutationLocality !== undefined){
let data21 = data14.mutationLocality;
if(!((((data21 === "none") || (data21 === "private-seed-workflow")) || (data21 === "initialization-before-ready")) || (data21 === "browser-initialization"))){
const err58 = {instancePath:instancePath+"/capabilities/mutationLocality",schemaPath:"#/properties/capabilities/properties/mutationLocality/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.mutationLocality.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
if(data14.limitations !== undefined){
let data22 = data14.limitations;
if(Array.isArray(data22)){
if(data22.length > 16){
const err59 = {instancePath:instancePath+"/capabilities/limitations",schemaPath:"#/properties/capabilities/properties/limitations/maxItems",keyword:"maxItems",params:{limit: 16},message:"must NOT have more than 16 items"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
const len2 = data22.length;
for(let i4=0; i4<len2; i4++){
let data23 = data22[i4];
if(!((((((((((((((((data23 === "read-only") || (data23 === "fixed-current-snapshot")) || (data23 === "no-synchronization")) || (data23 === "no-history-api")) || (data23 === "ephemeral")) || (data23 === "browser-local")) || (data23 === "no-durability")) || (data23 === "datomic-like-not-datomic-pro")) || (data23 === "no-datalog-api")) || (data23 === "no-distribution")) || (data23 === "not-production-database")) || (data23 === "unequal-dataset-scale")) || (data23 === "no-snapstart")) || (data23 === "eventual-storage-read")) || (data23 === "lifecycle-rebuild")) || (data23 === "unsupported-consistency"))){
const err60 = {instancePath:instancePath+"/capabilities/limitations/" + i4,schemaPath:"#/properties/capabilities/properties/limitations/items/enum",keyword:"enum",params:{allowedValues: schema43.properties.capabilities.properties.limitations.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
let i5 = data22.length;
let j2;
if(i5 > 1){
outer2:
for(;i5--;){
for(j2 = i5; j2--;){
if(func0(data22[i5], data22[j2])){
const err61 = {instancePath:instancePath+"/capabilities/limitations",schemaPath:"#/properties/capabilities/properties/limitations/uniqueItems",keyword:"uniqueItems",params:{i: i5, j: j2},message:"must NOT have duplicate items (items ## "+j2+" and "+i5+" are identical)"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
break outer2;
}
}
}
}
}
else {
const err62 = {instancePath:instancePath+"/capabilities/limitations",schemaPath:"#/properties/capabilities/properties/limitations/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
}
}
else {
const err63 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
if(data.limits !== undefined){
let data24 = data.limits;
if(Array.isArray(data24)){
if(data24.length > 32){
const err64 = {instancePath:instancePath+"/limits",schemaPath:"#/properties/limits/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
if(data24.length < 1){
const err65 = {instancePath:instancePath+"/limits",schemaPath:"#/properties/limits/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
const len3 = data24.length;
for(let i6=0; i6<len3; i6++){
let data25 = data24[i6];
if(data25 && typeof data25 == "object" && !Array.isArray(data25)){
if(data25.name === undefined){
const err66 = {instancePath:instancePath+"/limits/" + i6,schemaPath:"#/properties/limits/items/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
if(data25.value === undefined){
const err67 = {instancePath:instancePath+"/limits/" + i6,schemaPath:"#/properties/limits/items/required",keyword:"required",params:{missingProperty: "value"},message:"must have required property '"+"value"+"'"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
for(const key5 in data25){
if(!((key5 === "name") || (key5 === "value"))){
const err68 = {instancePath:instancePath+"/limits/" + i6,schemaPath:"#/properties/limits/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key5},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
}
if(data25.name !== undefined){
if(typeof data25.name !== "string"){
const err69 = {instancePath:instancePath+"/limits/" + i6+"/name",schemaPath:"#/properties/limits/items/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
if(data25.value !== undefined){
let data27 = data25.value;
if(!(((typeof data27 == "number") && (!(data27 % 1) && !isNaN(data27))) && (isFinite(data27)))){
const err70 = {instancePath:instancePath+"/limits/" + i6+"/value",schemaPath:"#/properties/limits/items/properties/value/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
if((typeof data27 == "number") && (isFinite(data27))){
if(data27 < 0 || isNaN(data27)){
const err71 = {instancePath:instancePath+"/limits/" + i6+"/value",schemaPath:"#/properties/limits/items/properties/value/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
}
}
}
else {
const err72 = {instancePath:instancePath+"/limits/" + i6,schemaPath:"#/properties/limits/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
}
else {
const err73 = {instancePath:instancePath+"/limits",schemaPath:"#/properties/limits/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
if(data.dataset !== undefined){
let data28 = data.dataset;
if(data28 && typeof data28 == "object" && !Array.isArray(data28)){
if(data28.fixtureId === undefined){
const err74 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/required",keyword:"required",params:{missingProperty: "fixtureId"},message:"must have required property '"+"fixtureId"+"'"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
if(data28.logicalResourceCount === undefined){
const err75 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/required",keyword:"required",params:{missingProperty: "logicalResourceCount"},message:"must have required property '"+"logicalResourceCount"+"'"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
if(data28.serverCount === undefined){
const err76 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/required",keyword:"required",params:{missingProperty: "serverCount"},message:"must have required property '"+"serverCount"+"'"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
if(data28.manifestSha256 === undefined){
const err77 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/required",keyword:"required",params:{missingProperty: "manifestSha256"},message:"must have required property '"+"manifestSha256"+"'"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
for(const key6 in data28){
if(!((((key6 === "fixtureId") || (key6 === "logicalResourceCount")) || (key6 === "serverCount")) || (key6 === "manifestSha256"))){
const err78 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key6},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
}
if(data28.fixtureId !== undefined){
if(typeof data28.fixtureId !== "string"){
const err79 = {instancePath:instancePath+"/dataset/fixtureId",schemaPath:"#/properties/dataset/properties/fixtureId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
}
if(data28.logicalResourceCount !== undefined){
let data30 = data28.logicalResourceCount;
if(!(((typeof data30 == "number") && (!(data30 % 1) && !isNaN(data30))) && (isFinite(data30)))){
const err80 = {instancePath:instancePath+"/dataset/logicalResourceCount",schemaPath:"#/properties/dataset/properties/logicalResourceCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
if((typeof data30 == "number") && (isFinite(data30))){
if(data30 < 1 || isNaN(data30)){
const err81 = {instancePath:instancePath+"/dataset/logicalResourceCount",schemaPath:"#/properties/dataset/properties/logicalResourceCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
}
}
if(data28.serverCount !== undefined){
let data31 = data28.serverCount;
if(!(((typeof data31 == "number") && (!(data31 % 1) && !isNaN(data31))) && (isFinite(data31)))){
const err82 = {instancePath:instancePath+"/dataset/serverCount",schemaPath:"#/properties/dataset/properties/serverCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err82];
}
else {
vErrors.push(err82);
}
errors++;
}
if((typeof data31 == "number") && (isFinite(data31))){
if(data31 < 1 || isNaN(data31)){
const err83 = {instancePath:instancePath+"/dataset/serverCount",schemaPath:"#/properties/dataset/properties/serverCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err83];
}
else {
vErrors.push(err83);
}
errors++;
}
}
}
if(data28.manifestSha256 !== undefined){
let data32 = data28.manifestSha256;
if(typeof data32 === "string"){
if(!pattern7.test(data32)){
const err84 = {instancePath:instancePath+"/dataset/manifestSha256",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err84];
}
else {
vErrors.push(err84);
}
errors++;
}
}
else {
const err85 = {instancePath:instancePath+"/dataset/manifestSha256",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err85];
}
else {
vErrors.push(err85);
}
errors++;
}
}
}
else {
const err86 = {instancePath:instancePath+"/dataset",schemaPath:"#/properties/dataset/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err86];
}
else {
vErrors.push(err86);
}
errors++;
}
}
if(data.basis !== undefined){
let data33 = data.basis;
if(data33 && typeof data33 == "object" && !Array.isArray(data33)){
if(data33.behavior === undefined){
const err87 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "behavior"},message:"must have required property '"+"behavior"+"'"};
if(vErrors === null){
vErrors = [err87];
}
else {
vErrors.push(err87);
}
errors++;
}
if(data33.id === undefined){
const err88 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err88];
}
else {
vErrors.push(err88);
}
errors++;
}
if(data33.capturedAt === undefined){
const err89 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "capturedAt"},message:"must have required property '"+"capturedAt"+"'"};
if(vErrors === null){
vErrors = [err89];
}
else {
vErrors.push(err89);
}
errors++;
}
if(data33.fixedForEnvironment === undefined){
const err90 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/required",keyword:"required",params:{missingProperty: "fixedForEnvironment"},message:"must have required property '"+"fixedForEnvironment"+"'"};
if(vErrors === null){
vErrors = [err90];
}
else {
vErrors.push(err90);
}
errors++;
}
for(const key7 in data33){
if(!((((key7 === "behavior") || (key7 === "id")) || (key7 === "capturedAt")) || (key7 === "fixedForEnvironment"))){
const err91 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key7},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err91];
}
else {
vErrors.push(err91);
}
errors++;
}
}
if(data33.behavior !== undefined){
let data34 = data33.behavior;
if(!((((data34 === "fixed-environment") || (data34 === "request-snapshot")) || (data34 === "page-lifecycle")) || (data34 === "rebuild-lifecycle"))){
const err92 = {instancePath:instancePath+"/basis/behavior",schemaPath:"#/$defs/basis/properties/behavior/enum",keyword:"enum",params:{allowedValues: schema42.properties.behavior.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err92];
}
else {
vErrors.push(err92);
}
errors++;
}
}
if(data33.id !== undefined){
let data35 = data33.id;
if(typeof data35 === "string"){
if(func1(data35) > 256){
const err93 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err93];
}
else {
vErrors.push(err93);
}
errors++;
}
if(func1(data35) < 1){
const err94 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err94];
}
else {
vErrors.push(err94);
}
errors++;
}
}
else {
const err95 = {instancePath:instancePath+"/basis/id",schemaPath:"#/$defs/basis/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err95];
}
else {
vErrors.push(err95);
}
errors++;
}
}
if(data33.capturedAt !== undefined){
let data36 = data33.capturedAt;
if(typeof data36 === "string"){
if(!(formats0.validate(data36))){
const err96 = {instancePath:instancePath+"/basis/capturedAt",schemaPath:"#/$defs/basis/properties/capturedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err96];
}
else {
vErrors.push(err96);
}
errors++;
}
}
else {
const err97 = {instancePath:instancePath+"/basis/capturedAt",schemaPath:"#/$defs/basis/properties/capturedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err97];
}
else {
vErrors.push(err97);
}
errors++;
}
}
if(data33.fixedForEnvironment !== undefined){
if(typeof data33.fixedForEnvironment !== "boolean"){
const err98 = {instancePath:instancePath+"/basis/fixedForEnvironment",schemaPath:"#/$defs/basis/properties/fixedForEnvironment/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err98];
}
else {
vErrors.push(err98);
}
errors++;
}
}
}
else {
const err99 = {instancePath:instancePath+"/basis",schemaPath:"#/$defs/basis/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err99];
}
else {
vErrors.push(err99);
}
errors++;
}
}
}
else {
const err100 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err100];
}
else {
vErrors.push(err100);
}
errors++;
}
validate60.errors = vErrors;
return errors === 0;
}
validate60.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate59(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/explorer-descriptor.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate59.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate60(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
errors = vErrors.length;
}
validate59.errors = vErrors;
return errors === 0;
}
validate59.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const registry = validate63;
const schema87 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/profile-registry.v1.schema.json","type":"object","additionalProperties":false,"required":["$schema","schema","contractVersion","benchmarkEvidence","storageDefaults","profiles"],"properties":{"$schema":{"const":"../schemas/profile-registry.v1.schema.json"},"schema":{"const":"eacl-demo.profile-registry.v1"},"contractVersion":{"const":"explorer.v1"},"benchmarkEvidence":{"type":"array","items":{"$ref":"#/$defs/evidenceSummary"}},"storageDefaults":{"type":"array","minItems":5,"maxItems":5,"items":{"$ref":"#/$defs/storageDefault"}},"profiles":{"type":"array","minItems":6,"maxItems":6,"items":{"$ref":"#/$defs/profile"}}},"$defs":{"sha1":{"type":["string","null"],"pattern":"^[0-9a-f]{40}$"},"sha256":{"type":["string","null"],"pattern":"^[0-9a-f]{64}$"},"prefixedSha256":{"type":["string","null"],"pattern":"^sha256:[0-9a-f]{64}$"},"evidenceSummary":{"type":"object","additionalProperties":false,"required":["evidenceId","backend","profiles","measuredAt","expiresAt","path","sha256"],"properties":{"evidenceId":{"$ref":"#/$defs/prefixedSha256"},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"profiles":{"type":"array","minItems":2,"uniqueItems":true,"items":{"type":"string"}},"measuredAt":{"type":"string","format":"date-time"},"expiresAt":{"type":"string","format":"date-time"},"path":{"type":"string","pattern":"^registry/benchmark-evidence/[a-z0-9._/-]+\\.json$"},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"}}},"storageDefault":{"type":"object","additionalProperties":false,"required":["outcome","profileId","storage","claim","evidenceId","measuredAt","reason","backend"],"properties":{"outcome":{"enum":["none","sole-qualified","fallback","winner","benchmark-tiebreak"]},"profileId":{"type":["string","null"]},"storage":{"type":["string","null"]},"claim":{"enum":[null,"fastest-qualified","benchmark-selected"]},"evidenceId":{"$ref":"#/$defs/prefixedSha256"},"measuredAt":{"type":["string","null"],"format":"date-time"},"reason":{"type":["string","null"]},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]}}},"profile":{"type":"object","additionalProperties":false,"required":["id","backend","storage","state","reason","route","deployment","lastOutcome"],"allOf":[{"if":{"properties":{"state":{"const":"enabled"}},"required":["state"]},"then":{"properties":{"reason":{"type":"null"},"deployment":{"$ref":"#/$defs/deployment"}}},"else":{"properties":{"reason":{"type":"string","minLength":12,"maxLength":320}}}}],"properties":{"id":{"enum":["datahike-s3","datahike-dynamodb","datomic-dynamodb","datalevin-memory","jank-memory","datascript-browser-memory"]},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"storage":{"enum":["s3","dynamodb","memory","browser-memory"]},"state":{"enum":["enabled","disabled","qualifying","unavailable"]},"reason":{"type":["string","null"]},"route":{"type":"string","pattern":"^/(?:datascript/)?$"},"deployment":{"anyOf":[{"type":"null"},{"$ref":"#/$defs/deployment"}]},"lastOutcome":{"$ref":"#/$defs/outcome"}}},"deployment":{"type":"object","additionalProperties":false,"required":["demoSha","eaclSha","artifact","deploymentId","dataManifestSha256","deployedAt"],"properties":{"demoSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"eaclSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"artifact":{"type":"object","additionalProperties":false,"required":["kind","sha256","version"],"properties":{"kind":{"enum":["static","lambda-version"]},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"version":{"type":"string","minLength":1}}},"deploymentId":{"type":"string","minLength":1},"dataManifestSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"deployedAt":{"type":"string","format":"date-time"}}},"outcome":{"type":"object","additionalProperties":false,"required":["outcome","attemptedDemoSha","attemptedEaclSha","artifactSha256","at","message"],"allOf":[{"if":{"properties":{"outcome":{"const":"never-deployed"}},"required":["outcome"]},"then":{"properties":{"attemptedDemoSha":{"type":"null"},"attemptedEaclSha":{"type":"null"},"artifactSha256":{"type":"null"},"at":{"type":"null"}}},"else":{"properties":{"attemptedDemoSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"attemptedEaclSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"artifactSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"at":{"type":"string","format":"date-time"}}}}],"properties":{"outcome":{"enum":["never-deployed","succeeded","failed","rolled-back"]},"attemptedDemoSha":{"$ref":"#/$defs/sha1"},"attemptedEaclSha":{"$ref":"#/$defs/sha1"},"artifactSha256":{"$ref":"#/$defs/sha256"},"at":{"type":["string","null"],"format":"date-time"},"message":{"type":"string","minLength":1,"maxLength":320}}}}};
const schema88 = {"type":"object","additionalProperties":false,"required":["evidenceId","backend","profiles","measuredAt","expiresAt","path","sha256"],"properties":{"evidenceId":{"$ref":"#/$defs/prefixedSha256"},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"profiles":{"type":"array","minItems":2,"uniqueItems":true,"items":{"type":"string"}},"measuredAt":{"type":"string","format":"date-time"},"expiresAt":{"type":"string","format":"date-time"},"path":{"type":"string","pattern":"^registry/benchmark-evidence/[a-z0-9._/-]+\\.json$"},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"}}};
const schema89 = {"type":["string","null"],"pattern":"^sha256:[0-9a-f]{64}$"};
const pattern29 = new RegExp("^sha256:[0-9a-f]{64}$", "u");
const pattern30 = new RegExp("^registry/benchmark-evidence/[a-z0-9._/-]+\\.json$", "u");

function validate64(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate64.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.evidenceId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "evidenceId"},message:"must have required property '"+"evidenceId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.backend === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.profiles === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profiles"},message:"must have required property '"+"profiles"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.measuredAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "measuredAt"},message:"must have required property '"+"measuredAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.expiresAt === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expiresAt"},message:"must have required property '"+"expiresAt"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.path === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.sha256 === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "evidenceId") || (key0 === "backend")) || (key0 === "profiles")) || (key0 === "measuredAt")) || (key0 === "expiresAt")) || (key0 === "path")) || (key0 === "sha256"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.evidenceId !== undefined){
let data0 = data.evidenceId;
if((typeof data0 !== "string") && (data0 !== null)){
const err8 = {instancePath:instancePath+"/evidenceId",schemaPath:"#/$defs/prefixedSha256/type",keyword:"type",params:{type: schema89.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(typeof data0 === "string"){
if(!pattern29.test(data0)){
const err9 = {instancePath:instancePath+"/evidenceId",schemaPath:"#/$defs/prefixedSha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
if(data.backend !== undefined){
let data1 = data.backend;
if(!(((((data1 === "datahike") || (data1 === "datomic")) || (data1 === "datalevin")) || (data1 === "jank")) || (data1 === "datascript"))){
const err10 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/enum",keyword:"enum",params:{allowedValues: schema88.properties.backend.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.profiles !== undefined){
let data2 = data.profiles;
if(Array.isArray(data2)){
if(data2.length < 2){
const err11 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
if(typeof data2[i0] !== "string"){
const err12 = {instancePath:instancePath+"/profiles/" + i0,schemaPath:"#/properties/profiles/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
let i1 = data2.length;
let j0;
if(i1 > 1){
const indices0 = {};
for(;i1--;){
let item0 = data2[i1];
if(typeof item0 !== "string"){
continue;
}
if(typeof indices0[item0] == "number"){
j0 = indices0[item0];
const err13 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
break;
}
indices0[item0] = i1;
}
}
}
else {
const err14 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.measuredAt !== undefined){
let data4 = data.measuredAt;
if(typeof data4 === "string"){
if(!(formats0.validate(data4))){
const err15 = {instancePath:instancePath+"/measuredAt",schemaPath:"#/properties/measuredAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/measuredAt",schemaPath:"#/properties/measuredAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.expiresAt !== undefined){
let data5 = data.expiresAt;
if(typeof data5 === "string"){
if(!(formats0.validate(data5))){
const err17 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/properties/expiresAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/properties/expiresAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.path !== undefined){
let data6 = data.path;
if(typeof data6 === "string"){
if(!pattern30.test(data6)){
const err19 = {instancePath:instancePath+"/path",schemaPath:"#/properties/path/pattern",keyword:"pattern",params:{pattern: "^registry/benchmark-evidence/[a-z0-9._/-]+\\.json$"},message:"must match pattern \""+"^registry/benchmark-evidence/[a-z0-9._/-]+\\.json$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/path",schemaPath:"#/properties/path/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.sha256 !== undefined){
let data7 = data.sha256;
if(typeof data7 === "string"){
if(!pattern7.test(data7)){
const err21 = {instancePath:instancePath+"/sha256",schemaPath:"#/properties/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/sha256",schemaPath:"#/properties/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate64.errors = vErrors;
return errors === 0;
}
validate64.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema90 = {"type":"object","additionalProperties":false,"required":["outcome","profileId","storage","claim","evidenceId","measuredAt","reason","backend"],"properties":{"outcome":{"enum":["none","sole-qualified","fallback","winner","benchmark-tiebreak"]},"profileId":{"type":["string","null"]},"storage":{"type":["string","null"]},"claim":{"enum":[null,"fastest-qualified","benchmark-selected"]},"evidenceId":{"$ref":"#/$defs/prefixedSha256"},"measuredAt":{"type":["string","null"],"format":"date-time"},"reason":{"type":["string","null"]},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]}}};

function validate66(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate66.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.outcome === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outcome"},message:"must have required property '"+"outcome"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.profileId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profileId"},message:"must have required property '"+"profileId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.storage === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "storage"},message:"must have required property '"+"storage"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.claim === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "claim"},message:"must have required property '"+"claim"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.evidenceId === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "evidenceId"},message:"must have required property '"+"evidenceId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.measuredAt === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "measuredAt"},message:"must have required property '"+"measuredAt"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.reason === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reason"},message:"must have required property '"+"reason"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.backend === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "outcome") || (key0 === "profileId")) || (key0 === "storage")) || (key0 === "claim")) || (key0 === "evidenceId")) || (key0 === "measuredAt")) || (key0 === "reason")) || (key0 === "backend"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.outcome !== undefined){
let data0 = data.outcome;
if(!(((((data0 === "none") || (data0 === "sole-qualified")) || (data0 === "fallback")) || (data0 === "winner")) || (data0 === "benchmark-tiebreak"))){
const err9 = {instancePath:instancePath+"/outcome",schemaPath:"#/properties/outcome/enum",keyword:"enum",params:{allowedValues: schema90.properties.outcome.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.profileId !== undefined){
let data1 = data.profileId;
if((typeof data1 !== "string") && (data1 !== null)){
const err10 = {instancePath:instancePath+"/profileId",schemaPath:"#/properties/profileId/type",keyword:"type",params:{type: schema90.properties.profileId.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.storage !== undefined){
let data2 = data.storage;
if((typeof data2 !== "string") && (data2 !== null)){
const err11 = {instancePath:instancePath+"/storage",schemaPath:"#/properties/storage/type",keyword:"type",params:{type: schema90.properties.storage.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.claim !== undefined){
let data3 = data.claim;
if(!(((data3 === null) || (data3 === "fastest-qualified")) || (data3 === "benchmark-selected"))){
const err12 = {instancePath:instancePath+"/claim",schemaPath:"#/properties/claim/enum",keyword:"enum",params:{allowedValues: schema90.properties.claim.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.evidenceId !== undefined){
let data4 = data.evidenceId;
if((typeof data4 !== "string") && (data4 !== null)){
const err13 = {instancePath:instancePath+"/evidenceId",schemaPath:"#/$defs/prefixedSha256/type",keyword:"type",params:{type: schema89.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(typeof data4 === "string"){
if(!pattern29.test(data4)){
const err14 = {instancePath:instancePath+"/evidenceId",schemaPath:"#/$defs/prefixedSha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.measuredAt !== undefined){
let data5 = data.measuredAt;
if((typeof data5 !== "string") && (data5 !== null)){
const err15 = {instancePath:instancePath+"/measuredAt",schemaPath:"#/properties/measuredAt/type",keyword:"type",params:{type: schema90.properties.measuredAt.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(typeof data5 === "string"){
if(!(formats0.validate(data5))){
const err16 = {instancePath:instancePath+"/measuredAt",schemaPath:"#/properties/measuredAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.reason !== undefined){
let data6 = data.reason;
if((typeof data6 !== "string") && (data6 !== null)){
const err17 = {instancePath:instancePath+"/reason",schemaPath:"#/properties/reason/type",keyword:"type",params:{type: schema90.properties.reason.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.backend !== undefined){
let data7 = data.backend;
if(!(((((data7 === "datahike") || (data7 === "datomic")) || (data7 === "datalevin")) || (data7 === "jank")) || (data7 === "datascript"))){
const err18 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/enum",keyword:"enum",params:{allowedValues: schema90.properties.backend.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
validate66.errors = vErrors;
return errors === 0;
}
validate66.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema92 = {"type":"object","additionalProperties":false,"required":["id","backend","storage","state","reason","route","deployment","lastOutcome"],"allOf":[{"if":{"properties":{"state":{"const":"enabled"}},"required":["state"]},"then":{"properties":{"reason":{"type":"null"},"deployment":{"$ref":"#/$defs/deployment"}}},"else":{"properties":{"reason":{"type":"string","minLength":12,"maxLength":320}}}}],"properties":{"id":{"enum":["datahike-s3","datahike-dynamodb","datomic-dynamodb","datalevin-memory","jank-memory","datascript-browser-memory"]},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"storage":{"enum":["s3","dynamodb","memory","browser-memory"]},"state":{"enum":["enabled","disabled","qualifying","unavailable"]},"reason":{"type":["string","null"]},"route":{"type":"string","pattern":"^/(?:datascript/)?$"},"deployment":{"anyOf":[{"type":"null"},{"$ref":"#/$defs/deployment"}]},"lastOutcome":{"$ref":"#/$defs/outcome"}}};
const schema93 = {"type":"object","additionalProperties":false,"required":["demoSha","eaclSha","artifact","deploymentId","dataManifestSha256","deployedAt"],"properties":{"demoSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"eaclSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"artifact":{"type":"object","additionalProperties":false,"required":["kind","sha256","version"],"properties":{"kind":{"enum":["static","lambda-version"]},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"version":{"type":"string","minLength":1}}},"deploymentId":{"type":"string","minLength":1},"dataManifestSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"deployedAt":{"type":"string","format":"date-time"}}};
const pattern37 = new RegExp("^/(?:datascript/)?$", "u");
const schema95 = {"type":"object","additionalProperties":false,"required":["outcome","attemptedDemoSha","attemptedEaclSha","artifactSha256","at","message"],"allOf":[{"if":{"properties":{"outcome":{"const":"never-deployed"}},"required":["outcome"]},"then":{"properties":{"attemptedDemoSha":{"type":"null"},"attemptedEaclSha":{"type":"null"},"artifactSha256":{"type":"null"},"at":{"type":"null"}}},"else":{"properties":{"attemptedDemoSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"attemptedEaclSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"artifactSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"at":{"type":"string","format":"date-time"}}}}],"properties":{"outcome":{"enum":["never-deployed","succeeded","failed","rolled-back"]},"attemptedDemoSha":{"$ref":"#/$defs/sha1"},"attemptedEaclSha":{"$ref":"#/$defs/sha1"},"artifactSha256":{"$ref":"#/$defs/sha256"},"at":{"type":["string","null"],"format":"date-time"},"message":{"type":"string","minLength":1,"maxLength":320}}};
const schema96 = {"type":["string","null"],"pattern":"^[0-9a-f]{40}$"};
const schema98 = {"type":["string","null"],"pattern":"^[0-9a-f]{64}$"};

function validate69(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate69.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = true;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.outcome === undefined) && (missing0 = "outcome")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
if(data.outcome !== undefined){
if("never-deployed" !== data.outcome){
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
}
var _valid0 = _errs3 === errors;
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.attemptedDemoSha !== undefined){
if(data.attemptedDemoSha !== null){
const err2 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/allOf/0/then/properties/attemptedDemoSha/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.attemptedEaclSha !== undefined){
if(data.attemptedEaclSha !== null){
const err3 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/allOf/0/then/properties/attemptedEaclSha/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.artifactSha256 !== undefined){
if(data.artifactSha256 !== null){
const err4 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/allOf/0/then/properties/artifactSha256/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.at !== undefined){
if(data.at !== null){
const err5 = {instancePath:instancePath+"/at",schemaPath:"#/allOf/0/then/properties/at/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
var _valid0 = _errs5 === errors;
valid1 = _valid0;
if(valid1){
var props0 = {};
props0.attemptedDemoSha = true;
props0.attemptedEaclSha = true;
props0.artifactSha256 = true;
props0.at = true;
props0.outcome = true;
}
ifClause0 = "then";
}
else {
const _errs14 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.attemptedDemoSha !== undefined){
let data5 = data.attemptedDemoSha;
if(typeof data5 === "string"){
if(!pattern5.test(data5)){
const err6 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/allOf/0/else/properties/attemptedDemoSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/allOf/0/else/properties/attemptedDemoSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.attemptedEaclSha !== undefined){
let data6 = data.attemptedEaclSha;
if(typeof data6 === "string"){
if(!pattern5.test(data6)){
const err8 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/allOf/0/else/properties/attemptedEaclSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/allOf/0/else/properties/attemptedEaclSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.artifactSha256 !== undefined){
let data7 = data.artifactSha256;
if(typeof data7 === "string"){
if(!pattern7.test(data7)){
const err10 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/allOf/0/else/properties/artifactSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/allOf/0/else/properties/artifactSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.at !== undefined){
let data8 = data.at;
if(typeof data8 === "string"){
if(!(formats0.validate(data8))){
const err12 = {instancePath:instancePath+"/at",schemaPath:"#/allOf/0/else/properties/at/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/at",schemaPath:"#/allOf/0/else/properties/at/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
var _valid0 = _errs14 === errors;
valid1 = _valid0;
if(valid1){
if(props0 !== true){
props0 = props0 || {};
props0.attemptedDemoSha = true;
props0.attemptedEaclSha = true;
props0.artifactSha256 = true;
props0.at = true;
}
}
ifClause0 = "else";
}
if(!valid1){
const err14 = {instancePath,schemaPath:"#/allOf/0/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.outcome === undefined){
const err15 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outcome"},message:"must have required property '"+"outcome"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data.attemptedDemoSha === undefined){
const err16 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "attemptedDemoSha"},message:"must have required property '"+"attemptedDemoSha"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data.attemptedEaclSha === undefined){
const err17 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "attemptedEaclSha"},message:"must have required property '"+"attemptedEaclSha"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.artifactSha256 === undefined){
const err18 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifactSha256"},message:"must have required property '"+"artifactSha256"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.at === undefined){
const err19 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "at"},message:"must have required property '"+"at"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data.message === undefined){
const err20 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "outcome") || (key0 === "attemptedDemoSha")) || (key0 === "attemptedEaclSha")) || (key0 === "artifactSha256")) || (key0 === "at")) || (key0 === "message"))){
const err21 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.outcome !== undefined){
let data9 = data.outcome;
if(!((((data9 === "never-deployed") || (data9 === "succeeded")) || (data9 === "failed")) || (data9 === "rolled-back"))){
const err22 = {instancePath:instancePath+"/outcome",schemaPath:"#/properties/outcome/enum",keyword:"enum",params:{allowedValues: schema95.properties.outcome.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.attemptedDemoSha !== undefined){
let data10 = data.attemptedDemoSha;
if((typeof data10 !== "string") && (data10 !== null)){
const err23 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/$defs/sha1/type",keyword:"type",params:{type: schema96.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(typeof data10 === "string"){
if(!pattern5.test(data10)){
const err24 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/$defs/sha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
if(data.attemptedEaclSha !== undefined){
let data11 = data.attemptedEaclSha;
if((typeof data11 !== "string") && (data11 !== null)){
const err25 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/$defs/sha1/type",keyword:"type",params:{type: schema96.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(typeof data11 === "string"){
if(!pattern5.test(data11)){
const err26 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/$defs/sha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
if(data.artifactSha256 !== undefined){
let data12 = data.artifactSha256;
if((typeof data12 !== "string") && (data12 !== null)){
const err27 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: schema98.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(typeof data12 === "string"){
if(!pattern7.test(data12)){
const err28 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
if(data.at !== undefined){
let data13 = data.at;
if((typeof data13 !== "string") && (data13 !== null)){
const err29 = {instancePath:instancePath+"/at",schemaPath:"#/properties/at/type",keyword:"type",params:{type: schema95.properties.at.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(typeof data13 === "string"){
if(!(formats0.validate(data13))){
const err30 = {instancePath:instancePath+"/at",schemaPath:"#/properties/at/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
if(data.message !== undefined){
let data14 = data.message;
if(typeof data14 === "string"){
if(func1(data14) > 320){
const err31 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/maxLength",keyword:"maxLength",params:{limit: 320},message:"must NOT have more than 320 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(func1(data14) < 1){
const err32 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
validate69.errors = vErrors;
return errors === 0;
}
validate69.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate68(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate68.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = true;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.state === undefined) && (missing0 = "state")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
if(data.state !== undefined){
if("enabled" !== data.state){
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
}
var _valid0 = _errs3 === errors;
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
if(data.reason !== null){
const err2 = {instancePath:instancePath+"/reason",schemaPath:"#/allOf/0/then/properties/reason/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.deployment !== undefined){
let data2 = data.deployment;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.demoSha === undefined){
const err3 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "demoSha"},message:"must have required property '"+"demoSha"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data2.eaclSha === undefined){
const err4 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "eaclSha"},message:"must have required property '"+"eaclSha"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data2.artifact === undefined){
const err5 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data2.deploymentId === undefined){
const err6 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "deploymentId"},message:"must have required property '"+"deploymentId"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2.dataManifestSha256 === undefined){
const err7 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "dataManifestSha256"},message:"must have required property '"+"dataManifestSha256"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2.deployedAt === undefined){
const err8 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "deployedAt"},message:"must have required property '"+"deployedAt"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data2){
if(!((((((key0 === "demoSha") || (key0 === "eaclSha")) || (key0 === "artifact")) || (key0 === "deploymentId")) || (key0 === "dataManifestSha256")) || (key0 === "deployedAt"))){
const err9 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data2.demoSha !== undefined){
let data3 = data2.demoSha;
if(typeof data3 === "string"){
if(!pattern5.test(data3)){
const err10 = {instancePath:instancePath+"/deployment/demoSha",schemaPath:"#/$defs/deployment/properties/demoSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/deployment/demoSha",schemaPath:"#/$defs/deployment/properties/demoSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data2.eaclSha !== undefined){
let data4 = data2.eaclSha;
if(typeof data4 === "string"){
if(!pattern5.test(data4)){
const err12 = {instancePath:instancePath+"/deployment/eaclSha",schemaPath:"#/$defs/deployment/properties/eaclSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/deployment/eaclSha",schemaPath:"#/$defs/deployment/properties/eaclSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data2.artifact !== undefined){
let data5 = data2.artifact;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.kind === undefined){
const err14 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data5.sha256 === undefined){
const err15 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data5.version === undefined){
const err16 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
for(const key1 in data5){
if(!(((key1 === "kind") || (key1 === "sha256")) || (key1 === "version"))){
const err17 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data5.kind !== undefined){
let data6 = data5.kind;
if(!((data6 === "static") || (data6 === "lambda-version"))){
const err18 = {instancePath:instancePath+"/deployment/artifact/kind",schemaPath:"#/$defs/deployment/properties/artifact/properties/kind/enum",keyword:"enum",params:{allowedValues: schema93.properties.artifact.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data5.sha256 !== undefined){
let data7 = data5.sha256;
if(typeof data7 === "string"){
if(!pattern7.test(data7)){
const err19 = {instancePath:instancePath+"/deployment/artifact/sha256",schemaPath:"#/$defs/deployment/properties/artifact/properties/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/deployment/artifact/sha256",schemaPath:"#/$defs/deployment/properties/artifact/properties/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data5.version !== undefined){
let data8 = data5.version;
if(typeof data8 === "string"){
if(func1(data8) < 1){
const err21 = {instancePath:instancePath+"/deployment/artifact/version",schemaPath:"#/$defs/deployment/properties/artifact/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/deployment/artifact/version",schemaPath:"#/$defs/deployment/properties/artifact/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data2.deploymentId !== undefined){
let data9 = data2.deploymentId;
if(typeof data9 === "string"){
if(func1(data9) < 1){
const err24 = {instancePath:instancePath+"/deployment/deploymentId",schemaPath:"#/$defs/deployment/properties/deploymentId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/deployment/deploymentId",schemaPath:"#/$defs/deployment/properties/deploymentId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data2.dataManifestSha256 !== undefined){
let data10 = data2.dataManifestSha256;
if(typeof data10 === "string"){
if(!pattern7.test(data10)){
const err26 = {instancePath:instancePath+"/deployment/dataManifestSha256",schemaPath:"#/$defs/deployment/properties/dataManifestSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/deployment/dataManifestSha256",schemaPath:"#/$defs/deployment/properties/dataManifestSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data2.deployedAt !== undefined){
let data11 = data2.deployedAt;
if(typeof data11 === "string"){
if(!(formats0.validate(data11))){
const err28 = {instancePath:instancePath+"/deployment/deployedAt",schemaPath:"#/$defs/deployment/properties/deployedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/deployment/deployedAt",schemaPath:"#/$defs/deployment/properties/deployedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
var _valid0 = _errs5 === errors;
valid1 = _valid0;
if(valid1){
var props0 = {};
props0.reason = true;
props0.deployment = true;
props0.state = true;
}
ifClause0 = "then";
}
else {
const _errs30 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
let data12 = data.reason;
if(typeof data12 === "string"){
if(func1(data12) > 320){
const err31 = {instancePath:instancePath+"/reason",schemaPath:"#/allOf/0/else/properties/reason/maxLength",keyword:"maxLength",params:{limit: 320},message:"must NOT have more than 320 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(func1(data12) < 12){
const err32 = {instancePath:instancePath+"/reason",schemaPath:"#/allOf/0/else/properties/reason/minLength",keyword:"minLength",params:{limit: 12},message:"must NOT have fewer than 12 characters"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/reason",schemaPath:"#/allOf/0/else/properties/reason/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
var _valid0 = _errs30 === errors;
valid1 = _valid0;
if(valid1){
if(props0 !== true){
props0 = props0 || {};
props0.reason = true;
}
}
ifClause0 = "else";
}
if(!valid1){
const err34 = {instancePath,schemaPath:"#/allOf/0/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err35 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data.backend === undefined){
const err36 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data.storage === undefined){
const err37 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "storage"},message:"must have required property '"+"storage"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data.state === undefined){
const err38 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "state"},message:"must have required property '"+"state"+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data.reason === undefined){
const err39 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reason"},message:"must have required property '"+"reason"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data.route === undefined){
const err40 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "route"},message:"must have required property '"+"route"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data.deployment === undefined){
const err41 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "deployment"},message:"must have required property '"+"deployment"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data.lastOutcome === undefined){
const err42 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "lastOutcome"},message:"must have required property '"+"lastOutcome"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
for(const key2 in data){
if(!((((((((key2 === "id") || (key2 === "backend")) || (key2 === "storage")) || (key2 === "state")) || (key2 === "reason")) || (key2 === "route")) || (key2 === "deployment")) || (key2 === "lastOutcome"))){
const err43 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.id !== undefined){
let data13 = data.id;
if(!((((((data13 === "datahike-s3") || (data13 === "datahike-dynamodb")) || (data13 === "datomic-dynamodb")) || (data13 === "datalevin-memory")) || (data13 === "jank-memory")) || (data13 === "datascript-browser-memory"))){
const err44 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/enum",keyword:"enum",params:{allowedValues: schema92.properties.id.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data.backend !== undefined){
let data14 = data.backend;
if(!(((((data14 === "datahike") || (data14 === "datomic")) || (data14 === "datalevin")) || (data14 === "jank")) || (data14 === "datascript"))){
const err45 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/enum",keyword:"enum",params:{allowedValues: schema92.properties.backend.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data.storage !== undefined){
let data15 = data.storage;
if(!((((data15 === "s3") || (data15 === "dynamodb")) || (data15 === "memory")) || (data15 === "browser-memory"))){
const err46 = {instancePath:instancePath+"/storage",schemaPath:"#/properties/storage/enum",keyword:"enum",params:{allowedValues: schema92.properties.storage.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data.state !== undefined){
let data16 = data.state;
if(!((((data16 === "enabled") || (data16 === "disabled")) || (data16 === "qualifying")) || (data16 === "unavailable"))){
const err47 = {instancePath:instancePath+"/state",schemaPath:"#/properties/state/enum",keyword:"enum",params:{allowedValues: schema92.properties.state.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data.reason !== undefined){
let data17 = data.reason;
if((typeof data17 !== "string") && (data17 !== null)){
const err48 = {instancePath:instancePath+"/reason",schemaPath:"#/properties/reason/type",keyword:"type",params:{type: schema92.properties.reason.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data.route !== undefined){
let data18 = data.route;
if(typeof data18 === "string"){
if(!pattern37.test(data18)){
const err49 = {instancePath:instancePath+"/route",schemaPath:"#/properties/route/pattern",keyword:"pattern",params:{pattern: "^/(?:datascript/)?$"},message:"must match pattern \""+"^/(?:datascript/)?$"+"\""};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
else {
const err50 = {instancePath:instancePath+"/route",schemaPath:"#/properties/route/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data.deployment !== undefined){
let data19 = data.deployment;
const _errs43 = errors;
let valid9 = false;
const _errs44 = errors;
if(data19 !== null){
const err51 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/anyOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
var _valid1 = _errs44 === errors;
valid9 = valid9 || _valid1;
const _errs46 = errors;
if(data19 && typeof data19 == "object" && !Array.isArray(data19)){
if(data19.demoSha === undefined){
const err52 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "demoSha"},message:"must have required property '"+"demoSha"+"'"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
if(data19.eaclSha === undefined){
const err53 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "eaclSha"},message:"must have required property '"+"eaclSha"+"'"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
if(data19.artifact === undefined){
const err54 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
if(data19.deploymentId === undefined){
const err55 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "deploymentId"},message:"must have required property '"+"deploymentId"+"'"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
if(data19.dataManifestSha256 === undefined){
const err56 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "dataManifestSha256"},message:"must have required property '"+"dataManifestSha256"+"'"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
if(data19.deployedAt === undefined){
const err57 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "deployedAt"},message:"must have required property '"+"deployedAt"+"'"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
for(const key3 in data19){
if(!((((((key3 === "demoSha") || (key3 === "eaclSha")) || (key3 === "artifact")) || (key3 === "deploymentId")) || (key3 === "dataManifestSha256")) || (key3 === "deployedAt"))){
const err58 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
if(data19.demoSha !== undefined){
let data20 = data19.demoSha;
if(typeof data20 === "string"){
if(!pattern5.test(data20)){
const err59 = {instancePath:instancePath+"/deployment/demoSha",schemaPath:"#/$defs/deployment/properties/demoSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
else {
const err60 = {instancePath:instancePath+"/deployment/demoSha",schemaPath:"#/$defs/deployment/properties/demoSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
if(data19.eaclSha !== undefined){
let data21 = data19.eaclSha;
if(typeof data21 === "string"){
if(!pattern5.test(data21)){
const err61 = {instancePath:instancePath+"/deployment/eaclSha",schemaPath:"#/$defs/deployment/properties/eaclSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
else {
const err62 = {instancePath:instancePath+"/deployment/eaclSha",schemaPath:"#/$defs/deployment/properties/eaclSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
}
if(data19.artifact !== undefined){
let data22 = data19.artifact;
if(data22 && typeof data22 == "object" && !Array.isArray(data22)){
if(data22.kind === undefined){
const err63 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
if(data22.sha256 === undefined){
const err64 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
if(data22.version === undefined){
const err65 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
for(const key4 in data22){
if(!(((key4 === "kind") || (key4 === "sha256")) || (key4 === "version"))){
const err66 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key4},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
if(data22.kind !== undefined){
let data23 = data22.kind;
if(!((data23 === "static") || (data23 === "lambda-version"))){
const err67 = {instancePath:instancePath+"/deployment/artifact/kind",schemaPath:"#/$defs/deployment/properties/artifact/properties/kind/enum",keyword:"enum",params:{allowedValues: schema93.properties.artifact.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
}
if(data22.sha256 !== undefined){
let data24 = data22.sha256;
if(typeof data24 === "string"){
if(!pattern7.test(data24)){
const err68 = {instancePath:instancePath+"/deployment/artifact/sha256",schemaPath:"#/$defs/deployment/properties/artifact/properties/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
}
else {
const err69 = {instancePath:instancePath+"/deployment/artifact/sha256",schemaPath:"#/$defs/deployment/properties/artifact/properties/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
if(data22.version !== undefined){
let data25 = data22.version;
if(typeof data25 === "string"){
if(func1(data25) < 1){
const err70 = {instancePath:instancePath+"/deployment/artifact/version",schemaPath:"#/$defs/deployment/properties/artifact/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
else {
const err71 = {instancePath:instancePath+"/deployment/artifact/version",schemaPath:"#/$defs/deployment/properties/artifact/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
}
}
else {
const err72 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
if(data19.deploymentId !== undefined){
let data26 = data19.deploymentId;
if(typeof data26 === "string"){
if(func1(data26) < 1){
const err73 = {instancePath:instancePath+"/deployment/deploymentId",schemaPath:"#/$defs/deployment/properties/deploymentId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
else {
const err74 = {instancePath:instancePath+"/deployment/deploymentId",schemaPath:"#/$defs/deployment/properties/deploymentId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
if(data19.dataManifestSha256 !== undefined){
let data27 = data19.dataManifestSha256;
if(typeof data27 === "string"){
if(!pattern7.test(data27)){
const err75 = {instancePath:instancePath+"/deployment/dataManifestSha256",schemaPath:"#/$defs/deployment/properties/dataManifestSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
}
else {
const err76 = {instancePath:instancePath+"/deployment/dataManifestSha256",schemaPath:"#/$defs/deployment/properties/dataManifestSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
}
if(data19.deployedAt !== undefined){
let data28 = data19.deployedAt;
if(typeof data28 === "string"){
if(!(formats0.validate(data28))){
const err77 = {instancePath:instancePath+"/deployment/deployedAt",schemaPath:"#/$defs/deployment/properties/deployedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
}
else {
const err78 = {instancePath:instancePath+"/deployment/deployedAt",schemaPath:"#/$defs/deployment/properties/deployedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
}
}
else {
const err79 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
var _valid1 = _errs46 === errors;
valid9 = valid9 || _valid1;
if(!valid9){
const err80 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
else {
errors = _errs43;
if(vErrors !== null){
if(_errs43){
vErrors.length = _errs43;
}
else {
vErrors = null;
}
}
}
}
if(data.lastOutcome !== undefined){
if(!(validate69(data.lastOutcome, {instancePath:instancePath+"/lastOutcome",parentData:data,parentDataProperty:"lastOutcome",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate69.errors : vErrors.concat(validate69.errors);
errors = vErrors.length;
}
}
}
else {
const err81 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
validate68.errors = vErrors;
return errors === 0;
}
validate68.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate63(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/profile-registry.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate63.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.schema === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.contractVersion === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contractVersion"},message:"must have required property '"+"contractVersion"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.benchmarkEvidence === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "benchmarkEvidence"},message:"must have required property '"+"benchmarkEvidence"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.storageDefaults === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "storageDefaults"},message:"must have required property '"+"storageDefaults"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.profiles === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profiles"},message:"must have required property '"+"profiles"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "$schema") || (key0 === "schema")) || (key0 === "contractVersion")) || (key0 === "benchmarkEvidence")) || (key0 === "storageDefaults")) || (key0 === "profiles"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("../schemas/profile-registry.v1.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "../schemas/profile-registry.v1.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.schema !== undefined){
if("eacl-demo.profile-registry.v1" !== data.schema){
const err8 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/const",keyword:"const",params:{allowedValue: "eacl-demo.profile-registry.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.contractVersion !== undefined){
if("explorer.v1" !== data.contractVersion){
const err9 = {instancePath:instancePath+"/contractVersion",schemaPath:"#/properties/contractVersion/const",keyword:"const",params:{allowedValue: "explorer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.benchmarkEvidence !== undefined){
let data3 = data.benchmarkEvidence;
if(Array.isArray(data3)){
const len0 = data3.length;
for(let i0=0; i0<len0; i0++){
if(!(validate64(data3[i0], {instancePath:instancePath+"/benchmarkEvidence/" + i0,parentData:data3,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
errors = vErrors.length;
}
}
}
else {
const err10 = {instancePath:instancePath+"/benchmarkEvidence",schemaPath:"#/properties/benchmarkEvidence/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.storageDefaults !== undefined){
let data5 = data.storageDefaults;
if(Array.isArray(data5)){
if(data5.length > 5){
const err11 = {instancePath:instancePath+"/storageDefaults",schemaPath:"#/properties/storageDefaults/maxItems",keyword:"maxItems",params:{limit: 5},message:"must NOT have more than 5 items"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data5.length < 5){
const err12 = {instancePath:instancePath+"/storageDefaults",schemaPath:"#/properties/storageDefaults/minItems",keyword:"minItems",params:{limit: 5},message:"must NOT have fewer than 5 items"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
const len1 = data5.length;
for(let i1=0; i1<len1; i1++){
if(!(validate66(data5[i1], {instancePath:instancePath+"/storageDefaults/" + i1,parentData:data5,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate66.errors : vErrors.concat(validate66.errors);
errors = vErrors.length;
}
}
}
else {
const err13 = {instancePath:instancePath+"/storageDefaults",schemaPath:"#/properties/storageDefaults/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.profiles !== undefined){
let data7 = data.profiles;
if(Array.isArray(data7)){
if(data7.length > 6){
const err14 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/maxItems",keyword:"maxItems",params:{limit: 6},message:"must NOT have more than 6 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data7.length < 6){
const err15 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/minItems",keyword:"minItems",params:{limit: 6},message:"must NOT have fewer than 6 items"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
const len2 = data7.length;
for(let i2=0; i2<len2; i2++){
if(!(validate68(data7[i2], {instancePath:instancePath+"/profiles/" + i2,parentData:data7,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
errors = vErrors.length;
}
}
}
else {
const err16 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate63.errors = vErrors;
return errors === 0;
}
validate63.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const profilePublication = validate72;
const schema99 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/profile-publication.v1.schema.json","type":"object","additionalProperties":false,"required":["$schema","schema","contractVersion","publicationId","publishedAt","gate","profile"],"properties":{"$schema":{"const":"../../schemas/profile-publication.v1.schema.json"},"schema":{"const":"eacl-demo.profile-publication.v1"},"contractVersion":{"const":"explorer.v1"},"publicationId":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"publishedAt":{"type":"string","format":"date-time"},"gate":{"oneOf":[{"type":"object","additionalProperties":false,"required":["kind","evidenceId"],"properties":{"kind":{"enum":["initial-qualification","merge-smoke","demo-smoke"]},"evidenceId":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"}}},{"type":"object","additionalProperties":false,"required":["kind","evidenceId"],"properties":{"kind":{"const":"failure-outcome"},"evidenceId":{"type":"null"}}}]},"profile":{"$ref":"#/$defs/profile"}},"$defs":{"nullableSha1":{"type":["string","null"],"pattern":"^[0-9a-f]{40}$"},"nullableSha256":{"type":["string","null"],"pattern":"^[0-9a-f]{64}$"},"profile":{"type":"object","additionalProperties":false,"required":["id","backend","storage","state","reason","route","deployment","lastOutcome"],"allOf":[{"if":{"properties":{"state":{"const":"enabled"}},"required":["state"]},"then":{"properties":{"reason":{"type":"null"},"deployment":{"$ref":"#/$defs/deployment"}}},"else":{"properties":{"reason":{"type":"string","minLength":12,"maxLength":320}}}}],"properties":{"id":{"enum":["datahike-s3","datahike-dynamodb","datomic-dynamodb","datalevin-memory","jank-memory","datascript-browser-memory"]},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"storage":{"enum":["s3","dynamodb","memory","browser-memory"]},"state":{"enum":["enabled","disabled","qualifying","unavailable"]},"reason":{"type":["string","null"],"maxLength":320},"route":{"type":"string","pattern":"^/(?:datascript/)?$"},"deployment":{"anyOf":[{"type":"null"},{"$ref":"#/$defs/deployment"}]},"lastOutcome":{"$ref":"#/$defs/outcome"}}},"deployment":{"type":"object","additionalProperties":false,"required":["demoSha","eaclSha","artifact","deploymentId","dataManifestSha256","deployedAt"],"properties":{"demoSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"eaclSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"artifact":{"type":"object","additionalProperties":false,"required":["kind","sha256","version"],"properties":{"kind":{"enum":["static","lambda-version"]},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"version":{"type":"string","minLength":1}}},"deploymentId":{"type":"string","minLength":1},"dataManifestSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"deployedAt":{"type":"string","format":"date-time"}}},"outcome":{"type":"object","additionalProperties":false,"required":["outcome","attemptedDemoSha","attemptedEaclSha","artifactSha256","at","message"],"allOf":[{"if":{"properties":{"outcome":{"const":"never-deployed"}},"required":["outcome"]},"then":{"properties":{"attemptedDemoSha":{"type":"null"},"attemptedEaclSha":{"type":"null"},"artifactSha256":{"type":"null"},"at":{"type":"null"}}},"else":{"properties":{"attemptedDemoSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"attemptedEaclSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"artifactSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"at":{"type":"string","format":"date-time"}}}}],"properties":{"outcome":{"enum":["never-deployed","succeeded","failed","rolled-back"]},"attemptedDemoSha":{"$ref":"#/$defs/nullableSha1"},"attemptedEaclSha":{"$ref":"#/$defs/nullableSha1"},"artifactSha256":{"$ref":"#/$defs/nullableSha256"},"at":{"type":["string","null"],"format":"date-time"},"message":{"type":"string","minLength":1,"maxLength":320}}}}};
const schema100 = {"type":"object","additionalProperties":false,"required":["id","backend","storage","state","reason","route","deployment","lastOutcome"],"allOf":[{"if":{"properties":{"state":{"const":"enabled"}},"required":["state"]},"then":{"properties":{"reason":{"type":"null"},"deployment":{"$ref":"#/$defs/deployment"}}},"else":{"properties":{"reason":{"type":"string","minLength":12,"maxLength":320}}}}],"properties":{"id":{"enum":["datahike-s3","datahike-dynamodb","datomic-dynamodb","datalevin-memory","jank-memory","datascript-browser-memory"]},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"storage":{"enum":["s3","dynamodb","memory","browser-memory"]},"state":{"enum":["enabled","disabled","qualifying","unavailable"]},"reason":{"type":["string","null"],"maxLength":320},"route":{"type":"string","pattern":"^/(?:datascript/)?$"},"deployment":{"anyOf":[{"type":"null"},{"$ref":"#/$defs/deployment"}]},"lastOutcome":{"$ref":"#/$defs/outcome"}}};
const schema101 = {"type":"object","additionalProperties":false,"required":["demoSha","eaclSha","artifact","deploymentId","dataManifestSha256","deployedAt"],"properties":{"demoSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"eaclSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"artifact":{"type":"object","additionalProperties":false,"required":["kind","sha256","version"],"properties":{"kind":{"enum":["static","lambda-version"]},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"version":{"type":"string","minLength":1}}},"deploymentId":{"type":"string","minLength":1},"dataManifestSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"deployedAt":{"type":"string","format":"date-time"}}};
const schema103 = {"type":"object","additionalProperties":false,"required":["outcome","attemptedDemoSha","attemptedEaclSha","artifactSha256","at","message"],"allOf":[{"if":{"properties":{"outcome":{"const":"never-deployed"}},"required":["outcome"]},"then":{"properties":{"attemptedDemoSha":{"type":"null"},"attemptedEaclSha":{"type":"null"},"artifactSha256":{"type":"null"},"at":{"type":"null"}}},"else":{"properties":{"attemptedDemoSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"attemptedEaclSha":{"type":"string","pattern":"^[0-9a-f]{40}$"},"artifactSha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"at":{"type":"string","format":"date-time"}}}}],"properties":{"outcome":{"enum":["never-deployed","succeeded","failed","rolled-back"]},"attemptedDemoSha":{"$ref":"#/$defs/nullableSha1"},"attemptedEaclSha":{"$ref":"#/$defs/nullableSha1"},"artifactSha256":{"$ref":"#/$defs/nullableSha256"},"at":{"type":["string","null"],"format":"date-time"},"message":{"type":"string","minLength":1,"maxLength":320}}};
const schema104 = {"type":["string","null"],"pattern":"^[0-9a-f]{40}$"};
const schema106 = {"type":["string","null"],"pattern":"^[0-9a-f]{64}$"};

function validate74(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate74.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = true;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.outcome === undefined) && (missing0 = "outcome")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
if(data.outcome !== undefined){
if("never-deployed" !== data.outcome){
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
}
var _valid0 = _errs3 === errors;
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.attemptedDemoSha !== undefined){
if(data.attemptedDemoSha !== null){
const err2 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/allOf/0/then/properties/attemptedDemoSha/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.attemptedEaclSha !== undefined){
if(data.attemptedEaclSha !== null){
const err3 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/allOf/0/then/properties/attemptedEaclSha/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.artifactSha256 !== undefined){
if(data.artifactSha256 !== null){
const err4 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/allOf/0/then/properties/artifactSha256/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.at !== undefined){
if(data.at !== null){
const err5 = {instancePath:instancePath+"/at",schemaPath:"#/allOf/0/then/properties/at/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
var _valid0 = _errs5 === errors;
valid1 = _valid0;
if(valid1){
var props0 = {};
props0.attemptedDemoSha = true;
props0.attemptedEaclSha = true;
props0.artifactSha256 = true;
props0.at = true;
props0.outcome = true;
}
ifClause0 = "then";
}
else {
const _errs14 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.attemptedDemoSha !== undefined){
let data5 = data.attemptedDemoSha;
if(typeof data5 === "string"){
if(!pattern5.test(data5)){
const err6 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/allOf/0/else/properties/attemptedDemoSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/allOf/0/else/properties/attemptedDemoSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.attemptedEaclSha !== undefined){
let data6 = data.attemptedEaclSha;
if(typeof data6 === "string"){
if(!pattern5.test(data6)){
const err8 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/allOf/0/else/properties/attemptedEaclSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/allOf/0/else/properties/attemptedEaclSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.artifactSha256 !== undefined){
let data7 = data.artifactSha256;
if(typeof data7 === "string"){
if(!pattern7.test(data7)){
const err10 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/allOf/0/else/properties/artifactSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/allOf/0/else/properties/artifactSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.at !== undefined){
let data8 = data.at;
if(typeof data8 === "string"){
if(!(formats0.validate(data8))){
const err12 = {instancePath:instancePath+"/at",schemaPath:"#/allOf/0/else/properties/at/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/at",schemaPath:"#/allOf/0/else/properties/at/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
var _valid0 = _errs14 === errors;
valid1 = _valid0;
if(valid1){
if(props0 !== true){
props0 = props0 || {};
props0.attemptedDemoSha = true;
props0.attemptedEaclSha = true;
props0.artifactSha256 = true;
props0.at = true;
}
}
ifClause0 = "else";
}
if(!valid1){
const err14 = {instancePath,schemaPath:"#/allOf/0/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.outcome === undefined){
const err15 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outcome"},message:"must have required property '"+"outcome"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data.attemptedDemoSha === undefined){
const err16 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "attemptedDemoSha"},message:"must have required property '"+"attemptedDemoSha"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data.attemptedEaclSha === undefined){
const err17 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "attemptedEaclSha"},message:"must have required property '"+"attemptedEaclSha"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.artifactSha256 === undefined){
const err18 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifactSha256"},message:"must have required property '"+"artifactSha256"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.at === undefined){
const err19 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "at"},message:"must have required property '"+"at"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data.message === undefined){
const err20 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "outcome") || (key0 === "attemptedDemoSha")) || (key0 === "attemptedEaclSha")) || (key0 === "artifactSha256")) || (key0 === "at")) || (key0 === "message"))){
const err21 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.outcome !== undefined){
let data9 = data.outcome;
if(!((((data9 === "never-deployed") || (data9 === "succeeded")) || (data9 === "failed")) || (data9 === "rolled-back"))){
const err22 = {instancePath:instancePath+"/outcome",schemaPath:"#/properties/outcome/enum",keyword:"enum",params:{allowedValues: schema103.properties.outcome.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.attemptedDemoSha !== undefined){
let data10 = data.attemptedDemoSha;
if((typeof data10 !== "string") && (data10 !== null)){
const err23 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/$defs/nullableSha1/type",keyword:"type",params:{type: schema104.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(typeof data10 === "string"){
if(!pattern5.test(data10)){
const err24 = {instancePath:instancePath+"/attemptedDemoSha",schemaPath:"#/$defs/nullableSha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
if(data.attemptedEaclSha !== undefined){
let data11 = data.attemptedEaclSha;
if((typeof data11 !== "string") && (data11 !== null)){
const err25 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/$defs/nullableSha1/type",keyword:"type",params:{type: schema104.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(typeof data11 === "string"){
if(!pattern5.test(data11)){
const err26 = {instancePath:instancePath+"/attemptedEaclSha",schemaPath:"#/$defs/nullableSha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
if(data.artifactSha256 !== undefined){
let data12 = data.artifactSha256;
if((typeof data12 !== "string") && (data12 !== null)){
const err27 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/$defs/nullableSha256/type",keyword:"type",params:{type: schema106.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(typeof data12 === "string"){
if(!pattern7.test(data12)){
const err28 = {instancePath:instancePath+"/artifactSha256",schemaPath:"#/$defs/nullableSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
if(data.at !== undefined){
let data13 = data.at;
if((typeof data13 !== "string") && (data13 !== null)){
const err29 = {instancePath:instancePath+"/at",schemaPath:"#/properties/at/type",keyword:"type",params:{type: schema103.properties.at.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(typeof data13 === "string"){
if(!(formats0.validate(data13))){
const err30 = {instancePath:instancePath+"/at",schemaPath:"#/properties/at/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
if(data.message !== undefined){
let data14 = data.message;
if(typeof data14 === "string"){
if(func1(data14) > 320){
const err31 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/maxLength",keyword:"maxLength",params:{limit: 320},message:"must NOT have more than 320 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(func1(data14) < 1){
const err32 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/message",schemaPath:"#/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
validate74.errors = vErrors;
return errors === 0;
}
validate74.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate73(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate73.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs2 = errors;
let valid1 = true;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.state === undefined) && (missing0 = "state")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
if(data.state !== undefined){
if("enabled" !== data.state){
const err1 = {};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
}
}
var _valid0 = _errs3 === errors;
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
let ifClause0;
if(_valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
if(data.reason !== null){
const err2 = {instancePath:instancePath+"/reason",schemaPath:"#/allOf/0/then/properties/reason/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.deployment !== undefined){
let data2 = data.deployment;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.demoSha === undefined){
const err3 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "demoSha"},message:"must have required property '"+"demoSha"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data2.eaclSha === undefined){
const err4 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "eaclSha"},message:"must have required property '"+"eaclSha"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data2.artifact === undefined){
const err5 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data2.deploymentId === undefined){
const err6 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "deploymentId"},message:"must have required property '"+"deploymentId"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data2.dataManifestSha256 === undefined){
const err7 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "dataManifestSha256"},message:"must have required property '"+"dataManifestSha256"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data2.deployedAt === undefined){
const err8 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "deployedAt"},message:"must have required property '"+"deployedAt"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data2){
if(!((((((key0 === "demoSha") || (key0 === "eaclSha")) || (key0 === "artifact")) || (key0 === "deploymentId")) || (key0 === "dataManifestSha256")) || (key0 === "deployedAt"))){
const err9 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data2.demoSha !== undefined){
let data3 = data2.demoSha;
if(typeof data3 === "string"){
if(!pattern5.test(data3)){
const err10 = {instancePath:instancePath+"/deployment/demoSha",schemaPath:"#/$defs/deployment/properties/demoSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/deployment/demoSha",schemaPath:"#/$defs/deployment/properties/demoSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data2.eaclSha !== undefined){
let data4 = data2.eaclSha;
if(typeof data4 === "string"){
if(!pattern5.test(data4)){
const err12 = {instancePath:instancePath+"/deployment/eaclSha",schemaPath:"#/$defs/deployment/properties/eaclSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/deployment/eaclSha",schemaPath:"#/$defs/deployment/properties/eaclSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data2.artifact !== undefined){
let data5 = data2.artifact;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.kind === undefined){
const err14 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data5.sha256 === undefined){
const err15 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data5.version === undefined){
const err16 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
for(const key1 in data5){
if(!(((key1 === "kind") || (key1 === "sha256")) || (key1 === "version"))){
const err17 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data5.kind !== undefined){
let data6 = data5.kind;
if(!((data6 === "static") || (data6 === "lambda-version"))){
const err18 = {instancePath:instancePath+"/deployment/artifact/kind",schemaPath:"#/$defs/deployment/properties/artifact/properties/kind/enum",keyword:"enum",params:{allowedValues: schema101.properties.artifact.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data5.sha256 !== undefined){
let data7 = data5.sha256;
if(typeof data7 === "string"){
if(!pattern7.test(data7)){
const err19 = {instancePath:instancePath+"/deployment/artifact/sha256",schemaPath:"#/$defs/deployment/properties/artifact/properties/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/deployment/artifact/sha256",schemaPath:"#/$defs/deployment/properties/artifact/properties/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data5.version !== undefined){
let data8 = data5.version;
if(typeof data8 === "string"){
if(func1(data8) < 1){
const err21 = {instancePath:instancePath+"/deployment/artifact/version",schemaPath:"#/$defs/deployment/properties/artifact/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/deployment/artifact/version",schemaPath:"#/$defs/deployment/properties/artifact/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data2.deploymentId !== undefined){
let data9 = data2.deploymentId;
if(typeof data9 === "string"){
if(func1(data9) < 1){
const err24 = {instancePath:instancePath+"/deployment/deploymentId",schemaPath:"#/$defs/deployment/properties/deploymentId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/deployment/deploymentId",schemaPath:"#/$defs/deployment/properties/deploymentId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data2.dataManifestSha256 !== undefined){
let data10 = data2.dataManifestSha256;
if(typeof data10 === "string"){
if(!pattern7.test(data10)){
const err26 = {instancePath:instancePath+"/deployment/dataManifestSha256",schemaPath:"#/$defs/deployment/properties/dataManifestSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/deployment/dataManifestSha256",schemaPath:"#/$defs/deployment/properties/dataManifestSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data2.deployedAt !== undefined){
let data11 = data2.deployedAt;
if(typeof data11 === "string"){
if(!(formats0.validate(data11))){
const err28 = {instancePath:instancePath+"/deployment/deployedAt",schemaPath:"#/$defs/deployment/properties/deployedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/deployment/deployedAt",schemaPath:"#/$defs/deployment/properties/deployedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
var _valid0 = _errs5 === errors;
valid1 = _valid0;
if(valid1){
var props0 = {};
props0.reason = true;
props0.deployment = true;
props0.state = true;
}
ifClause0 = "then";
}
else {
const _errs30 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.reason !== undefined){
let data12 = data.reason;
if(typeof data12 === "string"){
if(func1(data12) > 320){
const err31 = {instancePath:instancePath+"/reason",schemaPath:"#/allOf/0/else/properties/reason/maxLength",keyword:"maxLength",params:{limit: 320},message:"must NOT have more than 320 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(func1(data12) < 12){
const err32 = {instancePath:instancePath+"/reason",schemaPath:"#/allOf/0/else/properties/reason/minLength",keyword:"minLength",params:{limit: 12},message:"must NOT have fewer than 12 characters"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/reason",schemaPath:"#/allOf/0/else/properties/reason/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
var _valid0 = _errs30 === errors;
valid1 = _valid0;
if(valid1){
if(props0 !== true){
props0 = props0 || {};
props0.reason = true;
}
}
ifClause0 = "else";
}
if(!valid1){
const err34 = {instancePath,schemaPath:"#/allOf/0/if",keyword:"if",params:{failingKeyword: ifClause0},message:"must match \""+ifClause0+"\" schema"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err35 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data.backend === undefined){
const err36 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data.storage === undefined){
const err37 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "storage"},message:"must have required property '"+"storage"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data.state === undefined){
const err38 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "state"},message:"must have required property '"+"state"+"'"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if(data.reason === undefined){
const err39 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "reason"},message:"must have required property '"+"reason"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data.route === undefined){
const err40 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "route"},message:"must have required property '"+"route"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data.deployment === undefined){
const err41 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "deployment"},message:"must have required property '"+"deployment"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data.lastOutcome === undefined){
const err42 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "lastOutcome"},message:"must have required property '"+"lastOutcome"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
for(const key2 in data){
if(!((((((((key2 === "id") || (key2 === "backend")) || (key2 === "storage")) || (key2 === "state")) || (key2 === "reason")) || (key2 === "route")) || (key2 === "deployment")) || (key2 === "lastOutcome"))){
const err43 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data.id !== undefined){
let data13 = data.id;
if(!((((((data13 === "datahike-s3") || (data13 === "datahike-dynamodb")) || (data13 === "datomic-dynamodb")) || (data13 === "datalevin-memory")) || (data13 === "jank-memory")) || (data13 === "datascript-browser-memory"))){
const err44 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/enum",keyword:"enum",params:{allowedValues: schema100.properties.id.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data.backend !== undefined){
let data14 = data.backend;
if(!(((((data14 === "datahike") || (data14 === "datomic")) || (data14 === "datalevin")) || (data14 === "jank")) || (data14 === "datascript"))){
const err45 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/enum",keyword:"enum",params:{allowedValues: schema100.properties.backend.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data.storage !== undefined){
let data15 = data.storage;
if(!((((data15 === "s3") || (data15 === "dynamodb")) || (data15 === "memory")) || (data15 === "browser-memory"))){
const err46 = {instancePath:instancePath+"/storage",schemaPath:"#/properties/storage/enum",keyword:"enum",params:{allowedValues: schema100.properties.storage.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data.state !== undefined){
let data16 = data.state;
if(!((((data16 === "enabled") || (data16 === "disabled")) || (data16 === "qualifying")) || (data16 === "unavailable"))){
const err47 = {instancePath:instancePath+"/state",schemaPath:"#/properties/state/enum",keyword:"enum",params:{allowedValues: schema100.properties.state.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data.reason !== undefined){
let data17 = data.reason;
if((typeof data17 !== "string") && (data17 !== null)){
const err48 = {instancePath:instancePath+"/reason",schemaPath:"#/properties/reason/type",keyword:"type",params:{type: schema100.properties.reason.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(typeof data17 === "string"){
if(func1(data17) > 320){
const err49 = {instancePath:instancePath+"/reason",schemaPath:"#/properties/reason/maxLength",keyword:"maxLength",params:{limit: 320},message:"must NOT have more than 320 characters"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
}
if(data.route !== undefined){
let data18 = data.route;
if(typeof data18 === "string"){
if(!pattern37.test(data18)){
const err50 = {instancePath:instancePath+"/route",schemaPath:"#/properties/route/pattern",keyword:"pattern",params:{pattern: "^/(?:datascript/)?$"},message:"must match pattern \""+"^/(?:datascript/)?$"+"\""};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
else {
const err51 = {instancePath:instancePath+"/route",schemaPath:"#/properties/route/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data.deployment !== undefined){
let data19 = data.deployment;
const _errs43 = errors;
let valid9 = false;
const _errs44 = errors;
if(data19 !== null){
const err52 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/anyOf/0/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
var _valid1 = _errs44 === errors;
valid9 = valid9 || _valid1;
const _errs46 = errors;
if(data19 && typeof data19 == "object" && !Array.isArray(data19)){
if(data19.demoSha === undefined){
const err53 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "demoSha"},message:"must have required property '"+"demoSha"+"'"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
if(data19.eaclSha === undefined){
const err54 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "eaclSha"},message:"must have required property '"+"eaclSha"+"'"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
if(data19.artifact === undefined){
const err55 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "artifact"},message:"must have required property '"+"artifact"+"'"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
if(data19.deploymentId === undefined){
const err56 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "deploymentId"},message:"must have required property '"+"deploymentId"+"'"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
if(data19.dataManifestSha256 === undefined){
const err57 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "dataManifestSha256"},message:"must have required property '"+"dataManifestSha256"+"'"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
if(data19.deployedAt === undefined){
const err58 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/required",keyword:"required",params:{missingProperty: "deployedAt"},message:"must have required property '"+"deployedAt"+"'"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
for(const key3 in data19){
if(!((((((key3 === "demoSha") || (key3 === "eaclSha")) || (key3 === "artifact")) || (key3 === "deploymentId")) || (key3 === "dataManifestSha256")) || (key3 === "deployedAt"))){
const err59 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
if(data19.demoSha !== undefined){
let data20 = data19.demoSha;
if(typeof data20 === "string"){
if(!pattern5.test(data20)){
const err60 = {instancePath:instancePath+"/deployment/demoSha",schemaPath:"#/$defs/deployment/properties/demoSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
else {
const err61 = {instancePath:instancePath+"/deployment/demoSha",schemaPath:"#/$defs/deployment/properties/demoSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
if(data19.eaclSha !== undefined){
let data21 = data19.eaclSha;
if(typeof data21 === "string"){
if(!pattern5.test(data21)){
const err62 = {instancePath:instancePath+"/deployment/eaclSha",schemaPath:"#/$defs/deployment/properties/eaclSha/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
}
else {
const err63 = {instancePath:instancePath+"/deployment/eaclSha",schemaPath:"#/$defs/deployment/properties/eaclSha/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
if(data19.artifact !== undefined){
let data22 = data19.artifact;
if(data22 && typeof data22 == "object" && !Array.isArray(data22)){
if(data22.kind === undefined){
const err64 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
if(data22.sha256 === undefined){
const err65 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
if(data22.version === undefined){
const err66 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
for(const key4 in data22){
if(!(((key4 === "kind") || (key4 === "sha256")) || (key4 === "version"))){
const err67 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key4},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
}
if(data22.kind !== undefined){
let data23 = data22.kind;
if(!((data23 === "static") || (data23 === "lambda-version"))){
const err68 = {instancePath:instancePath+"/deployment/artifact/kind",schemaPath:"#/$defs/deployment/properties/artifact/properties/kind/enum",keyword:"enum",params:{allowedValues: schema101.properties.artifact.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
}
if(data22.sha256 !== undefined){
let data24 = data22.sha256;
if(typeof data24 === "string"){
if(!pattern7.test(data24)){
const err69 = {instancePath:instancePath+"/deployment/artifact/sha256",schemaPath:"#/$defs/deployment/properties/artifact/properties/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
}
else {
const err70 = {instancePath:instancePath+"/deployment/artifact/sha256",schemaPath:"#/$defs/deployment/properties/artifact/properties/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
if(data22.version !== undefined){
let data25 = data22.version;
if(typeof data25 === "string"){
if(func1(data25) < 1){
const err71 = {instancePath:instancePath+"/deployment/artifact/version",schemaPath:"#/$defs/deployment/properties/artifact/properties/version/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
}
else {
const err72 = {instancePath:instancePath+"/deployment/artifact/version",schemaPath:"#/$defs/deployment/properties/artifact/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
}
else {
const err73 = {instancePath:instancePath+"/deployment/artifact",schemaPath:"#/$defs/deployment/properties/artifact/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
if(data19.deploymentId !== undefined){
let data26 = data19.deploymentId;
if(typeof data26 === "string"){
if(func1(data26) < 1){
const err74 = {instancePath:instancePath+"/deployment/deploymentId",schemaPath:"#/$defs/deployment/properties/deploymentId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
else {
const err75 = {instancePath:instancePath+"/deployment/deploymentId",schemaPath:"#/$defs/deployment/properties/deploymentId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
}
if(data19.dataManifestSha256 !== undefined){
let data27 = data19.dataManifestSha256;
if(typeof data27 === "string"){
if(!pattern7.test(data27)){
const err76 = {instancePath:instancePath+"/deployment/dataManifestSha256",schemaPath:"#/$defs/deployment/properties/dataManifestSha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
}
else {
const err77 = {instancePath:instancePath+"/deployment/dataManifestSha256",schemaPath:"#/$defs/deployment/properties/dataManifestSha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
}
if(data19.deployedAt !== undefined){
let data28 = data19.deployedAt;
if(typeof data28 === "string"){
if(!(formats0.validate(data28))){
const err78 = {instancePath:instancePath+"/deployment/deployedAt",schemaPath:"#/$defs/deployment/properties/deployedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
}
else {
const err79 = {instancePath:instancePath+"/deployment/deployedAt",schemaPath:"#/$defs/deployment/properties/deployedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
}
}
else {
const err80 = {instancePath:instancePath+"/deployment",schemaPath:"#/$defs/deployment/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
var _valid1 = _errs46 === errors;
valid9 = valid9 || _valid1;
if(!valid9){
const err81 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
else {
errors = _errs43;
if(vErrors !== null){
if(_errs43){
vErrors.length = _errs43;
}
else {
vErrors = null;
}
}
}
}
if(data.lastOutcome !== undefined){
if(!(validate74(data.lastOutcome, {instancePath:instancePath+"/lastOutcome",parentData:data,parentDataProperty:"lastOutcome",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate74.errors : vErrors.concat(validate74.errors);
errors = vErrors.length;
}
}
}
else {
const err82 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err82];
}
else {
vErrors.push(err82);
}
errors++;
}
validate73.errors = vErrors;
return errors === 0;
}
validate73.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate72(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/profile-publication.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate72.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.schema === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.contractVersion === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contractVersion"},message:"must have required property '"+"contractVersion"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.publicationId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publicationId"},message:"must have required property '"+"publicationId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.publishedAt === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publishedAt"},message:"must have required property '"+"publishedAt"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.gate === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "gate"},message:"must have required property '"+"gate"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.profile === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "$schema") || (key0 === "schema")) || (key0 === "contractVersion")) || (key0 === "publicationId")) || (key0 === "publishedAt")) || (key0 === "gate")) || (key0 === "profile"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.$schema !== undefined){
if("../../schemas/profile-publication.v1.schema.json" !== data.$schema){
const err8 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "../../schemas/profile-publication.v1.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.schema !== undefined){
if("eacl-demo.profile-publication.v1" !== data.schema){
const err9 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/const",keyword:"const",params:{allowedValue: "eacl-demo.profile-publication.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.contractVersion !== undefined){
if("explorer.v1" !== data.contractVersion){
const err10 = {instancePath:instancePath+"/contractVersion",schemaPath:"#/properties/contractVersion/const",keyword:"const",params:{allowedValue: "explorer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.publicationId !== undefined){
let data3 = data.publicationId;
if(typeof data3 === "string"){
if(!pattern29.test(data3)){
const err11 = {instancePath:instancePath+"/publicationId",schemaPath:"#/properties/publicationId/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/publicationId",schemaPath:"#/properties/publicationId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.publishedAt !== undefined){
let data4 = data.publishedAt;
if(typeof data4 === "string"){
if(!(formats0.validate(data4))){
const err13 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/properties/publishedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/properties/publishedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.gate !== undefined){
let data5 = data.gate;
const _errs10 = errors;
let valid1 = false;
let passing0 = null;
const _errs11 = errors;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.kind === undefined){
const err15 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf/0/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data5.evidenceId === undefined){
const err16 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf/0/required",keyword:"required",params:{missingProperty: "evidenceId"},message:"must have required property '"+"evidenceId"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
for(const key1 in data5){
if(!((key1 === "kind") || (key1 === "evidenceId"))){
const err17 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf/0/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data5.kind !== undefined){
let data6 = data5.kind;
if(!(((data6 === "initial-qualification") || (data6 === "merge-smoke")) || (data6 === "demo-smoke"))){
const err18 = {instancePath:instancePath+"/gate/kind",schemaPath:"#/properties/gate/oneOf/0/properties/kind/enum",keyword:"enum",params:{allowedValues: schema99.properties.gate.oneOf[0].properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data5.evidenceId !== undefined){
let data7 = data5.evidenceId;
if(typeof data7 === "string"){
if(!pattern29.test(data7)){
const err19 = {instancePath:instancePath+"/gate/evidenceId",schemaPath:"#/properties/gate/oneOf/0/properties/evidenceId/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/gate/evidenceId",schemaPath:"#/properties/gate/oneOf/0/properties/evidenceId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf/0/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
var _valid0 = _errs11 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
var props0 = true;
}
const _errs17 = errors;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.kind === undefined){
const err22 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5.evidenceId === undefined){
const err23 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf/1/required",keyword:"required",params:{missingProperty: "evidenceId"},message:"must have required property '"+"evidenceId"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key2 in data5){
if(!((key2 === "kind") || (key2 === "evidenceId"))){
const err24 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data5.kind !== undefined){
if("failure-outcome" !== data5.kind){
const err25 = {instancePath:instancePath+"/gate/kind",schemaPath:"#/properties/gate/oneOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "failure-outcome"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data5.evidenceId !== undefined){
if(data5.evidenceId !== null){
const err26 = {instancePath:instancePath+"/gate/evidenceId",schemaPath:"#/properties/gate/oneOf/1/properties/evidenceId/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
var _valid0 = _errs17 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid1){
const err28 = {instancePath:instancePath+"/gate",schemaPath:"#/properties/gate/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
else {
errors = _errs10;
if(vErrors !== null){
if(_errs10){
vErrors.length = _errs10;
}
else {
vErrors = null;
}
}
}
}
if(data.profile !== undefined){
if(!(validate73(data.profile, {instancePath:instancePath+"/profile",parentData:data,parentDataProperty:"profile",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate73.errors : vErrors.concat(validate73.errors);
errors = vErrors.length;
}
}
}
else {
const err29 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
validate72.errors = vErrors;
return errors === 0;
}
validate72.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const benchmarkIndex = validate77;
const schema107 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/benchmark-evidence-index.v1.schema.json","type":"object","additionalProperties":false,"required":["$schema","schema","contractVersion","indexId","publishedAt","evidence"],"properties":{"$schema":{"const":"../../schemas/benchmark-evidence-index.v1.schema.json"},"schema":{"const":"eacl-demo.benchmark-evidence-index.v1"},"contractVersion":{"const":"explorer.v1"},"indexId":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"publishedAt":{"type":"string","format":"date-time"},"evidence":{"type":"array","maxItems":32,"items":{"$ref":"#/$defs/summary"}}},"$defs":{"summary":{"type":"object","additionalProperties":false,"required":["evidenceId","backend","profiles","measuredAt","expiresAt","path","sha256"],"properties":{"evidenceId":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"profiles":{"type":"array","minItems":2,"uniqueItems":true,"items":{"type":"string"}},"measuredAt":{"type":"string","format":"date-time"},"expiresAt":{"type":"string","format":"date-time"},"path":{"type":"string","pattern":"^registry/benchmark-evidence/[a-z0-9][a-z0-9._-]*\\.json$"},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"}}}}};
const schema108 = {"type":"object","additionalProperties":false,"required":["evidenceId","backend","profiles","measuredAt","expiresAt","path","sha256"],"properties":{"evidenceId":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"backend":{"enum":["datahike","datomic","datalevin","jank","datascript"]},"profiles":{"type":"array","minItems":2,"uniqueItems":true,"items":{"type":"string"}},"measuredAt":{"type":"string","format":"date-time"},"expiresAt":{"type":"string","format":"date-time"},"path":{"type":"string","pattern":"^registry/benchmark-evidence/[a-z0-9][a-z0-9._-]*\\.json$"},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"}}};
const pattern67 = new RegExp("^registry/benchmark-evidence/[a-z0-9][a-z0-9._-]*\\.json$", "u");

function validate77(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/benchmark-evidence-index.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate77.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.$schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "$schema"},message:"must have required property '"+"$schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.schema === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.contractVersion === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contractVersion"},message:"must have required property '"+"contractVersion"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.indexId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "indexId"},message:"must have required property '"+"indexId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.publishedAt === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publishedAt"},message:"must have required property '"+"publishedAt"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.evidence === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "evidence"},message:"must have required property '"+"evidence"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "$schema") || (key0 === "schema")) || (key0 === "contractVersion")) || (key0 === "indexId")) || (key0 === "publishedAt")) || (key0 === "evidence"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.$schema !== undefined){
if("../../schemas/benchmark-evidence-index.v1.schema.json" !== data.$schema){
const err7 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/const",keyword:"const",params:{allowedValue: "../../schemas/benchmark-evidence-index.v1.schema.json"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.schema !== undefined){
if("eacl-demo.benchmark-evidence-index.v1" !== data.schema){
const err8 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/const",keyword:"const",params:{allowedValue: "eacl-demo.benchmark-evidence-index.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.contractVersion !== undefined){
if("explorer.v1" !== data.contractVersion){
const err9 = {instancePath:instancePath+"/contractVersion",schemaPath:"#/properties/contractVersion/const",keyword:"const",params:{allowedValue: "explorer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.indexId !== undefined){
let data3 = data.indexId;
if(typeof data3 === "string"){
if(!pattern29.test(data3)){
const err10 = {instancePath:instancePath+"/indexId",schemaPath:"#/properties/indexId/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/indexId",schemaPath:"#/properties/indexId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.publishedAt !== undefined){
let data4 = data.publishedAt;
if(typeof data4 === "string"){
if(!(formats0.validate(data4))){
const err12 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/properties/publishedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/properties/publishedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.evidence !== undefined){
let data5 = data.evidence;
if(Array.isArray(data5)){
if(data5.length > 32){
const err14 = {instancePath:instancePath+"/evidence",schemaPath:"#/properties/evidence/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
const len0 = data5.length;
for(let i0=0; i0<len0; i0++){
let data6 = data5[i0];
if(data6 && typeof data6 == "object" && !Array.isArray(data6)){
if(data6.evidenceId === undefined){
const err15 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/required",keyword:"required",params:{missingProperty: "evidenceId"},message:"must have required property '"+"evidenceId"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data6.backend === undefined){
const err16 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data6.profiles === undefined){
const err17 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/required",keyword:"required",params:{missingProperty: "profiles"},message:"must have required property '"+"profiles"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data6.measuredAt === undefined){
const err18 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/required",keyword:"required",params:{missingProperty: "measuredAt"},message:"must have required property '"+"measuredAt"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data6.expiresAt === undefined){
const err19 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/required",keyword:"required",params:{missingProperty: "expiresAt"},message:"must have required property '"+"expiresAt"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data6.path === undefined){
const err20 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data6.sha256 === undefined){
const err21 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
for(const key1 in data6){
if(!(((((((key1 === "evidenceId") || (key1 === "backend")) || (key1 === "profiles")) || (key1 === "measuredAt")) || (key1 === "expiresAt")) || (key1 === "path")) || (key1 === "sha256"))){
const err22 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data6.evidenceId !== undefined){
let data7 = data6.evidenceId;
if(typeof data7 === "string"){
if(!pattern29.test(data7)){
const err23 = {instancePath:instancePath+"/evidence/" + i0+"/evidenceId",schemaPath:"#/$defs/summary/properties/evidenceId/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/evidence/" + i0+"/evidenceId",schemaPath:"#/$defs/summary/properties/evidenceId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data6.backend !== undefined){
let data8 = data6.backend;
if(!(((((data8 === "datahike") || (data8 === "datomic")) || (data8 === "datalevin")) || (data8 === "jank")) || (data8 === "datascript"))){
const err25 = {instancePath:instancePath+"/evidence/" + i0+"/backend",schemaPath:"#/$defs/summary/properties/backend/enum",keyword:"enum",params:{allowedValues: schema108.properties.backend.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data6.profiles !== undefined){
let data9 = data6.profiles;
if(Array.isArray(data9)){
if(data9.length < 2){
const err26 = {instancePath:instancePath+"/evidence/" + i0+"/profiles",schemaPath:"#/$defs/summary/properties/profiles/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
const len1 = data9.length;
for(let i1=0; i1<len1; i1++){
if(typeof data9[i1] !== "string"){
const err27 = {instancePath:instancePath+"/evidence/" + i0+"/profiles/" + i1,schemaPath:"#/$defs/summary/properties/profiles/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
let i2 = data9.length;
let j0;
if(i2 > 1){
const indices0 = {};
for(;i2--;){
let item0 = data9[i2];
if(typeof item0 !== "string"){
continue;
}
if(typeof indices0[item0] == "number"){
j0 = indices0[item0];
const err28 = {instancePath:instancePath+"/evidence/" + i0+"/profiles",schemaPath:"#/$defs/summary/properties/profiles/uniqueItems",keyword:"uniqueItems",params:{i: i2, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i2+" are identical)"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
break;
}
indices0[item0] = i2;
}
}
}
else {
const err29 = {instancePath:instancePath+"/evidence/" + i0+"/profiles",schemaPath:"#/$defs/summary/properties/profiles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data6.measuredAt !== undefined){
let data11 = data6.measuredAt;
if(typeof data11 === "string"){
if(!(formats0.validate(data11))){
const err30 = {instancePath:instancePath+"/evidence/" + i0+"/measuredAt",schemaPath:"#/$defs/summary/properties/measuredAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
else {
const err31 = {instancePath:instancePath+"/evidence/" + i0+"/measuredAt",schemaPath:"#/$defs/summary/properties/measuredAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data6.expiresAt !== undefined){
let data12 = data6.expiresAt;
if(typeof data12 === "string"){
if(!(formats0.validate(data12))){
const err32 = {instancePath:instancePath+"/evidence/" + i0+"/expiresAt",schemaPath:"#/$defs/summary/properties/expiresAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/evidence/" + i0+"/expiresAt",schemaPath:"#/$defs/summary/properties/expiresAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data6.path !== undefined){
let data13 = data6.path;
if(typeof data13 === "string"){
if(!pattern67.test(data13)){
const err34 = {instancePath:instancePath+"/evidence/" + i0+"/path",schemaPath:"#/$defs/summary/properties/path/pattern",keyword:"pattern",params:{pattern: "^registry/benchmark-evidence/[a-z0-9][a-z0-9._-]*\\.json$"},message:"must match pattern \""+"^registry/benchmark-evidence/[a-z0-9][a-z0-9._-]*\\.json$"+"\""};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/evidence/" + i0+"/path",schemaPath:"#/$defs/summary/properties/path/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data6.sha256 !== undefined){
let data14 = data6.sha256;
if(typeof data14 === "string"){
if(!pattern7.test(data14)){
const err36 = {instancePath:instancePath+"/evidence/" + i0+"/sha256",schemaPath:"#/$defs/summary/properties/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/evidence/" + i0+"/sha256",schemaPath:"#/$defs/summary/properties/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
else {
const err38 = {instancePath:instancePath+"/evidence/" + i0,schemaPath:"#/$defs/summary/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
}
else {
const err39 = {instancePath:instancePath+"/evidence",schemaPath:"#/properties/evidence/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
else {
const err40 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
validate77.errors = vErrors;
return errors === 0;
}
validate77.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const fastestEvidence = validate78;
const schema109 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/fastest-storage-evidence.v1.schema.json","type":"object","additionalProperties":false,"required":["schema","evidenceId","methodVersion","backend","profiles","fixture","workload","environment","repetitions","measuredAt","expiresAt","candidates","results","decision"],"properties":{"schema":{"const":"eacl-demo.fastest-storage-evidence.v1"},"evidenceId":{"$ref":"#/$defs/digest"},"methodVersion":{"const":"datahike-storage-million.v1"},"backend":{"const":"datahike"},"profiles":{"const":["datahike-s3","datahike-dynamodb"]},"fixture":{"$ref":"#/$defs/fixture"},"workload":{"$ref":"#/$defs/workload"},"environment":{"$ref":"#/$defs/environment"},"repetitions":{"$ref":"#/$defs/repetitions"},"measuredAt":{"type":"string","format":"date-time"},"expiresAt":{"type":"string","format":"date-time"},"candidates":{"type":"array","minItems":2,"maxItems":2,"items":{"$ref":"#/$defs/candidate"}},"results":{"type":"array","minItems":2,"maxItems":2,"items":{"$ref":"#/$defs/result"}},"decision":{"$ref":"#/$defs/decision"}},"$defs":{"sha1":{"type":"string","pattern":"^[0-9a-f]{40}$"},"digest":{"type":"string","pattern":"^sha256:[0-9a-f]{64}$"},"fixture":{"type":"object","additionalProperties":false,"required":["id","manifestDigest","fixtureDigest","schemaDigest","logicalResourceCount"],"properties":{"id":{"const":"eacl-demo-fixture-v1"},"manifestDigest":{"$ref":"#/$defs/digest"},"fixtureDigest":{"$ref":"#/$defs/digest"},"schemaDigest":{"$ref":"#/$defs/digest"},"logicalResourceCount":{"const":1000000}}},"workload":{"type":"object","additionalProperties":false,"required":["id","digest","requestsPerWave","operationWeights","cacheLanesDigest"],"properties":{"id":{"const":"datahike-storage-million-v1"},"digest":{"$ref":"#/$defs/digest"},"requestsPerWave":{"const":100},"cacheLanesDigest":{"$ref":"#/$defs/digest"},"operationWeights":{"type":"object","additionalProperties":false,"required":["checkPermission","bootstrap","countObjects","getObject","getSchema","listRelationships","listSubjects","reverseRelationships"],"properties":{"checkPermission":{"const":40},"bootstrap":{"const":5},"countObjects":{"const":10},"getObject":{"const":10},"getSchema":{"const":5},"listRelationships":{"const":15},"listSubjects":{"const":5},"reverseRelationships":{"const":10}}}}},"environment":{"type":"object","additionalProperties":false,"required":["region","runtime","architecture","memoryMb","snapStart","timeoutSeconds","ephemeralStorageMiB","productionPath"],"properties":{"region":{"const":"us-east-1"},"runtime":{"const":"java25"},"architecture":{"const":"arm64"},"memoryMb":{"type":"integer","minimum":1},"snapStart":{"enum":["None","PublishedVersions"]},"timeoutSeconds":{"type":"integer","minimum":1},"ephemeralStorageMiB":{"type":"integer","minimum":1},"productionPath":{"const":"function-url-v2"}}},"repetitions":{"type":"object","additionalProperties":false,"required":["coldOrRestore","warmWavesPerLane","concurrency","bootstrapResamples"],"properties":{"coldOrRestore":{"type":"integer","minimum":30},"warmWavesPerLane":{"type":"integer","minimum":30},"concurrency":{"const":[1,8]},"bootstrapResamples":{"const":10000}}},"candidate":{"type":"object","additionalProperties":false,"required":["profileId","storage","demoSha","eaclSha","artifactDigest","deploymentId","serviceCodeDigest","dataLifecycleId","dataManifestDigest","qualificationEvidenceId","qualificationExpiresAt","qualificationPassing","contractVersion","region","runtime","architecture","memoryMb","snapStart","timeoutSeconds","ephemeralStorageMiB","workloadDigest","cacheLanesDigest"],"properties":{"profileId":{"enum":["datahike-s3","datahike-dynamodb"]},"storage":{"enum":["s3","dynamodb"]},"demoSha":{"$ref":"#/$defs/sha1"},"eaclSha":{"$ref":"#/$defs/sha1"},"artifactDigest":{"$ref":"#/$defs/digest"},"deploymentId":{"type":"string","minLength":1,"maxLength":256},"serviceCodeDigest":{"$ref":"#/$defs/digest"},"dataLifecycleId":{"type":"string","minLength":1,"maxLength":256},"dataManifestDigest":{"$ref":"#/$defs/digest"},"qualificationEvidenceId":{"$ref":"#/$defs/digest"},"qualificationExpiresAt":{"type":"string","format":"date-time"},"qualificationPassing":{"const":true},"contractVersion":{"const":"explorer.v1"},"region":{"const":"us-east-1"},"runtime":{"const":"java25"},"architecture":{"const":"arm64"},"memoryMb":{"type":"integer","minimum":1},"snapStart":{"enum":["None","PublishedVersions"]},"timeoutSeconds":{"type":"integer","minimum":1},"ephemeralStorageMiB":{"type":"integer","minimum":1},"workloadDigest":{"$ref":"#/$defs/digest"},"cacheLanesDigest":{"$ref":"#/$defs/digest"}}},"result":{"type":"object","additionalProperties":false,"required":["profileId","warmWeightedP95Ms","coldOrRestoreP95Ms","warmP95Ci95Ms","coldP95Ci95Ms","errorRate","projectedMonthlyUsd","warmSamples","coldSamples"],"properties":{"profileId":{"enum":["datahike-s3","datahike-dynamodb"]},"warmWeightedP95Ms":{"type":"number","minimum":0},"coldOrRestoreP95Ms":{"type":"number","minimum":0},"warmP95Ci95Ms":{"$ref":"#/$defs/interval"},"coldP95Ci95Ms":{"$ref":"#/$defs/interval"},"errorRate":{"const":0},"projectedMonthlyUsd":{"type":"number","minimum":0},"warmSamples":{"type":"integer","minimum":6000},"coldSamples":{"type":"integer","minimum":30}}},"interval":{"type":"array","minItems":2,"maxItems":2,"items":{"type":"number","minimum":0}},"decision":{"type":"object","additionalProperties":false,"required":["outcome","defaultProfileId","selectionBasis","primaryMetric","minimumEffectFraction","tieBreakOrder"],"properties":{"outcome":{"enum":["winner","benchmark-tiebreak","unresolved"]},"defaultProfileId":{"enum":["datahike-s3","datahike-dynamodb",null]},"selectionBasis":{"enum":["warm-cache-disabled-p95","cold-or-restore-p95","projected-monthly-cost","none"]},"primaryMetric":{"const":"operation-weighted-warm-cache-disabled-service-p95-ms"},"minimumEffectFraction":{"const":0.05},"tieBreakOrder":{"const":["cold-or-restore-p95-ms","projected-monthly-usd"]}}}}};
const schema110 = {"type":"string","pattern":"^sha256:[0-9a-f]{64}$"};
const schema118 = {"type":"object","additionalProperties":false,"required":["region","runtime","architecture","memoryMb","snapStart","timeoutSeconds","ephemeralStorageMiB","productionPath"],"properties":{"region":{"const":"us-east-1"},"runtime":{"const":"java25"},"architecture":{"const":"arm64"},"memoryMb":{"type":"integer","minimum":1},"snapStart":{"enum":["None","PublishedVersions"]},"timeoutSeconds":{"type":"integer","minimum":1},"ephemeralStorageMiB":{"type":"integer","minimum":1},"productionPath":{"const":"function-url-v2"}}};
const schema119 = {"type":"object","additionalProperties":false,"required":["coldOrRestore","warmWavesPerLane","concurrency","bootstrapResamples"],"properties":{"coldOrRestore":{"type":"integer","minimum":30},"warmWavesPerLane":{"type":"integer","minimum":30},"concurrency":{"const":[1,8]},"bootstrapResamples":{"const":10000}}};
const schema132 = {"type":"object","additionalProperties":false,"required":["outcome","defaultProfileId","selectionBasis","primaryMetric","minimumEffectFraction","tieBreakOrder"],"properties":{"outcome":{"enum":["winner","benchmark-tiebreak","unresolved"]},"defaultProfileId":{"enum":["datahike-s3","datahike-dynamodb",null]},"selectionBasis":{"enum":["warm-cache-disabled-p95","cold-or-restore-p95","projected-monthly-cost","none"]},"primaryMetric":{"const":"operation-weighted-warm-cache-disabled-service-p95-ms"},"minimumEffectFraction":{"const":0.05},"tieBreakOrder":{"const":["cold-or-restore-p95-ms","projected-monthly-usd"]}}};
const func89 = Object.prototype.hasOwnProperty;
const schema111 = {"type":"object","additionalProperties":false,"required":["id","manifestDigest","fixtureDigest","schemaDigest","logicalResourceCount"],"properties":{"id":{"const":"eacl-demo-fixture-v1"},"manifestDigest":{"$ref":"#/$defs/digest"},"fixtureDigest":{"$ref":"#/$defs/digest"},"schemaDigest":{"$ref":"#/$defs/digest"},"logicalResourceCount":{"const":1000000}}};

function validate79(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate79.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.manifestDigest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "manifestDigest"},message:"must have required property '"+"manifestDigest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.fixtureDigest === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fixtureDigest"},message:"must have required property '"+"fixtureDigest"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.schemaDigest === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaDigest"},message:"must have required property '"+"schemaDigest"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.logicalResourceCount === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "logicalResourceCount"},message:"must have required property '"+"logicalResourceCount"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "manifestDigest")) || (key0 === "fixtureDigest")) || (key0 === "schemaDigest")) || (key0 === "logicalResourceCount"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
if("eacl-demo-fixture-v1" !== data.id){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/const",keyword:"const",params:{allowedValue: "eacl-demo-fixture-v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.manifestDigest !== undefined){
let data1 = data.manifestDigest;
if(typeof data1 === "string"){
if(!pattern29.test(data1)){
const err7 = {instancePath:instancePath+"/manifestDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/manifestDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.fixtureDigest !== undefined){
let data2 = data.fixtureDigest;
if(typeof data2 === "string"){
if(!pattern29.test(data2)){
const err9 = {instancePath:instancePath+"/fixtureDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/fixtureDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.schemaDigest !== undefined){
let data3 = data.schemaDigest;
if(typeof data3 === "string"){
if(!pattern29.test(data3)){
const err11 = {instancePath:instancePath+"/schemaDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/schemaDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.logicalResourceCount !== undefined){
if(1000000 !== data.logicalResourceCount){
const err13 = {instancePath:instancePath+"/logicalResourceCount",schemaPath:"#/properties/logicalResourceCount/const",keyword:"const",params:{allowedValue: 1000000},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate79.errors = vErrors;
return errors === 0;
}
validate79.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema115 = {"type":"object","additionalProperties":false,"required":["id","digest","requestsPerWave","operationWeights","cacheLanesDigest"],"properties":{"id":{"const":"datahike-storage-million-v1"},"digest":{"$ref":"#/$defs/digest"},"requestsPerWave":{"const":100},"cacheLanesDigest":{"$ref":"#/$defs/digest"},"operationWeights":{"type":"object","additionalProperties":false,"required":["checkPermission","bootstrap","countObjects","getObject","getSchema","listRelationships","listSubjects","reverseRelationships"],"properties":{"checkPermission":{"const":40},"bootstrap":{"const":5},"countObjects":{"const":10},"getObject":{"const":10},"getSchema":{"const":5},"listRelationships":{"const":15},"listSubjects":{"const":5},"reverseRelationships":{"const":10}}}}};

function validate81(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate81.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.digest === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "digest"},message:"must have required property '"+"digest"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.requestsPerWave === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "requestsPerWave"},message:"must have required property '"+"requestsPerWave"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.operationWeights === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "operationWeights"},message:"must have required property '"+"operationWeights"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.cacheLanesDigest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cacheLanesDigest"},message:"must have required property '"+"cacheLanesDigest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "digest")) || (key0 === "requestsPerWave")) || (key0 === "cacheLanesDigest")) || (key0 === "operationWeights"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
if("datahike-storage-million-v1" !== data.id){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/const",keyword:"const",params:{allowedValue: "datahike-storage-million-v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.digest !== undefined){
let data1 = data.digest;
if(typeof data1 === "string"){
if(!pattern29.test(data1)){
const err7 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/digest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.requestsPerWave !== undefined){
if(100 !== data.requestsPerWave){
const err9 = {instancePath:instancePath+"/requestsPerWave",schemaPath:"#/properties/requestsPerWave/const",keyword:"const",params:{allowedValue: 100},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.cacheLanesDigest !== undefined){
let data3 = data.cacheLanesDigest;
if(typeof data3 === "string"){
if(!pattern29.test(data3)){
const err10 = {instancePath:instancePath+"/cacheLanesDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/cacheLanesDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.operationWeights !== undefined){
let data4 = data.operationWeights;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.checkPermission === undefined){
const err12 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/required",keyword:"required",params:{missingProperty: "checkPermission"},message:"must have required property '"+"checkPermission"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data4.bootstrap === undefined){
const err13 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/required",keyword:"required",params:{missingProperty: "bootstrap"},message:"must have required property '"+"bootstrap"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data4.countObjects === undefined){
const err14 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/required",keyword:"required",params:{missingProperty: "countObjects"},message:"must have required property '"+"countObjects"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data4.getObject === undefined){
const err15 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/required",keyword:"required",params:{missingProperty: "getObject"},message:"must have required property '"+"getObject"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data4.getSchema === undefined){
const err16 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/required",keyword:"required",params:{missingProperty: "getSchema"},message:"must have required property '"+"getSchema"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data4.listRelationships === undefined){
const err17 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/required",keyword:"required",params:{missingProperty: "listRelationships"},message:"must have required property '"+"listRelationships"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data4.listSubjects === undefined){
const err18 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/required",keyword:"required",params:{missingProperty: "listSubjects"},message:"must have required property '"+"listSubjects"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data4.reverseRelationships === undefined){
const err19 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/required",keyword:"required",params:{missingProperty: "reverseRelationships"},message:"must have required property '"+"reverseRelationships"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
for(const key1 in data4){
if(!((((((((key1 === "checkPermission") || (key1 === "bootstrap")) || (key1 === "countObjects")) || (key1 === "getObject")) || (key1 === "getSchema")) || (key1 === "listRelationships")) || (key1 === "listSubjects")) || (key1 === "reverseRelationships"))){
const err20 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data4.checkPermission !== undefined){
if(40 !== data4.checkPermission){
const err21 = {instancePath:instancePath+"/operationWeights/checkPermission",schemaPath:"#/properties/operationWeights/properties/checkPermission/const",keyword:"const",params:{allowedValue: 40},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data4.bootstrap !== undefined){
if(5 !== data4.bootstrap){
const err22 = {instancePath:instancePath+"/operationWeights/bootstrap",schemaPath:"#/properties/operationWeights/properties/bootstrap/const",keyword:"const",params:{allowedValue: 5},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data4.countObjects !== undefined){
if(10 !== data4.countObjects){
const err23 = {instancePath:instancePath+"/operationWeights/countObjects",schemaPath:"#/properties/operationWeights/properties/countObjects/const",keyword:"const",params:{allowedValue: 10},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data4.getObject !== undefined){
if(10 !== data4.getObject){
const err24 = {instancePath:instancePath+"/operationWeights/getObject",schemaPath:"#/properties/operationWeights/properties/getObject/const",keyword:"const",params:{allowedValue: 10},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data4.getSchema !== undefined){
if(5 !== data4.getSchema){
const err25 = {instancePath:instancePath+"/operationWeights/getSchema",schemaPath:"#/properties/operationWeights/properties/getSchema/const",keyword:"const",params:{allowedValue: 5},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data4.listRelationships !== undefined){
if(15 !== data4.listRelationships){
const err26 = {instancePath:instancePath+"/operationWeights/listRelationships",schemaPath:"#/properties/operationWeights/properties/listRelationships/const",keyword:"const",params:{allowedValue: 15},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data4.listSubjects !== undefined){
if(5 !== data4.listSubjects){
const err27 = {instancePath:instancePath+"/operationWeights/listSubjects",schemaPath:"#/properties/operationWeights/properties/listSubjects/const",keyword:"const",params:{allowedValue: 5},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data4.reverseRelationships !== undefined){
if(10 !== data4.reverseRelationships){
const err28 = {instancePath:instancePath+"/operationWeights/reverseRelationships",schemaPath:"#/properties/operationWeights/properties/reverseRelationships/const",keyword:"const",params:{allowedValue: 10},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
else {
const err29 = {instancePath:instancePath+"/operationWeights",schemaPath:"#/properties/operationWeights/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
validate81.errors = vErrors;
return errors === 0;
}
validate81.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema120 = {"type":"object","additionalProperties":false,"required":["profileId","storage","demoSha","eaclSha","artifactDigest","deploymentId","serviceCodeDigest","dataLifecycleId","dataManifestDigest","qualificationEvidenceId","qualificationExpiresAt","qualificationPassing","contractVersion","region","runtime","architecture","memoryMb","snapStart","timeoutSeconds","ephemeralStorageMiB","workloadDigest","cacheLanesDigest"],"properties":{"profileId":{"enum":["datahike-s3","datahike-dynamodb"]},"storage":{"enum":["s3","dynamodb"]},"demoSha":{"$ref":"#/$defs/sha1"},"eaclSha":{"$ref":"#/$defs/sha1"},"artifactDigest":{"$ref":"#/$defs/digest"},"deploymentId":{"type":"string","minLength":1,"maxLength":256},"serviceCodeDigest":{"$ref":"#/$defs/digest"},"dataLifecycleId":{"type":"string","minLength":1,"maxLength":256},"dataManifestDigest":{"$ref":"#/$defs/digest"},"qualificationEvidenceId":{"$ref":"#/$defs/digest"},"qualificationExpiresAt":{"type":"string","format":"date-time"},"qualificationPassing":{"const":true},"contractVersion":{"const":"explorer.v1"},"region":{"const":"us-east-1"},"runtime":{"const":"java25"},"architecture":{"const":"arm64"},"memoryMb":{"type":"integer","minimum":1},"snapStart":{"enum":["None","PublishedVersions"]},"timeoutSeconds":{"type":"integer","minimum":1},"ephemeralStorageMiB":{"type":"integer","minimum":1},"workloadDigest":{"$ref":"#/$defs/digest"},"cacheLanesDigest":{"$ref":"#/$defs/digest"}}};
const schema121 = {"type":"string","pattern":"^[0-9a-f]{40}$"};

function validate83(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate83.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.profileId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profileId"},message:"must have required property '"+"profileId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.storage === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "storage"},message:"must have required property '"+"storage"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.demoSha === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "demoSha"},message:"must have required property '"+"demoSha"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.eaclSha === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "eaclSha"},message:"must have required property '"+"eaclSha"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.artifactDigest === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifactDigest"},message:"must have required property '"+"artifactDigest"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.deploymentId === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "deploymentId"},message:"must have required property '"+"deploymentId"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.serviceCodeDigest === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "serviceCodeDigest"},message:"must have required property '"+"serviceCodeDigest"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.dataLifecycleId === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dataLifecycleId"},message:"must have required property '"+"dataLifecycleId"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.dataManifestDigest === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dataManifestDigest"},message:"must have required property '"+"dataManifestDigest"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.qualificationEvidenceId === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "qualificationEvidenceId"},message:"must have required property '"+"qualificationEvidenceId"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.qualificationExpiresAt === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "qualificationExpiresAt"},message:"must have required property '"+"qualificationExpiresAt"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.qualificationPassing === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "qualificationPassing"},message:"must have required property '"+"qualificationPassing"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.contractVersion === undefined){
const err12 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contractVersion"},message:"must have required property '"+"contractVersion"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.region === undefined){
const err13 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "region"},message:"must have required property '"+"region"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data.runtime === undefined){
const err14 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "runtime"},message:"must have required property '"+"runtime"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(data.architecture === undefined){
const err15 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "architecture"},message:"must have required property '"+"architecture"+"'"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data.memoryMb === undefined){
const err16 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "memoryMb"},message:"must have required property '"+"memoryMb"+"'"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data.snapStart === undefined){
const err17 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "snapStart"},message:"must have required property '"+"snapStart"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data.timeoutSeconds === undefined){
const err18 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "timeoutSeconds"},message:"must have required property '"+"timeoutSeconds"+"'"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data.ephemeralStorageMiB === undefined){
const err19 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ephemeralStorageMiB"},message:"must have required property '"+"ephemeralStorageMiB"+"'"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data.workloadDigest === undefined){
const err20 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "workloadDigest"},message:"must have required property '"+"workloadDigest"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data.cacheLanesDigest === undefined){
const err21 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cacheLanesDigest"},message:"must have required property '"+"cacheLanesDigest"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
for(const key0 in data){
if(!(func89.call(schema120.properties, key0))){
const err22 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.profileId !== undefined){
let data0 = data.profileId;
if(!((data0 === "datahike-s3") || (data0 === "datahike-dynamodb"))){
const err23 = {instancePath:instancePath+"/profileId",schemaPath:"#/properties/profileId/enum",keyword:"enum",params:{allowedValues: schema120.properties.profileId.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.storage !== undefined){
let data1 = data.storage;
if(!((data1 === "s3") || (data1 === "dynamodb"))){
const err24 = {instancePath:instancePath+"/storage",schemaPath:"#/properties/storage/enum",keyword:"enum",params:{allowedValues: schema120.properties.storage.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.demoSha !== undefined){
let data2 = data.demoSha;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err25 = {instancePath:instancePath+"/demoSha",schemaPath:"#/$defs/sha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
else {
const err26 = {instancePath:instancePath+"/demoSha",schemaPath:"#/$defs/sha1/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.eaclSha !== undefined){
let data3 = data.eaclSha;
if(typeof data3 === "string"){
if(!pattern5.test(data3)){
const err27 = {instancePath:instancePath+"/eaclSha",schemaPath:"#/$defs/sha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
else {
const err28 = {instancePath:instancePath+"/eaclSha",schemaPath:"#/$defs/sha1/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.artifactDigest !== undefined){
let data4 = data.artifactDigest;
if(typeof data4 === "string"){
if(!pattern29.test(data4)){
const err29 = {instancePath:instancePath+"/artifactDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/artifactDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.deploymentId !== undefined){
let data5 = data.deploymentId;
if(typeof data5 === "string"){
if(func1(data5) > 256){
const err31 = {instancePath:instancePath+"/deploymentId",schemaPath:"#/properties/deploymentId/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(func1(data5) < 1){
const err32 = {instancePath:instancePath+"/deploymentId",schemaPath:"#/properties/deploymentId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/deploymentId",schemaPath:"#/properties/deploymentId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.serviceCodeDigest !== undefined){
let data6 = data.serviceCodeDigest;
if(typeof data6 === "string"){
if(!pattern29.test(data6)){
const err34 = {instancePath:instancePath+"/serviceCodeDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/serviceCodeDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.dataLifecycleId !== undefined){
let data7 = data.dataLifecycleId;
if(typeof data7 === "string"){
if(func1(data7) > 256){
const err36 = {instancePath:instancePath+"/dataLifecycleId",schemaPath:"#/properties/dataLifecycleId/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(func1(data7) < 1){
const err37 = {instancePath:instancePath+"/dataLifecycleId",schemaPath:"#/properties/dataLifecycleId/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
else {
const err38 = {instancePath:instancePath+"/dataLifecycleId",schemaPath:"#/properties/dataLifecycleId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.dataManifestDigest !== undefined){
let data8 = data.dataManifestDigest;
if(typeof data8 === "string"){
if(!pattern29.test(data8)){
const err39 = {instancePath:instancePath+"/dataManifestDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
else {
const err40 = {instancePath:instancePath+"/dataManifestDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data.qualificationEvidenceId !== undefined){
let data9 = data.qualificationEvidenceId;
if(typeof data9 === "string"){
if(!pattern29.test(data9)){
const err41 = {instancePath:instancePath+"/qualificationEvidenceId",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
else {
const err42 = {instancePath:instancePath+"/qualificationEvidenceId",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data.qualificationExpiresAt !== undefined){
let data10 = data.qualificationExpiresAt;
if(typeof data10 === "string"){
if(!(formats0.validate(data10))){
const err43 = {instancePath:instancePath+"/qualificationExpiresAt",schemaPath:"#/properties/qualificationExpiresAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
else {
const err44 = {instancePath:instancePath+"/qualificationExpiresAt",schemaPath:"#/properties/qualificationExpiresAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
if(data.qualificationPassing !== undefined){
if(true !== data.qualificationPassing){
const err45 = {instancePath:instancePath+"/qualificationPassing",schemaPath:"#/properties/qualificationPassing/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data.contractVersion !== undefined){
if("explorer.v1" !== data.contractVersion){
const err46 = {instancePath:instancePath+"/contractVersion",schemaPath:"#/properties/contractVersion/const",keyword:"const",params:{allowedValue: "explorer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data.region !== undefined){
if("us-east-1" !== data.region){
const err47 = {instancePath:instancePath+"/region",schemaPath:"#/properties/region/const",keyword:"const",params:{allowedValue: "us-east-1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data.runtime !== undefined){
if("java25" !== data.runtime){
const err48 = {instancePath:instancePath+"/runtime",schemaPath:"#/properties/runtime/const",keyword:"const",params:{allowedValue: "java25"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data.architecture !== undefined){
if("arm64" !== data.architecture){
const err49 = {instancePath:instancePath+"/architecture",schemaPath:"#/properties/architecture/const",keyword:"const",params:{allowedValue: "arm64"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data.memoryMb !== undefined){
let data16 = data.memoryMb;
if(!(((typeof data16 == "number") && (!(data16 % 1) && !isNaN(data16))) && (isFinite(data16)))){
const err50 = {instancePath:instancePath+"/memoryMb",schemaPath:"#/properties/memoryMb/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
if((typeof data16 == "number") && (isFinite(data16))){
if(data16 < 1 || isNaN(data16)){
const err51 = {instancePath:instancePath+"/memoryMb",schemaPath:"#/properties/memoryMb/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
}
if(data.snapStart !== undefined){
let data17 = data.snapStart;
if(!((data17 === "None") || (data17 === "PublishedVersions"))){
const err52 = {instancePath:instancePath+"/snapStart",schemaPath:"#/properties/snapStart/enum",keyword:"enum",params:{allowedValues: schema120.properties.snapStart.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
if(data.timeoutSeconds !== undefined){
let data18 = data.timeoutSeconds;
if(!(((typeof data18 == "number") && (!(data18 % 1) && !isNaN(data18))) && (isFinite(data18)))){
const err53 = {instancePath:instancePath+"/timeoutSeconds",schemaPath:"#/properties/timeoutSeconds/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
if((typeof data18 == "number") && (isFinite(data18))){
if(data18 < 1 || isNaN(data18)){
const err54 = {instancePath:instancePath+"/timeoutSeconds",schemaPath:"#/properties/timeoutSeconds/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
}
if(data.ephemeralStorageMiB !== undefined){
let data19 = data.ephemeralStorageMiB;
if(!(((typeof data19 == "number") && (!(data19 % 1) && !isNaN(data19))) && (isFinite(data19)))){
const err55 = {instancePath:instancePath+"/ephemeralStorageMiB",schemaPath:"#/properties/ephemeralStorageMiB/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
if((typeof data19 == "number") && (isFinite(data19))){
if(data19 < 1 || isNaN(data19)){
const err56 = {instancePath:instancePath+"/ephemeralStorageMiB",schemaPath:"#/properties/ephemeralStorageMiB/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
}
if(data.workloadDigest !== undefined){
let data20 = data.workloadDigest;
if(typeof data20 === "string"){
if(!pattern29.test(data20)){
const err57 = {instancePath:instancePath+"/workloadDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
else {
const err58 = {instancePath:instancePath+"/workloadDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
if(data.cacheLanesDigest !== undefined){
let data21 = data.cacheLanesDigest;
if(typeof data21 === "string"){
if(!pattern29.test(data21)){
const err59 = {instancePath:instancePath+"/cacheLanesDigest",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
}
else {
const err60 = {instancePath:instancePath+"/cacheLanesDigest",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
}
else {
const err61 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
validate83.errors = vErrors;
return errors === 0;
}
validate83.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema129 = {"type":"object","additionalProperties":false,"required":["profileId","warmWeightedP95Ms","coldOrRestoreP95Ms","warmP95Ci95Ms","coldP95Ci95Ms","errorRate","projectedMonthlyUsd","warmSamples","coldSamples"],"properties":{"profileId":{"enum":["datahike-s3","datahike-dynamodb"]},"warmWeightedP95Ms":{"type":"number","minimum":0},"coldOrRestoreP95Ms":{"type":"number","minimum":0},"warmP95Ci95Ms":{"$ref":"#/$defs/interval"},"coldP95Ci95Ms":{"$ref":"#/$defs/interval"},"errorRate":{"const":0},"projectedMonthlyUsd":{"type":"number","minimum":0},"warmSamples":{"type":"integer","minimum":6000},"coldSamples":{"type":"integer","minimum":30}}};
const schema130 = {"type":"array","minItems":2,"maxItems":2,"items":{"type":"number","minimum":0}};

function validate85(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate85.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.profileId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profileId"},message:"must have required property '"+"profileId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.warmWeightedP95Ms === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "warmWeightedP95Ms"},message:"must have required property '"+"warmWeightedP95Ms"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.coldOrRestoreP95Ms === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "coldOrRestoreP95Ms"},message:"must have required property '"+"coldOrRestoreP95Ms"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.warmP95Ci95Ms === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "warmP95Ci95Ms"},message:"must have required property '"+"warmP95Ci95Ms"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.coldP95Ci95Ms === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "coldP95Ci95Ms"},message:"must have required property '"+"coldP95Ci95Ms"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.errorRate === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "errorRate"},message:"must have required property '"+"errorRate"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.projectedMonthlyUsd === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "projectedMonthlyUsd"},message:"must have required property '"+"projectedMonthlyUsd"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.warmSamples === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "warmSamples"},message:"must have required property '"+"warmSamples"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.coldSamples === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "coldSamples"},message:"must have required property '"+"coldSamples"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func89.call(schema129.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.profileId !== undefined){
let data0 = data.profileId;
if(!((data0 === "datahike-s3") || (data0 === "datahike-dynamodb"))){
const err10 = {instancePath:instancePath+"/profileId",schemaPath:"#/properties/profileId/enum",keyword:"enum",params:{allowedValues: schema129.properties.profileId.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.warmWeightedP95Ms !== undefined){
let data1 = data.warmWeightedP95Ms;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 < 0 || isNaN(data1)){
const err11 = {instancePath:instancePath+"/warmWeightedP95Ms",schemaPath:"#/properties/warmWeightedP95Ms/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/warmWeightedP95Ms",schemaPath:"#/properties/warmWeightedP95Ms/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.coldOrRestoreP95Ms !== undefined){
let data2 = data.coldOrRestoreP95Ms;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 < 0 || isNaN(data2)){
const err13 = {instancePath:instancePath+"/coldOrRestoreP95Ms",schemaPath:"#/properties/coldOrRestoreP95Ms/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/coldOrRestoreP95Ms",schemaPath:"#/properties/coldOrRestoreP95Ms/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.warmP95Ci95Ms !== undefined){
let data3 = data.warmP95Ci95Ms;
if(Array.isArray(data3)){
if(data3.length > 2){
const err15 = {instancePath:instancePath+"/warmP95Ci95Ms",schemaPath:"#/$defs/interval/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data3.length < 2){
const err16 = {instancePath:instancePath+"/warmP95Ci95Ms",schemaPath:"#/$defs/interval/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
const len0 = data3.length;
for(let i0=0; i0<len0; i0++){
let data4 = data3[i0];
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err17 = {instancePath:instancePath+"/warmP95Ci95Ms/" + i0,schemaPath:"#/$defs/interval/items/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/warmP95Ci95Ms/" + i0,schemaPath:"#/$defs/interval/items/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
else {
const err19 = {instancePath:instancePath+"/warmP95Ci95Ms",schemaPath:"#/$defs/interval/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.coldP95Ci95Ms !== undefined){
let data5 = data.coldP95Ci95Ms;
if(Array.isArray(data5)){
if(data5.length > 2){
const err20 = {instancePath:instancePath+"/coldP95Ci95Ms",schemaPath:"#/$defs/interval/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data5.length < 2){
const err21 = {instancePath:instancePath+"/coldP95Ci95Ms",schemaPath:"#/$defs/interval/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
const len1 = data5.length;
for(let i1=0; i1<len1; i1++){
let data6 = data5[i1];
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 < 0 || isNaN(data6)){
const err22 = {instancePath:instancePath+"/coldP95Ci95Ms/" + i1,schemaPath:"#/$defs/interval/items/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/coldP95Ci95Ms/" + i1,schemaPath:"#/$defs/interval/items/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
else {
const err24 = {instancePath:instancePath+"/coldP95Ci95Ms",schemaPath:"#/$defs/interval/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.errorRate !== undefined){
if(0 !== data.errorRate){
const err25 = {instancePath:instancePath+"/errorRate",schemaPath:"#/properties/errorRate/const",keyword:"const",params:{allowedValue: 0},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.projectedMonthlyUsd !== undefined){
let data8 = data.projectedMonthlyUsd;
if((typeof data8 == "number") && (isFinite(data8))){
if(data8 < 0 || isNaN(data8)){
const err26 = {instancePath:instancePath+"/projectedMonthlyUsd",schemaPath:"#/properties/projectedMonthlyUsd/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/projectedMonthlyUsd",schemaPath:"#/properties/projectedMonthlyUsd/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.warmSamples !== undefined){
let data9 = data.warmSamples;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err28 = {instancePath:instancePath+"/warmSamples",schemaPath:"#/properties/warmSamples/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 < 6000 || isNaN(data9)){
const err29 = {instancePath:instancePath+"/warmSamples",schemaPath:"#/properties/warmSamples/minimum",keyword:"minimum",params:{comparison: ">=", limit: 6000},message:"must be >= 6000"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
if(data.coldSamples !== undefined){
let data10 = data.coldSamples;
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err30 = {instancePath:instancePath+"/coldSamples",schemaPath:"#/properties/coldSamples/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if((typeof data10 == "number") && (isFinite(data10))){
if(data10 < 30 || isNaN(data10)){
const err31 = {instancePath:instancePath+"/coldSamples",schemaPath:"#/properties/coldSamples/minimum",keyword:"minimum",params:{comparison: ">=", limit: 30},message:"must be >= 30"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
}
else {
const err32 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
validate85.errors = vErrors;
return errors === 0;
}
validate85.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate78(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/fastest-storage-evidence.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate78.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.evidenceId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "evidenceId"},message:"must have required property '"+"evidenceId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.methodVersion === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "methodVersion"},message:"must have required property '"+"methodVersion"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.backend === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "backend"},message:"must have required property '"+"backend"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.profiles === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profiles"},message:"must have required property '"+"profiles"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.fixture === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fixture"},message:"must have required property '"+"fixture"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.workload === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "workload"},message:"must have required property '"+"workload"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.environment === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.repetitions === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "repetitions"},message:"must have required property '"+"repetitions"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.measuredAt === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "measuredAt"},message:"must have required property '"+"measuredAt"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.expiresAt === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expiresAt"},message:"must have required property '"+"expiresAt"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.candidates === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "candidates"},message:"must have required property '"+"candidates"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.results === undefined){
const err12 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "results"},message:"must have required property '"+"results"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.decision === undefined){
const err13 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "decision"},message:"must have required property '"+"decision"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
for(const key0 in data){
if(!(func89.call(schema109.properties, key0))){
const err14 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.schema !== undefined){
if("eacl-demo.fastest-storage-evidence.v1" !== data.schema){
const err15 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/const",keyword:"const",params:{allowedValue: "eacl-demo.fastest-storage-evidence.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.evidenceId !== undefined){
let data1 = data.evidenceId;
if(typeof data1 === "string"){
if(!pattern29.test(data1)){
const err16 = {instancePath:instancePath+"/evidenceId",schemaPath:"#/$defs/digest/pattern",keyword:"pattern",params:{pattern: "^sha256:[0-9a-f]{64}$"},message:"must match pattern \""+"^sha256:[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/evidenceId",schemaPath:"#/$defs/digest/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.methodVersion !== undefined){
if("datahike-storage-million.v1" !== data.methodVersion){
const err18 = {instancePath:instancePath+"/methodVersion",schemaPath:"#/properties/methodVersion/const",keyword:"const",params:{allowedValue: "datahike-storage-million.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.backend !== undefined){
if("datahike" !== data.backend){
const err19 = {instancePath:instancePath+"/backend",schemaPath:"#/properties/backend/const",keyword:"const",params:{allowedValue: "datahike"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.profiles !== undefined){
if(!func0(data.profiles, schema109.properties.profiles.const)){
const err20 = {instancePath:instancePath+"/profiles",schemaPath:"#/properties/profiles/const",keyword:"const",params:{allowedValue: schema109.properties.profiles.const},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.fixture !== undefined){
if(!(validate79(data.fixture, {instancePath:instancePath+"/fixture",parentData:data,parentDataProperty:"fixture",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate79.errors : vErrors.concat(validate79.errors);
errors = vErrors.length;
}
}
if(data.workload !== undefined){
if(!(validate81(data.workload, {instancePath:instancePath+"/workload",parentData:data,parentDataProperty:"workload",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate81.errors : vErrors.concat(validate81.errors);
errors = vErrors.length;
}
}
if(data.environment !== undefined){
let data7 = data.environment;
if(data7 && typeof data7 == "object" && !Array.isArray(data7)){
if(data7.region === undefined){
const err21 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/required",keyword:"required",params:{missingProperty: "region"},message:"must have required property '"+"region"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data7.runtime === undefined){
const err22 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/required",keyword:"required",params:{missingProperty: "runtime"},message:"must have required property '"+"runtime"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data7.architecture === undefined){
const err23 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/required",keyword:"required",params:{missingProperty: "architecture"},message:"must have required property '"+"architecture"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data7.memoryMb === undefined){
const err24 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/required",keyword:"required",params:{missingProperty: "memoryMb"},message:"must have required property '"+"memoryMb"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data7.snapStart === undefined){
const err25 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/required",keyword:"required",params:{missingProperty: "snapStart"},message:"must have required property '"+"snapStart"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data7.timeoutSeconds === undefined){
const err26 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/required",keyword:"required",params:{missingProperty: "timeoutSeconds"},message:"must have required property '"+"timeoutSeconds"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data7.ephemeralStorageMiB === undefined){
const err27 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/required",keyword:"required",params:{missingProperty: "ephemeralStorageMiB"},message:"must have required property '"+"ephemeralStorageMiB"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data7.productionPath === undefined){
const err28 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/required",keyword:"required",params:{missingProperty: "productionPath"},message:"must have required property '"+"productionPath"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
for(const key1 in data7){
if(!((((((((key1 === "region") || (key1 === "runtime")) || (key1 === "architecture")) || (key1 === "memoryMb")) || (key1 === "snapStart")) || (key1 === "timeoutSeconds")) || (key1 === "ephemeralStorageMiB")) || (key1 === "productionPath"))){
const err29 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data7.region !== undefined){
if("us-east-1" !== data7.region){
const err30 = {instancePath:instancePath+"/environment/region",schemaPath:"#/$defs/environment/properties/region/const",keyword:"const",params:{allowedValue: "us-east-1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data7.runtime !== undefined){
if("java25" !== data7.runtime){
const err31 = {instancePath:instancePath+"/environment/runtime",schemaPath:"#/$defs/environment/properties/runtime/const",keyword:"const",params:{allowedValue: "java25"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data7.architecture !== undefined){
if("arm64" !== data7.architecture){
const err32 = {instancePath:instancePath+"/environment/architecture",schemaPath:"#/$defs/environment/properties/architecture/const",keyword:"const",params:{allowedValue: "arm64"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data7.memoryMb !== undefined){
let data11 = data7.memoryMb;
if(!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))){
const err33 = {instancePath:instancePath+"/environment/memoryMb",schemaPath:"#/$defs/environment/properties/memoryMb/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if((typeof data11 == "number") && (isFinite(data11))){
if(data11 < 1 || isNaN(data11)){
const err34 = {instancePath:instancePath+"/environment/memoryMb",schemaPath:"#/$defs/environment/properties/memoryMb/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
if(data7.snapStart !== undefined){
let data12 = data7.snapStart;
if(!((data12 === "None") || (data12 === "PublishedVersions"))){
const err35 = {instancePath:instancePath+"/environment/snapStart",schemaPath:"#/$defs/environment/properties/snapStart/enum",keyword:"enum",params:{allowedValues: schema118.properties.snapStart.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data7.timeoutSeconds !== undefined){
let data13 = data7.timeoutSeconds;
if(!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))){
const err36 = {instancePath:instancePath+"/environment/timeoutSeconds",schemaPath:"#/$defs/environment/properties/timeoutSeconds/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 < 1 || isNaN(data13)){
const err37 = {instancePath:instancePath+"/environment/timeoutSeconds",schemaPath:"#/$defs/environment/properties/timeoutSeconds/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
if(data7.ephemeralStorageMiB !== undefined){
let data14 = data7.ephemeralStorageMiB;
if(!(((typeof data14 == "number") && (!(data14 % 1) && !isNaN(data14))) && (isFinite(data14)))){
const err38 = {instancePath:instancePath+"/environment/ephemeralStorageMiB",schemaPath:"#/$defs/environment/properties/ephemeralStorageMiB/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if((typeof data14 == "number") && (isFinite(data14))){
if(data14 < 1 || isNaN(data14)){
const err39 = {instancePath:instancePath+"/environment/ephemeralStorageMiB",schemaPath:"#/$defs/environment/properties/ephemeralStorageMiB/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
if(data7.productionPath !== undefined){
if("function-url-v2" !== data7.productionPath){
const err40 = {instancePath:instancePath+"/environment/productionPath",schemaPath:"#/$defs/environment/properties/productionPath/const",keyword:"const",params:{allowedValue: "function-url-v2"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
}
else {
const err41 = {instancePath:instancePath+"/environment",schemaPath:"#/$defs/environment/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data.repetitions !== undefined){
let data16 = data.repetitions;
if(data16 && typeof data16 == "object" && !Array.isArray(data16)){
if(data16.coldOrRestore === undefined){
const err42 = {instancePath:instancePath+"/repetitions",schemaPath:"#/$defs/repetitions/required",keyword:"required",params:{missingProperty: "coldOrRestore"},message:"must have required property '"+"coldOrRestore"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data16.warmWavesPerLane === undefined){
const err43 = {instancePath:instancePath+"/repetitions",schemaPath:"#/$defs/repetitions/required",keyword:"required",params:{missingProperty: "warmWavesPerLane"},message:"must have required property '"+"warmWavesPerLane"+"'"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if(data16.concurrency === undefined){
const err44 = {instancePath:instancePath+"/repetitions",schemaPath:"#/$defs/repetitions/required",keyword:"required",params:{missingProperty: "concurrency"},message:"must have required property '"+"concurrency"+"'"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if(data16.bootstrapResamples === undefined){
const err45 = {instancePath:instancePath+"/repetitions",schemaPath:"#/$defs/repetitions/required",keyword:"required",params:{missingProperty: "bootstrapResamples"},message:"must have required property '"+"bootstrapResamples"+"'"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
for(const key2 in data16){
if(!((((key2 === "coldOrRestore") || (key2 === "warmWavesPerLane")) || (key2 === "concurrency")) || (key2 === "bootstrapResamples"))){
const err46 = {instancePath:instancePath+"/repetitions",schemaPath:"#/$defs/repetitions/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data16.coldOrRestore !== undefined){
let data17 = data16.coldOrRestore;
if(!(((typeof data17 == "number") && (!(data17 % 1) && !isNaN(data17))) && (isFinite(data17)))){
const err47 = {instancePath:instancePath+"/repetitions/coldOrRestore",schemaPath:"#/$defs/repetitions/properties/coldOrRestore/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if((typeof data17 == "number") && (isFinite(data17))){
if(data17 < 30 || isNaN(data17)){
const err48 = {instancePath:instancePath+"/repetitions/coldOrRestore",schemaPath:"#/$defs/repetitions/properties/coldOrRestore/minimum",keyword:"minimum",params:{comparison: ">=", limit: 30},message:"must be >= 30"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
}
if(data16.warmWavesPerLane !== undefined){
let data18 = data16.warmWavesPerLane;
if(!(((typeof data18 == "number") && (!(data18 % 1) && !isNaN(data18))) && (isFinite(data18)))){
const err49 = {instancePath:instancePath+"/repetitions/warmWavesPerLane",schemaPath:"#/$defs/repetitions/properties/warmWavesPerLane/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
if((typeof data18 == "number") && (isFinite(data18))){
if(data18 < 30 || isNaN(data18)){
const err50 = {instancePath:instancePath+"/repetitions/warmWavesPerLane",schemaPath:"#/$defs/repetitions/properties/warmWavesPerLane/minimum",keyword:"minimum",params:{comparison: ">=", limit: 30},message:"must be >= 30"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
}
if(data16.concurrency !== undefined){
if(!func0(data16.concurrency, schema119.properties.concurrency.const)){
const err51 = {instancePath:instancePath+"/repetitions/concurrency",schemaPath:"#/$defs/repetitions/properties/concurrency/const",keyword:"const",params:{allowedValue: schema119.properties.concurrency.const},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data16.bootstrapResamples !== undefined){
if(10000 !== data16.bootstrapResamples){
const err52 = {instancePath:instancePath+"/repetitions/bootstrapResamples",schemaPath:"#/$defs/repetitions/properties/bootstrapResamples/const",keyword:"const",params:{allowedValue: 10000},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
}
else {
const err53 = {instancePath:instancePath+"/repetitions",schemaPath:"#/$defs/repetitions/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
if(data.measuredAt !== undefined){
let data21 = data.measuredAt;
if(typeof data21 === "string"){
if(!(formats0.validate(data21))){
const err54 = {instancePath:instancePath+"/measuredAt",schemaPath:"#/properties/measuredAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
else {
const err55 = {instancePath:instancePath+"/measuredAt",schemaPath:"#/properties/measuredAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
if(data.expiresAt !== undefined){
let data22 = data.expiresAt;
if(typeof data22 === "string"){
if(!(formats0.validate(data22))){
const err56 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/properties/expiresAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
else {
const err57 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/properties/expiresAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
if(data.candidates !== undefined){
let data23 = data.candidates;
if(Array.isArray(data23)){
if(data23.length > 2){
const err58 = {instancePath:instancePath+"/candidates",schemaPath:"#/properties/candidates/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
if(data23.length < 2){
const err59 = {instancePath:instancePath+"/candidates",schemaPath:"#/properties/candidates/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
const len0 = data23.length;
for(let i0=0; i0<len0; i0++){
if(!(validate83(data23[i0], {instancePath:instancePath+"/candidates/" + i0,parentData:data23,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate83.errors : vErrors.concat(validate83.errors);
errors = vErrors.length;
}
}
}
else {
const err60 = {instancePath:instancePath+"/candidates",schemaPath:"#/properties/candidates/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
if(data.results !== undefined){
let data25 = data.results;
if(Array.isArray(data25)){
if(data25.length > 2){
const err61 = {instancePath:instancePath+"/results",schemaPath:"#/properties/results/maxItems",keyword:"maxItems",params:{limit: 2},message:"must NOT have more than 2 items"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
if(data25.length < 2){
const err62 = {instancePath:instancePath+"/results",schemaPath:"#/properties/results/minItems",keyword:"minItems",params:{limit: 2},message:"must NOT have fewer than 2 items"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
const len1 = data25.length;
for(let i1=0; i1<len1; i1++){
if(!(validate85(data25[i1], {instancePath:instancePath+"/results/" + i1,parentData:data25,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate85.errors : vErrors.concat(validate85.errors);
errors = vErrors.length;
}
}
}
else {
const err63 = {instancePath:instancePath+"/results",schemaPath:"#/properties/results/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
if(data.decision !== undefined){
let data27 = data.decision;
if(data27 && typeof data27 == "object" && !Array.isArray(data27)){
if(data27.outcome === undefined){
const err64 = {instancePath:instancePath+"/decision",schemaPath:"#/$defs/decision/required",keyword:"required",params:{missingProperty: "outcome"},message:"must have required property '"+"outcome"+"'"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
if(data27.defaultProfileId === undefined){
const err65 = {instancePath:instancePath+"/decision",schemaPath:"#/$defs/decision/required",keyword:"required",params:{missingProperty: "defaultProfileId"},message:"must have required property '"+"defaultProfileId"+"'"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
if(data27.selectionBasis === undefined){
const err66 = {instancePath:instancePath+"/decision",schemaPath:"#/$defs/decision/required",keyword:"required",params:{missingProperty: "selectionBasis"},message:"must have required property '"+"selectionBasis"+"'"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
if(data27.primaryMetric === undefined){
const err67 = {instancePath:instancePath+"/decision",schemaPath:"#/$defs/decision/required",keyword:"required",params:{missingProperty: "primaryMetric"},message:"must have required property '"+"primaryMetric"+"'"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
if(data27.minimumEffectFraction === undefined){
const err68 = {instancePath:instancePath+"/decision",schemaPath:"#/$defs/decision/required",keyword:"required",params:{missingProperty: "minimumEffectFraction"},message:"must have required property '"+"minimumEffectFraction"+"'"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
if(data27.tieBreakOrder === undefined){
const err69 = {instancePath:instancePath+"/decision",schemaPath:"#/$defs/decision/required",keyword:"required",params:{missingProperty: "tieBreakOrder"},message:"must have required property '"+"tieBreakOrder"+"'"};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
for(const key3 in data27){
if(!((((((key3 === "outcome") || (key3 === "defaultProfileId")) || (key3 === "selectionBasis")) || (key3 === "primaryMetric")) || (key3 === "minimumEffectFraction")) || (key3 === "tieBreakOrder"))){
const err70 = {instancePath:instancePath+"/decision",schemaPath:"#/$defs/decision/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
if(data27.outcome !== undefined){
let data28 = data27.outcome;
if(!(((data28 === "winner") || (data28 === "benchmark-tiebreak")) || (data28 === "unresolved"))){
const err71 = {instancePath:instancePath+"/decision/outcome",schemaPath:"#/$defs/decision/properties/outcome/enum",keyword:"enum",params:{allowedValues: schema132.properties.outcome.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
}
if(data27.defaultProfileId !== undefined){
let data29 = data27.defaultProfileId;
if(!(((data29 === "datahike-s3") || (data29 === "datahike-dynamodb")) || (data29 === null))){
const err72 = {instancePath:instancePath+"/decision/defaultProfileId",schemaPath:"#/$defs/decision/properties/defaultProfileId/enum",keyword:"enum",params:{allowedValues: schema132.properties.defaultProfileId.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
if(data27.selectionBasis !== undefined){
let data30 = data27.selectionBasis;
if(!((((data30 === "warm-cache-disabled-p95") || (data30 === "cold-or-restore-p95")) || (data30 === "projected-monthly-cost")) || (data30 === "none"))){
const err73 = {instancePath:instancePath+"/decision/selectionBasis",schemaPath:"#/$defs/decision/properties/selectionBasis/enum",keyword:"enum",params:{allowedValues: schema132.properties.selectionBasis.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
if(data27.primaryMetric !== undefined){
if("operation-weighted-warm-cache-disabled-service-p95-ms" !== data27.primaryMetric){
const err74 = {instancePath:instancePath+"/decision/primaryMetric",schemaPath:"#/$defs/decision/properties/primaryMetric/const",keyword:"const",params:{allowedValue: "operation-weighted-warm-cache-disabled-service-p95-ms"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
if(data27.minimumEffectFraction !== undefined){
if(0.05 !== data27.minimumEffectFraction){
const err75 = {instancePath:instancePath+"/decision/minimumEffectFraction",schemaPath:"#/$defs/decision/properties/minimumEffectFraction/const",keyword:"const",params:{allowedValue: 0.05},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
}
if(data27.tieBreakOrder !== undefined){
if(!func0(data27.tieBreakOrder, schema132.properties.tieBreakOrder.const)){
const err76 = {instancePath:instancePath+"/decision/tieBreakOrder",schemaPath:"#/$defs/decision/properties/tieBreakOrder/const",keyword:"const",params:{allowedValue: schema132.properties.tieBreakOrder.const},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
}
}
else {
const err77 = {instancePath:instancePath+"/decision",schemaPath:"#/$defs/decision/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
}
}
else {
const err78 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
validate78.errors = vErrors;
return errors === 0;
}
validate78.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const release = validate87;
const schema133 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://demo.eacl.dev/schemas/release-manifest.v1.schema.json","title":"EACL demo release manifest v1","type":"object","additionalProperties":false,"required":["schema","contractVersion","source","fixture","deployment","artifacts"],"properties":{"schema":{"const":"eacl-demo.release-manifest.v1"},"contractVersion":{"const":"explorer.v1"},"source":{"type":"object","additionalProperties":false,"required":["demo","eacl"],"properties":{"demo":{"$ref":"#/$defs/source"},"eacl":{"$ref":"#/$defs/source"}}},"fixture":{"type":"object","additionalProperties":false,"required":["id","manifestSha256"],"properties":{"id":{"type":"string","pattern":"^[a-z0-9]+(?:[._-][a-z0-9]+)*$"},"manifestSha256":{"$ref":"#/$defs/sha256"}}},"deployment":{"type":"object","additionalProperties":false,"required":["provider","repositoryId","runId","runAttempt","ref","identity"],"properties":{"provider":{"const":"github-actions"},"repositoryId":{"const":"1345904214"},"runId":{"type":"string","pattern":"^[1-9][0-9]*$"},"runAttempt":{"type":"integer","minimum":1},"ref":{"const":"refs/heads/demos"},"identity":{"type":"string","pattern":"^1345904214:[1-9][0-9]*:[1-9][0-9]*:[0-9a-f]{40}$"}}},"artifacts":{"type":"array","minItems":1,"items":{"$ref":"artifact-digests.v1.schema.json#/$defs/artifact"}}},"$defs":{"sha1":{"type":"string","pattern":"^[0-9a-f]{40}$"},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"source":{"type":"object","additionalProperties":false,"required":["repository","sha"],"properties":{"repository":{"enum":["https://github.com/theronic/eacl-demo.git","https://github.com/theronic/eacl.git"]},"sha":{"$ref":"#/$defs/sha1"}}}}};
const schema136 = {"type":"string","pattern":"^[0-9a-f]{64}$"};
const schema138 = {"type":"object","additionalProperties":false,"required":["name","path","sha256","bytes"],"properties":{"name":{"type":"string","pattern":"^[a-z0-9]+(?:-[a-z0-9]+)*$"},"path":{"type":"string","pattern":"^dist/[a-z0-9-]+/artifact[.]json$"},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"bytes":{"type":"integer","minimum":1}}};
const schema134 = {"type":"object","additionalProperties":false,"required":["repository","sha"],"properties":{"repository":{"enum":["https://github.com/theronic/eacl-demo.git","https://github.com/theronic/eacl.git"]},"sha":{"$ref":"#/$defs/sha1"}}};
const schema135 = {"type":"string","pattern":"^[0-9a-f]{40}$"};

function validate88(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate88.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.repository === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "repository"},message:"must have required property '"+"repository"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sha === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sha"},message:"must have required property '"+"sha"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "repository") || (key0 === "sha"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.repository !== undefined){
let data0 = data.repository;
if(!((data0 === "https://github.com/theronic/eacl-demo.git") || (data0 === "https://github.com/theronic/eacl.git"))){
const err3 = {instancePath:instancePath+"/repository",schemaPath:"#/properties/repository/enum",keyword:"enum",params:{allowedValues: schema134.properties.repository.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.sha !== undefined){
let data1 = data.sha;
if(typeof data1 === "string"){
if(!pattern5.test(data1)){
const err4 = {instancePath:instancePath+"/sha",schemaPath:"#/$defs/sha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/sha",schemaPath:"#/$defs/sha1/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
else {
const err6 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
validate88.errors = vErrors;
return errors === 0;
}
validate88.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const pattern86 = new RegExp("^[1-9][0-9]*$", "u");
const pattern87 = new RegExp("^1345904214:[1-9][0-9]*:[1-9][0-9]*:[0-9a-f]{40}$", "u");
const pattern89 = new RegExp("^dist/[a-z0-9-]+/artifact[.]json$", "u");

function validate87(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://demo.eacl.dev/schemas/release-manifest.v1.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate87.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schema === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schema"},message:"must have required property '"+"schema"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.contractVersion === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contractVersion"},message:"must have required property '"+"contractVersion"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.source === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "source"},message:"must have required property '"+"source"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.fixture === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fixture"},message:"must have required property '"+"fixture"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.deployment === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "deployment"},message:"must have required property '"+"deployment"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.artifacts === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "artifacts"},message:"must have required property '"+"artifacts"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "schema") || (key0 === "contractVersion")) || (key0 === "source")) || (key0 === "fixture")) || (key0 === "deployment")) || (key0 === "artifacts"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.schema !== undefined){
if("eacl-demo.release-manifest.v1" !== data.schema){
const err7 = {instancePath:instancePath+"/schema",schemaPath:"#/properties/schema/const",keyword:"const",params:{allowedValue: "eacl-demo.release-manifest.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.contractVersion !== undefined){
if("explorer.v1" !== data.contractVersion){
const err8 = {instancePath:instancePath+"/contractVersion",schemaPath:"#/properties/contractVersion/const",keyword:"const",params:{allowedValue: "explorer.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.source !== undefined){
let data2 = data.source;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.demo === undefined){
const err9 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/required",keyword:"required",params:{missingProperty: "demo"},message:"must have required property '"+"demo"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2.eacl === undefined){
const err10 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/required",keyword:"required",params:{missingProperty: "eacl"},message:"must have required property '"+"eacl"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
for(const key1 in data2){
if(!((key1 === "demo") || (key1 === "eacl"))){
const err11 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data2.demo !== undefined){
if(!(validate88(data2.demo, {instancePath:instancePath+"/source/demo",parentData:data2,parentDataProperty:"demo",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate88.errors : vErrors.concat(validate88.errors);
errors = vErrors.length;
}
}
if(data2.eacl !== undefined){
if(!(validate88(data2.eacl, {instancePath:instancePath+"/source/eacl",parentData:data2,parentDataProperty:"eacl",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate88.errors : vErrors.concat(validate88.errors);
errors = vErrors.length;
}
}
}
else {
const err12 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.fixture !== undefined){
let data5 = data.fixture;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.id === undefined){
const err13 = {instancePath:instancePath+"/fixture",schemaPath:"#/properties/fixture/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data5.manifestSha256 === undefined){
const err14 = {instancePath:instancePath+"/fixture",schemaPath:"#/properties/fixture/required",keyword:"required",params:{missingProperty: "manifestSha256"},message:"must have required property '"+"manifestSha256"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
for(const key2 in data5){
if(!((key2 === "id") || (key2 === "manifestSha256"))){
const err15 = {instancePath:instancePath+"/fixture",schemaPath:"#/properties/fixture/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data5.id !== undefined){
let data6 = data5.id;
if(typeof data6 === "string"){
if(!pattern24.test(data6)){
const err16 = {instancePath:instancePath+"/fixture/id",schemaPath:"#/properties/fixture/properties/id/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:[._-][a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:[._-][a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/fixture/id",schemaPath:"#/properties/fixture/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data5.manifestSha256 !== undefined){
let data7 = data5.manifestSha256;
if(typeof data7 === "string"){
if(!pattern7.test(data7)){
const err18 = {instancePath:instancePath+"/fixture/manifestSha256",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/fixture/manifestSha256",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath:instancePath+"/fixture",schemaPath:"#/properties/fixture/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.deployment !== undefined){
let data8 = data.deployment;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.provider === undefined){
const err21 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/required",keyword:"required",params:{missingProperty: "provider"},message:"must have required property '"+"provider"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data8.repositoryId === undefined){
const err22 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/required",keyword:"required",params:{missingProperty: "repositoryId"},message:"must have required property '"+"repositoryId"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data8.runId === undefined){
const err23 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/required",keyword:"required",params:{missingProperty: "runId"},message:"must have required property '"+"runId"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data8.runAttempt === undefined){
const err24 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/required",keyword:"required",params:{missingProperty: "runAttempt"},message:"must have required property '"+"runAttempt"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data8.ref === undefined){
const err25 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/required",keyword:"required",params:{missingProperty: "ref"},message:"must have required property '"+"ref"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data8.identity === undefined){
const err26 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/required",keyword:"required",params:{missingProperty: "identity"},message:"must have required property '"+"identity"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
for(const key3 in data8){
if(!((((((key3 === "provider") || (key3 === "repositoryId")) || (key3 === "runId")) || (key3 === "runAttempt")) || (key3 === "ref")) || (key3 === "identity"))){
const err27 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data8.provider !== undefined){
if("github-actions" !== data8.provider){
const err28 = {instancePath:instancePath+"/deployment/provider",schemaPath:"#/properties/deployment/properties/provider/const",keyword:"const",params:{allowedValue: "github-actions"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data8.repositoryId !== undefined){
if("1345904214" !== data8.repositoryId){
const err29 = {instancePath:instancePath+"/deployment/repositoryId",schemaPath:"#/properties/deployment/properties/repositoryId/const",keyword:"const",params:{allowedValue: "1345904214"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data8.runId !== undefined){
let data11 = data8.runId;
if(typeof data11 === "string"){
if(!pattern86.test(data11)){
const err30 = {instancePath:instancePath+"/deployment/runId",schemaPath:"#/properties/deployment/properties/runId/pattern",keyword:"pattern",params:{pattern: "^[1-9][0-9]*$"},message:"must match pattern \""+"^[1-9][0-9]*$"+"\""};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
else {
const err31 = {instancePath:instancePath+"/deployment/runId",schemaPath:"#/properties/deployment/properties/runId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data8.runAttempt !== undefined){
let data12 = data8.runAttempt;
if(!(((typeof data12 == "number") && (!(data12 % 1) && !isNaN(data12))) && (isFinite(data12)))){
const err32 = {instancePath:instancePath+"/deployment/runAttempt",schemaPath:"#/properties/deployment/properties/runAttempt/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if((typeof data12 == "number") && (isFinite(data12))){
if(data12 < 1 || isNaN(data12)){
const err33 = {instancePath:instancePath+"/deployment/runAttempt",schemaPath:"#/properties/deployment/properties/runAttempt/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
if(data8.ref !== undefined){
if("refs/heads/demos" !== data8.ref){
const err34 = {instancePath:instancePath+"/deployment/ref",schemaPath:"#/properties/deployment/properties/ref/const",keyword:"const",params:{allowedValue: "refs/heads/demos"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data8.identity !== undefined){
let data14 = data8.identity;
if(typeof data14 === "string"){
if(!pattern87.test(data14)){
const err35 = {instancePath:instancePath+"/deployment/identity",schemaPath:"#/properties/deployment/properties/identity/pattern",keyword:"pattern",params:{pattern: "^1345904214:[1-9][0-9]*:[1-9][0-9]*:[0-9a-f]{40}$"},message:"must match pattern \""+"^1345904214:[1-9][0-9]*:[1-9][0-9]*:[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
else {
const err36 = {instancePath:instancePath+"/deployment/identity",schemaPath:"#/properties/deployment/properties/identity/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath:instancePath+"/deployment",schemaPath:"#/properties/deployment/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.artifacts !== undefined){
let data15 = data.artifacts;
if(Array.isArray(data15)){
if(data15.length < 1){
const err38 = {instancePath:instancePath+"/artifacts",schemaPath:"#/properties/artifacts/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
const len0 = data15.length;
for(let i0=0; i0<len0; i0++){
let data16 = data15[i0];
if(data16 && typeof data16 == "object" && !Array.isArray(data16)){
if(data16.name === undefined){
const err39 = {instancePath:instancePath+"/artifacts/" + i0,schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(data16.path === undefined){
const err40 = {instancePath:instancePath+"/artifacts/" + i0,schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
if(data16.sha256 === undefined){
const err41 = {instancePath:instancePath+"/artifacts/" + i0,schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data16.bytes === undefined){
const err42 = {instancePath:instancePath+"/artifacts/" + i0,schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/required",keyword:"required",params:{missingProperty: "bytes"},message:"must have required property '"+"bytes"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
for(const key4 in data16){
if(!((((key4 === "name") || (key4 === "path")) || (key4 === "sha256")) || (key4 === "bytes"))){
const err43 = {instancePath:instancePath+"/artifacts/" + i0,schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key4},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data16.name !== undefined){
let data17 = data16.name;
if(typeof data17 === "string"){
if(!pattern4.test(data17)){
const err44 = {instancePath:instancePath+"/artifacts/" + i0+"/name",schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/properties/name/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9]+(?:-[a-z0-9]+)*$"},message:"must match pattern \""+"^[a-z0-9]+(?:-[a-z0-9]+)*$"+"\""};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {instancePath:instancePath+"/artifacts/" + i0+"/name",schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data16.path !== undefined){
let data18 = data16.path;
if(typeof data18 === "string"){
if(!pattern89.test(data18)){
const err46 = {instancePath:instancePath+"/artifacts/" + i0+"/path",schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/properties/path/pattern",keyword:"pattern",params:{pattern: "^dist/[a-z0-9-]+/artifact[.]json$"},message:"must match pattern \""+"^dist/[a-z0-9-]+/artifact[.]json$"+"\""};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
else {
const err47 = {instancePath:instancePath+"/artifacts/" + i0+"/path",schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/properties/path/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data16.sha256 !== undefined){
let data19 = data16.sha256;
if(typeof data19 === "string"){
if(!pattern7.test(data19)){
const err48 = {instancePath:instancePath+"/artifacts/" + i0+"/sha256",schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/properties/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
else {
const err49 = {instancePath:instancePath+"/artifacts/" + i0+"/sha256",schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/properties/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data16.bytes !== undefined){
let data20 = data16.bytes;
if(!(((typeof data20 == "number") && (!(data20 % 1) && !isNaN(data20))) && (isFinite(data20)))){
const err50 = {instancePath:instancePath+"/artifacts/" + i0+"/bytes",schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/properties/bytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
if((typeof data20 == "number") && (isFinite(data20))){
if(data20 < 1 || isNaN(data20)){
const err51 = {instancePath:instancePath+"/artifacts/" + i0+"/bytes",schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/properties/bytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
}
}
else {
const err52 = {instancePath:instancePath+"/artifacts/" + i0,schemaPath:"artifact-digests.v1.schema.json#/$defs/artifact/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
}
else {
const err53 = {instancePath:instancePath+"/artifacts",schemaPath:"#/properties/artifacts/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
}
else {
const err54 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
validate87.errors = vErrors;
return errors === 0;
}
validate87.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

